import { QUAOM_DEFAULT_UI_LANGUAGE, type PublicI18nBundle } from '@quaom/contracts/i18n';

export type AccountMessageKey =
  | 'title'
  | 'eyebrow'
  | 'headline'
  | 'intro'
  | 'home'
  | 'login'
  | 'register'
  | 'recover'
  | 'texts'
  | 'saved'
  | 'recent'
  | 'reading'
  | 'translations'
  | 'bonus'
  | 'support'
  | 'security'
  | 'settings'
  | 'accountNotProfile'
  | 'loading'
  | 'empty'
  | 'error'
  | 'success'
  | 'submit'
  | 'save'
  | 'cancel'
  | 'delete'
  | 'close'
  | 'refresh'
  | 'password'
  | 'currentPassword'
  | 'newPassword'
  | 'pseudonym'
  | 'emailOptional'
  | 'recoveryKey'
  | 'copy'
  | 'download'
  | 'status'
  | 'language'
  | 'created'
  | 'updated'
  | 'published'
  | 'open'
  | 'manage'
  | 'remove'
  | 'clear'
  | 'enabled'
  | 'disabled'
  | 'interfaceLanguage'
  | 'theme'
  | 'notifications'
  | 'privacy'
  | 'data'
  | 'savedTextsIntro'
  | 'recentIntro'
  | 'readingIntro'
  | 'translationsIntro'
  | 'supportIntro'
  | 'securityIntro'
  | 'settingsIntro'
  | 'loginIntro'
  | 'registerIntro'
  | 'recoverIntro'
  | 'textsIntro'
  | 'noPublicProfile'
  | 'handleTaken'
  | 'pseudonymSuggestions'
  | 'pseudonymRules'
  | 'pseudonymLength'
  | 'pseudonymFormat'
  | 'pseudonymReserved'
  | 'pseudonymRequired'
  | 'securityHold'
  | 'logout'
  | 'logoutAll'
  | 'sessions'
  | 'devices'
  | 'createRecoveryKey'
  | 'recoveryKeyWarning'
  | 'recoveryKeyRotatedAfterRecovery'
  | 'replaceRecoveryKey'
  | 'changeEmail'
  | 'removeEmail'
  | 'exportData'
  | 'deleteAccount'
  | 'settingsTabLanguage'
  | 'settingsTabTheme'
  | 'settingsTabDeletion'
  | 'autoDeleteAccount'
  | 'autoDeleteCheckboxRequired'
  | 'saveAutoDelete'
  | 'confirmChange'
  | 'deleteNow'
  | 'deleteNowIntro'
  | 'confirmDeleteAccount'
  | 'pseudonymConfirmation'
  | 'deletionSettingsSaved'
  | 'accountDeleted'
  | 'accountDeleteConfirmationMismatch'
  | 'addByLink'
  | 'claimText'
  | 'timingTooFast'
  | 'managementLink'
  | 'supportCategory'
  | 'message'
  | 'ticket'
  | 'newTicket'
  | 'supportTabNew'
  | 'supportTabTickets'
  | 'supportSubject'
  | 'sendSupportRequest'
  | 'supportAccountReplyHint'
  | 'supportReply'
  | 'sendSupportReply'
  | 'closeTicket'
  | 'supportTicketClosed'
  | 'supportMessageClosedFromAccount'
  | 'supportUnreadMessages'
  | 'supportLiveActive'
  | 'supportLiveReconnecting'
  | 'supportMessageClosedBySupport'
  | 'supportMessageStatusChanged'
  | 'supportCloseReasonClosedBySupport'
  | 'supportCloseReasonClosedByAccount'
  | 'supportActorYou'
  | 'supportActorSupport'
  | 'supportActorSystem'
  | 'supportStatusNew'
  | 'supportStatusOpen'
  | 'supportStatusWaitingSupport'
  | 'supportStatusWaitingUser'
  | 'supportStatusResolved'
  | 'supportStatusClosed'
  | 'supportCategoryAccount'
  | 'supportCategoryText'
  | 'supportCategoryTranslation'
  | 'supportCategoryAccess'
  | 'supportCategorySecurity'
  | 'supportCategoryBug'
  | 'supportCategoryInterface'
  | 'supportCategoryData'
  | 'supportCategoryOther'
  | 'startRecovery'
  | 'completeRecovery'
  | 'savedPrivate'
  | 'recentPrivate'
  | 'translationsPrivate'
  | 'settingsSaved'
  | 'bonusIntro'
  | 'bonusBalance'
  | 'bonusAvailable'
  | 'bonusPending'
  | 'bonusLocked'
  | 'bonusHistory'
  | 'bonusRules'
  | 'bonusHowToGet'
  | 'bonusSpend'
  | 'bonusSubscription'
  | 'bonusSubscriptionActive'
  | 'bonusSubscriptionInactive'
  | 'bonusRedeemOptions'
  | 'bonusRedeem'
  | 'bonusNoCashOut'
  | 'bonusNoTextRewards'
  | 'bonusHelpOnly'
  | 'bonusRuleConfirmedReports'
  | 'bonusRuleTranslationIssues'
  | 'bonusRuleBugReports'
  | 'bonusRuleUiFeedback'
  | 'bonusCannotWithdraw'
  | 'bonusAccountOnly'
  | 'bonusRedeemSecurityHold'
  | 'bonusSubscriptionExpires'
  | 'bonusCredits'
  | 'bonusPlan7Days'
  | 'bonusPlan30Days'
  | 'bonusSpent'
  | 'bonusEarned'
  | 'bonusPendingReview'
  | 'bonusRulesIntro'
  | 'bonusActivate'
  | 'bonusNeedMore'
  | 'bonusConfirmActivation'
  | 'bonusWillSpend'
  | 'bonusRemaining'
  | 'bonusProgramsUnavailable'
  | 'bonusUpTo'
  | 'bonusContactSupport'
  | 'bonusTerms'
  | 'bonusHistoryEmpty'
  | 'bonusHistoryRejected'
  | 'bonusHistoryReturned'
  | 'bonusHistoryExpired'
  | 'bonusHistoryLocked'
  | 'bonusRewardConfirmedReport'
  | 'bonusRewardTranslationIssue'
  | 'bonusRewardBugReport'
  | 'bonusRewardUiFeedback'
  | 'bonusPartialLoadError'
  | 'bonusRetry'
  | 'bonusBalanceUnavailable'
  | 'bonusRedeemOptionsUnavailable'
  | 'bonusRulesUnavailable'
  | 'bonusHistoryUnavailable'
  | 'bonusSubscriptionUnavailable'
  | 'bonusRedeemStateUnavailable'
  | 'bonusOptionUnavailable'
  | 'bonusRedeemInsufficient'
  | 'bonusRedeemOptionUnavailable'
  | 'bonusRedeemUnknownOutcome'
  | 'bonusRedeemFailed'
  | 'bonusShowMore'
  | 'bonusHistoryLoadMoreError'
  | 'bonusBenefitsTitle'
  | 'bonusBenefitMorePrivateSaves'
  | 'bonusBenefitLongerHistory'
  | 'bonusBenefitAdvancedReading'
  | 'bonusBenefitThemes'
  | 'bonusBenefitExport'
  | 'bonusBenefitEarlyAccess'
  | 'bonusBenefitPrioritySupport'
  | 'bonusRewardSafetyReport'
  | 'bonusRuleSafetyReports'
  | 'bonusRewardSupportFeedback'
  | 'bonusRuleSupportFeedback'
  | 'invalidPassword'
  | 'passwordRules'
  | 'passwordRequired'
  | 'passwordLength'
  | 'passwordLatinOnly'
  | 'passwordLowercase'
  | 'passwordUppercase'
  | 'passwordDigit'
  | 'recoveryFileWarning'
  | 'downloaded'
  | 'copied'
  | 'generatePassword'
  | 'hideRecoveryKey'
  | 'showRecoveryKey'
  | 'hidePassword'
  | 'showPassword'
  | 'accountNotFound'
  | 'supportMessageTooManyRepeats'
  | 'supportMessageWordTooLong'
  | 'supportMessageTooManyUrls'
  | 'supportMessageTooShort'
  | 'supportMessageTooLong'
  | 'tooManyAttempts'
  | 'securityHoldShort'
  | 'securityTabAuthentication'
  | 'securityTabSessions'
  | 'securityTabActivity'
  | 'authentication'
  | 'changePassword'
  | 'changePasswordIntro'
  | 'savePassword'
  | 'passwordChanged'
  | 'recoveryKeyCreateIntro'
  | 'recoveryKeyReplaceIntro'
  | 'recoveryKeyAlreadyCreated'
  | 'showRecoveryKeyForm'
  | 'sessionCurrent'
  | 'sessionOther'
  | 'sessionExpiresAt'
  | 'revokeSession'
  | 'sessionRevoked'
  | 'activity'
  | 'securityActivityIntro'
  | 'securityEvent'
  | 'securityTime'
  | 'securitySeverityInfo'
  | 'securitySeverityImportant'
  | 'securitySeverityWarning'
  | 'securityEventSensitiveActionAuthorized'
  | 'securityEventSensitiveActionPasswordFailed'
  | 'securityEventSensitiveActionBlockedHold'
  | 'noActivity'
  | 'securityEventAccountLoginSucceeded'
  | 'securityEventAccountLoginFailed'
  | 'securityEventAccountLogout'
  | 'securityEventAccountLogoutAll'
  | 'securityEventAccountSessionRevoked'
  | 'securityEventAccountPasswordChanged'
  | 'securityEventRecoveryKeyCreated'
  | 'securityEventRecoveryKeyReplaced'
  | 'securityEventRecoveredByKey'
  | 'securityEventAutoDeleteUpdated'
  | 'securityEventAccountDeleted'
  | 'securityEventGeneric'
  | 'featureDisabled';

export type AccountMessages = Record<AccountMessageKey, string>;

export const ACCOUNT_REQUIRED_I18N_KEYS: readonly AccountMessageKey[] = [
  'title',
  'eyebrow',
  'headline',
  'intro',
  'home',
  'login',
  'register',
  'recover',
  'texts',
  'saved',
  'recent',
  'reading',
  'translations',
  'bonus',
  'support',
  'security',
  'settings',
  'accountNotProfile',
  'loading',
  'empty',
  'error',
  'success',
  'submit',
  'save',
  'cancel',
  'delete',
  'close',
  'refresh',
  'password',
  'currentPassword',
  'newPassword',
  'pseudonym',
  'emailOptional',
  'recoveryKey',
  'copy',
  'download',
  'status',
  'language',
  'created',
  'updated',
  'published',
  'open',
  'manage',
  'remove',
  'clear',
  'enabled',
  'disabled',
  'interfaceLanguage',
  'theme',
  'notifications',
  'privacy',
  'data',
  'savedTextsIntro',
  'recentIntro',
  'readingIntro',
  'translationsIntro',
  'supportIntro',
  'securityIntro',
  'settingsIntro',
  'loginIntro',
  'registerIntro',
  'recoverIntro',
  'textsIntro',
  'noPublicProfile',
  'handleTaken',
  'pseudonymSuggestions',
  'pseudonymRules',
  'pseudonymLength',
  'pseudonymFormat',
  'pseudonymReserved',
  'pseudonymRequired',
  'securityHold',
  'logout',
  'logoutAll',
  'sessions',
  'devices',
  'createRecoveryKey',
  'recoveryKeyWarning',
  'recoveryKeyRotatedAfterRecovery',
  'replaceRecoveryKey',
  'changeEmail',
  'removeEmail',
  'exportData',
  'deleteAccount',
  'addByLink',
  'claimText',
  'timingTooFast',
  'managementLink',
  'supportCategory',
  'message',
  'ticket',
  'newTicket',
  'supportTabNew',
  'supportTabTickets',
  'supportSubject',
  'sendSupportRequest',
  'supportAccountReplyHint',
  'supportReply',
  'sendSupportReply',
  'closeTicket',
  'supportTicketClosed',
  'supportMessageClosedFromAccount',
  'supportUnreadMessages',
  'supportLiveActive',
  'supportLiveReconnecting',
  'supportMessageClosedBySupport',
  'supportMessageStatusChanged',
  'supportCloseReasonClosedBySupport',
  'supportCloseReasonClosedByAccount',
  'supportActorYou',
  'supportActorSupport',
  'supportActorSystem',
  'supportStatusNew',
  'supportStatusOpen',
  'supportStatusWaitingSupport',
  'supportStatusWaitingUser',
  'supportStatusResolved',
  'supportStatusClosed',
  'supportCategoryAccount',
  'supportCategoryText',
  'supportCategoryTranslation',
  'supportCategoryAccess',
  'supportCategorySecurity',
  'supportCategoryBug',
  'supportCategoryInterface',
  'supportCategoryData',
  'supportCategoryOther',
  'startRecovery',
  'completeRecovery',
  'savedPrivate',
  'recentPrivate',
  'translationsPrivate',
  'settingsSaved',
  'bonusIntro',
  'bonusBalance',
  'bonusAvailable',
  'bonusPending',
  'bonusLocked',
  'bonusHistory',
  'bonusRules',
  'bonusHowToGet',
  'bonusSpend',
  'bonusSubscription',
  'bonusSubscriptionActive',
  'bonusSubscriptionInactive',
  'bonusRedeemOptions',
  'bonusRedeem',
  'bonusNoCashOut',
  'bonusNoTextRewards',
  'bonusHelpOnly',
  'bonusRuleConfirmedReports',
  'bonusRuleTranslationIssues',
  'bonusRuleBugReports',
  'bonusRuleUiFeedback',
  'bonusCannotWithdraw',
  'bonusAccountOnly',
  'bonusRedeemSecurityHold',
  'bonusSubscriptionExpires',
  'bonusCredits',
  'bonusPlan7Days',
  'bonusPlan30Days',
  'bonusSpent',
  'bonusEarned',
  'bonusPendingReview',
  'bonusRulesIntro',
  'bonusActivate',
  'bonusNeedMore',
  'bonusConfirmActivation',
  'bonusWillSpend',
  'bonusRemaining',
  'bonusProgramsUnavailable',
  'bonusUpTo',
  'bonusContactSupport',
  'bonusTerms',
  'bonusHistoryEmpty',
  'bonusHistoryRejected',
  'bonusHistoryReturned',
  'bonusHistoryExpired',
  'bonusHistoryLocked',
  'bonusRewardConfirmedReport',
  'bonusRewardTranslationIssue',
  'bonusRewardBugReport',
  'bonusRewardUiFeedback',
  'bonusPartialLoadError',
  'bonusRetry',
  'bonusBalanceUnavailable',
  'bonusRedeemOptionsUnavailable',
  'bonusRulesUnavailable',
  'bonusHistoryUnavailable',
  'bonusSubscriptionUnavailable',
  'bonusRedeemStateUnavailable',
  'bonusOptionUnavailable',
  'bonusRedeemInsufficient',
  'bonusRedeemOptionUnavailable',
  'bonusRedeemUnknownOutcome',
  'bonusRedeemFailed',
  'bonusShowMore',
  'bonusHistoryLoadMoreError',
  'bonusBenefitsTitle',
  'bonusBenefitMorePrivateSaves',
  'bonusBenefitLongerHistory',
  'bonusBenefitAdvancedReading',
  'bonusBenefitThemes',
  'bonusBenefitExport',
  'bonusBenefitEarlyAccess',
  'bonusBenefitPrioritySupport',
  'bonusRewardSafetyReport',
  'bonusRuleSafetyReports',
  'bonusRewardSupportFeedback',
  'bonusRuleSupportFeedback',
  'invalidPassword',
  'passwordRules',
  'passwordRequired',
  'passwordLength',
  'passwordLatinOnly',
  'passwordLowercase',
  'passwordUppercase',
  'passwordDigit',
  'recoveryFileWarning',
  'downloaded',
  'copied',
  'generatePassword',
  'hideRecoveryKey',
  'showRecoveryKey',
  'hidePassword',
  'showPassword',
  'accountNotFound',
  'supportMessageTooManyRepeats',
  'supportMessageWordTooLong',
  'supportMessageTooManyUrls',
  'supportMessageTooShort',
  'supportMessageTooLong',
  'tooManyAttempts',
  'securityHoldShort',
  'settingsTabLanguage',
  'settingsTabTheme',
  'settingsTabDeletion',
  'autoDeleteAccount',
  'autoDeleteCheckboxRequired',
  'saveAutoDelete',
  'confirmChange',
  'deleteNow',
  'deleteNowIntro',
  'confirmDeleteAccount',
  'pseudonymConfirmation',
  'deletionSettingsSaved',
  'accountDeleted',
  'accountDeleteConfirmationMismatch',
  'securityTabAuthentication',
  'securityTabSessions',
  'securityTabActivity',
  'authentication',
  'changePassword',
  'changePasswordIntro',
  'savePassword',
  'passwordChanged',
  'recoveryKeyCreateIntro',
  'recoveryKeyReplaceIntro',
  'recoveryKeyAlreadyCreated',
  'showRecoveryKeyForm',
  'sessionCurrent',
  'sessionOther',
  'sessionExpiresAt',
  'revokeSession',
  'sessionRevoked',
  'activity',
  'securityActivityIntro',
  'securityEvent',
  'securityTime',
  'securitySeverityInfo',
  'securitySeverityImportant',
  'securitySeverityWarning',
  'securityEventSensitiveActionAuthorized',
  'securityEventSensitiveActionPasswordFailed',
  'securityEventSensitiveActionBlockedHold',
  'noActivity',
  'securityEventAccountLoginSucceeded',
  'securityEventAccountLoginFailed',
  'securityEventAccountLogout',
  'securityEventAccountLogoutAll',
  'securityEventAccountSessionRevoked',
  'securityEventAccountPasswordChanged',
  'securityEventRecoveryKeyCreated',
  'securityEventRecoveryKeyReplaced',
  'securityEventRecoveredByKey',
  'securityEventAutoDeleteUpdated',
  'securityEventAccountDeleted',
  'securityEventGeneric',
  'featureDisabled',
];

const EN: AccountMessages = {
  title: 'Account',
  eyebrow: 'Private account',
  headline: 'Account',
  intro: 'Manage your account.',
  home: 'Account',
  login: 'Sign in',
  register: 'Create account',
  recover: 'Recover account',
  texts: 'My texts',
  saved: 'Saved',
  recent: 'Recently read',
  reading: 'Reading',
  translations: 'Translations',
  bonus: 'Bonuses',
  support: 'Support',
  security: 'Security',
  settings: 'Settings',
  accountNotProfile:
    'Account is for control, not publicity. Your pseudonym is not shown as an author name.',
  loading: 'Loading…',
  empty: 'Nothing to show yet.',
  error: 'Something went wrong. Try again.',
  success: 'Saved.',
  submit: 'Submit',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  close: 'Close',
  refresh: 'Refresh',
  password: 'Password',
  currentPassword: 'Current password',
  newPassword: 'New password',
  pseudonym: 'Pseudonym',
  emailOptional: 'Email, optional',
  recoveryKey: 'Recovery key',
  copy: 'Copy',
  download: 'Download',
  status: 'Status',
  language: 'Language',
  created: 'Created',
  updated: 'Updated',
  published: 'Published',
  open: 'Open',
  manage: 'Manage',
  remove: 'Remove',
  clear: 'Clear',
  enabled: 'Enabled',
  disabled: 'Disabled',
  interfaceLanguage: 'Interface language',
  theme: 'Theme',
  notifications: 'Notifications',
  privacy: 'Privacy',
  data: 'Data',
  savedTextsIntro:
    'Saved texts are private. They are not public likes and do not expose your identity.',
  recentIntro: 'Recently read is private, can be cleared, and can be disabled.',
  readingIntro:
    'Choose reading languages and soft reading mode. These settings are separate from the interface language.',
  translationsIntro:
    'Control translation consent and translation status for your texts. Translations are not created immediately.',
  supportIntro: 'Create and follow private support requests.',
  securityIntro: 'Manage sessions, recovery, email and sensitive account actions.',
  settingsIntro:
    'General account settings: interface language, theme, notifications, privacy and data.',
  loginIntro: 'Enter your access details.',
  registerIntro: 'Choose your access details.',
  recoverIntro: 'Restore access.',
  textsIntro: 'Texts linked to your account stay anonymous to readers.',
  noPublicProfile: 'No public profile, no followers, no avatar, no author page.',
  handleTaken: 'This pseudonym is unavailable.',
  pseudonymSuggestions: 'Choose one of these:',
  pseudonymRules: '6-20 characters: letters, numbers, dot, dash or underscore.',
  pseudonymLength: 'Use 6-20 characters.',
  pseudonymFormat: 'Use letters, numbers, dot, dash or underscore.',
  pseudonymReserved: 'Choose another pseudonym.',
  pseudonymRequired: 'Enter a pseudonym.',
  securityHold: 'This action is temporarily protected after a new device or network.',
  logout: 'Log out',
  logoutAll: 'Log out everywhere',
  sessions: 'Sessions',
  devices: 'Devices',
  createRecoveryKey: 'Create recovery key',
  recoveryKeyWarning:
    'Without a recovery key, you will not be able to recover this account if you forget the password.',
  recoveryKeyRotatedAfterRecovery: 'After recovery, a new recovery key will be issued.',
  replaceRecoveryKey: 'Replace recovery key',
  changeEmail: 'Change email',
  removeEmail: 'Remove email',
  exportData: 'Request data export',
  deleteAccount: 'Request account deletion',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Add text by link',
  claimText: 'Save text in account',
  timingTooFast: 'Wait a few seconds and try again.',
  managementLink: 'Management link',
  supportCategory: 'Category',
  message: 'Message',
  ticket: 'Ticket',
  newTicket: 'New request',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'The support request was closed from the account.',
  supportUnreadMessages: '{count} unread support messages',
  supportLiveActive: 'Live updates active',
  supportLiveReconnecting: 'Reconnecting live updates…',
  supportMessageClosedBySupport: 'The support request was closed by support. Reason: {reason}',
  supportMessageStatusChanged: 'Support request status changed to {status}.',
  supportCloseReasonClosedBySupport: 'closed by support',
  supportCloseReasonClosedByAccount: 'closed from the account',
  supportActorYou: 'You',
  supportActorSupport: 'Support',
  supportActorSystem: 'System',
  supportStatusNew: 'New',
  supportStatusOpen: 'Open',
  supportStatusWaitingSupport: 'Waiting for support',
  supportStatusWaitingUser: 'Waiting for you',
  supportStatusResolved: 'Resolved',
  supportStatusClosed: 'Closed',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Start recovery',
  completeRecovery: 'Complete recovery',
  savedPrivate: 'Only you can see this list.',
  recentPrivate: 'Reading history is not shown to authors or other users.',
  translationsPrivate: 'Translation controls do not reveal authorship.',
  settingsSaved: 'Settings saved.',
  bonusIntro:
    'Use bonuses inside Quaom. They are earned only for confirmed help and cannot be withdrawn.',
  bonusBalance: 'Balance',
  bonusAvailable: 'Available',
  bonusPending: 'Pending review',
  bonusLocked: 'Locked',
  bonusHistory: 'History',
  bonusRules: 'Rules',
  bonusHowToGet: 'How to get bonuses',
  bonusSpend: 'Spend bonuses',
  bonusSubscription: 'Subscription',
  bonusSubscriptionActive: 'Subscription active',
  bonusSubscriptionInactive: 'No active subscription',
  bonusRedeemOptions: 'Use bonuses',
  bonusRedeem: 'Use bonuses',
  bonusNoCashOut: 'Bonuses cannot be withdrawn or transferred.',
  bonusNoTextRewards: 'Texts, views, saves and emotions do not earn bonuses.',
  bonusHelpOnly:
    'Only confirmed help with reports, translations, bugs or interface feedback may earn bonuses.',
  bonusRuleConfirmedReports: 'Confirmed useful reports may earn bonuses.',
  bonusRuleTranslationIssues: 'Confirmed translation or language issues may earn bonuses.',
  bonusRuleBugReports: 'Confirmed technical bugs may earn bonuses.',
  bonusRuleUiFeedback: 'Useful interface feedback may earn bonuses after review.',
  bonusCannotWithdraw: 'Bonuses are not money and cannot be paid out.',
  bonusAccountOnly: 'Bonuses exist only inside your private account.',
  bonusRedeemSecurityHold:
    'Spending bonuses is temporarily protected after a new device or network.',
  bonusSubscriptionExpires: 'Expires',
  bonusCredits: 'bonuses',
  bonusPlan7Days: '7 days',
  bonusPlan30Days: '30 days',
  bonusSpent: 'Spent',
  bonusEarned: 'Earned',
  bonusPendingReview: 'Pending review',
  bonusRulesIntro: 'Bonus rules protect Quaom from turning personal texts into a paid stage.',
  bonusActivate: 'Activate',
  bonusNeedMore: 'Need',
  bonusConfirmActivation: 'Confirm activation',
  bonusWillSpend: 'Will be spent',
  bonusRemaining: 'Remaining',
  bonusProgramsUnavailable: 'Bonus awards are temporarily unavailable.',
  bonusUpTo: 'Up to',
  bonusContactSupport: 'Contact support',
  bonusTerms: 'Conditions',
  bonusHistoryEmpty: 'No bonus activity yet.',
  bonusHistoryRejected: 'Rejected',
  bonusHistoryReturned: 'Returned',
  bonusHistoryExpired: 'Expired',
  bonusHistoryLocked: 'Temporarily locked',
  bonusRewardConfirmedReport: 'Confirmed useful report',
  bonusRewardTranslationIssue: 'Confirmed translation issue',
  bonusRewardBugReport: 'Confirmed technical bug',
  bonusRewardUiFeedback: 'Confirmed interface feedback',
  invalidPassword: 'Wrong password.',
  passwordRules:
    'Use 10-32 characters: Latin letters and numbers only, with at least one lowercase letter, one uppercase letter, and one number.',
  passwordRequired: 'Enter a password.',
  passwordLength: 'Use 10-32 characters for the password.',
  passwordLatinOnly: 'Use only Latin letters and numbers in the password.',
  passwordLowercase: 'Add at least one lowercase Latin letter to the password.',
  passwordUppercase: 'Add at least one uppercase Latin letter to the password.',
  passwordDigit: 'Add at least one number to the password.',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  showRecoveryKey: 'Show recovery key',
  hideRecoveryKey: 'Hide recovery key',
  generatePassword: 'Generate password',
  copied: 'Copied.',
  downloaded: 'Downloaded.',
  recoveryFileWarning:
    'Keep this file in a private place. The recovery key can help restore access to the account.',
  accountNotFound: 'Account not found.',
  supportMessageTooManyRepeats: 'The message contains too many identical characters in a row.',
  supportMessageWordTooLong: 'One word in the message is too long.',
  supportMessageTooManyUrls: 'The message contains too many links.',
  supportMessageTooShort: 'The message is too short.',
  supportMessageTooLong: 'The message is too long.',
  tooManyAttempts: 'Too many attempts. Please wait a little and try again.',
  securityHoldShort: 'Temporarily limited.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Event',
  securityTime: 'Time',
  securitySeverityInfo: 'Information',
  securitySeverityImportant: 'Important',
  securitySeverityWarning: 'Warning',
  securityEventSensitiveActionAuthorized: 'Protected action confirmed',
  securityEventSensitiveActionPasswordFailed: 'Password confirmation failed',
  securityEventSensitiveActionBlockedHold: 'Action blocked by temporary protection',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Temporarily unavailable.',
  bonusPartialLoadError: 'Some bonus data could not be loaded. Available sections remain usable.',
  bonusRetry: 'Try again',
  bonusBalanceUnavailable: 'Balance is temporarily unavailable.',
  bonusRedeemOptionsUnavailable: 'Bonus options are temporarily unavailable.',
  bonusRulesUnavailable: 'Bonus earning programs are temporarily unavailable.',
  bonusHistoryUnavailable: 'Bonus history is temporarily unavailable.',
  bonusSubscriptionUnavailable: 'Subscription status is temporarily unavailable.',
  bonusRedeemStateUnavailable: 'Spending cannot be verified right now. Try again.',
  bonusOptionUnavailable: 'This option is temporarily unavailable.',
  bonusRedeemInsufficient: 'Not enough available bonuses. Your balance may have changed.',
  bonusRedeemOptionUnavailable:
    'This bonus option is no longer available. Refresh and choose again.',
  bonusRedeemUnknownOutcome:
    'We could not confirm the result. Try again safely; the same request will not be charged twice.',
  bonusRedeemFailed: 'Could not use bonuses. Try again.',
  bonusShowMore: 'Show more',
  bonusHistoryLoadMoreError: 'Could not load more history. Try again.',
  bonusBenefitsTitle: 'Subscription includes',
  bonusBenefitMorePrivateSaves: 'More private saved texts',
  bonusBenefitLongerHistory: 'Longer private reading history',
  bonusBenefitAdvancedReading: 'Advanced reading settings',
  bonusBenefitThemes: 'Additional reading themes',
  bonusBenefitExport: 'Export of saved texts',
  bonusBenefitEarlyAccess: 'Early access to reading modes',
  bonusBenefitPrioritySupport: 'Priority support',
  bonusRewardSafetyReport: 'Confirmed safety report',
  bonusRuleSafetyReports: 'A confirmed safety report may earn bonuses after review.',
  bonusRewardSupportFeedback: 'Confirmed support feedback',
  bonusRuleSupportFeedback: 'Useful feedback about support may earn bonuses after review.',
};
const DE: AccountMessages = {
  title: 'Konto',
  eyebrow: 'Privates Konto',
  headline: 'Konto',
  intro: 'Verwalten Sie Ihr Konto.',
  home: 'Konto',
  login: 'Anmelden',
  register: 'Konto erstellen',
  recover: 'Konto wiederherstellen',
  texts: 'Meine Texte',
  saved: 'Gespeichert',
  recent: 'Zuletzt gelesen',
  reading: 'Lesen',
  translations: 'Übersetzungen',
  bonus: 'Boni',
  support: 'Support',
  security: 'Sicherheit',
  settings: 'Einstellungen',
  accountNotProfile:
    'Das Konto dient der Kontrolle, nicht der Öffentlichkeit. Ihr Pseudonym wird nicht als Autorenname gezeigt.',
  loading: 'Wird geladen…',
  empty: 'Noch nichts vorhanden.',
  error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
  success: 'Gespeichert.',
  submit: 'Senden',
  save: 'Speichern',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  close: 'Schließen',
  refresh: 'Aktualisieren',
  password: 'Passwort',
  currentPassword: 'Aktuelles Passwort',
  newPassword: 'Neues Passwort',
  pseudonym: 'Pseudonym',
  emailOptional: 'E-Mail, optional',
  recoveryKey: 'Wiederherstellungsschlüssel',
  copy: 'Kopieren',
  download: 'Herunterladen',
  status: 'Status',
  language: 'Sprache',
  created: 'Erstellt',
  updated: 'Aktualisiert',
  published: 'Veröffentlicht',
  open: 'Öffnen',
  manage: 'Verwalten',
  remove: 'Entfernen',
  clear: 'Leeren',
  enabled: 'Aktiviert',
  disabled: 'Deaktiviert',
  interfaceLanguage: 'Oberflächensprache',
  theme: 'Design',
  notifications: 'Benachrichtigungen',
  privacy: 'Privatsphäre',
  data: 'Daten',
  savedTextsIntro:
    'Gespeicherte Texte sind privat. Sie sind keine öffentlichen Likes und zeigen Ihre Identität nicht.',
  recentIntro: 'Zuletzt gelesen ist privat, kann geleert und deaktiviert werden.',
  readingIntro:
    'Wählen Sie Lesesprachen und den sanften Lesemodus. Diese Einstellungen sind von der Oberflächensprache getrennt.',
  translationsIntro:
    'Steuern Sie Übersetzungszustimmung und Übersetzungsstatus Ihrer Texte. Übersetzungen werden nicht sofort erstellt.',
  supportIntro: 'Erstellen und verfolgen Sie private Supportanfragen.',
  securityIntro: 'Verwalten Sie Sitzungen, Wiederherstellung, E-Mail und sensible Kontoaktionen.',
  settingsIntro:
    'Allgemeine Kontoeinstellungen: Sprache, Design, Benachrichtigungen, Privatsphäre und Daten.',
  loginIntro: 'Geben Sie Ihre Zugangsdaten ein.',
  registerIntro: 'Wählen Sie Ihre Zugangsdaten.',
  recoverIntro: 'Zugang wiederherstellen.',
  textsIntro: 'Mit Ihrem Konto verknüpfte Texte bleiben für Leser anonym.',
  noPublicProfile: 'Kein öffentliches Profil, keine Follower, kein Avatar, keine Autorenseite.',
  handleTaken: 'Dieses Pseudonym ist nicht verfügbar.',
  pseudonymSuggestions: 'Wähle eine dieser Optionen:',
  pseudonymRules: '6-20 Zeichen: Buchstaben, Zahlen, Punkt, Bindestrich oder Unterstrich.',
  pseudonymLength: 'Verwenden Sie 6-20 Zeichen.',
  pseudonymFormat: 'Verwenden Sie Buchstaben, Zahlen, Punkt, Bindestrich oder Unterstrich.',
  pseudonymReserved: 'Wählen Sie ein anderes Pseudonym.',
  pseudonymRequired: 'Geben Sie ein Pseudonym ein.',
  securityHold: 'Diese Aktion ist nach einem neuen Gerät oder Netzwerk vorübergehend geschützt.',
  logout: 'Abmelden',
  logoutAll: 'Überall abmelden',
  sessions: 'Sitzungen',
  devices: 'Geräte',
  createRecoveryKey: 'Wiederherstellungsschlüssel erstellen',
  recoveryKeyWarning:
    'Ohne Wiederherstellungsschlüssel können Sie dieses Konto nicht wiederherstellen, wenn Sie das Passwort vergessen.',
  recoveryKeyRotatedAfterRecovery:
    'Nach der Wiederherstellung wird ein neuer Wiederherstellungsschlüssel ausgegeben.',
  replaceRecoveryKey: 'Wiederherstellungsschlüssel ersetzen',
  changeEmail: 'E-Mail ändern',
  removeEmail: 'E-Mail entfernen',
  exportData: 'Datenexport anfordern',
  deleteAccount: 'Kontolöschung anfordern',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Text per Link hinzufügen',
  claimText: 'Text im Konto speichern',
  timingTooFast: 'Warten Sie ein paar Sekunden und versuchen Sie es erneut.',
  managementLink: 'Verwaltungslink',
  supportCategory: 'Kategorie',
  message: 'Nachricht',
  ticket: 'Anfrage',
  newTicket: 'Neue Anfrage',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'Die Supportanfrage wurde über das Konto geschlossen.',
  supportUnreadMessages: '{count} ungelesene Support-Nachrichten',
  supportLiveActive: 'Live-Aktualisierung aktiv',
  supportLiveReconnecting: 'Live-Aktualisierung wird wiederhergestellt…',
  supportMessageClosedBySupport:
    'Die Supportanfrage wurde vom Support geschlossen. Grund: {reason}',
  supportMessageStatusChanged: 'Der Status der Supportanfrage wurde auf {status} geändert.',
  supportCloseReasonClosedBySupport: 'vom Support geschlossen',
  supportCloseReasonClosedByAccount: 'über das Konto geschlossen',
  supportActorYou: 'Sie',
  supportActorSupport: 'Support',
  supportActorSystem: 'System',
  supportStatusNew: 'Neu',
  supportStatusOpen: 'Offen',
  supportStatusWaitingSupport: 'Wartet auf Support',
  supportStatusWaitingUser: 'Wartet auf Ihre Antwort',
  supportStatusResolved: 'Gelöst',
  supportStatusClosed: 'Geschlossen',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Wiederherstellung starten',
  completeRecovery: 'Wiederherstellung abschließen',
  savedPrivate: 'Nur Sie können diese Liste sehen.',
  recentPrivate: 'Der Leseverlauf wird Autoren oder anderen Nutzern nicht gezeigt.',
  translationsPrivate: 'Übersetzungssteuerung legt keine Autorschaft offen.',
  settingsSaved: 'Einstellungen gespeichert.',
  bonusIntro:
    'Nutzen Sie Boni innerhalb von Quaom. Sie entstehen nur durch bestätigte Hilfe und können nicht ausgezahlt werden.',
  bonusBalance: 'Guthaben',
  bonusAvailable: 'Verfügbar',
  bonusPending: 'In Prüfung',
  bonusLocked: 'Gesperrt',
  bonusHistory: 'Verlauf',
  bonusRules: 'Regeln',
  bonusHowToGet: 'So erhalten Sie Boni',
  bonusSpend: 'Boni verwenden',
  bonusSubscription: 'Abonnement',
  bonusSubscriptionActive: 'Abonnement aktiv',
  bonusSubscriptionInactive: 'Kein aktives Abonnement',
  bonusRedeemOptions: 'Boni verwenden',
  bonusRedeem: 'Boni verwenden',
  bonusNoCashOut: 'Boni können nicht ausgezahlt oder übertragen werden.',
  bonusNoTextRewards: 'Texte, Ansichten, Speicherungen und Emotionen bringen keine Boni.',
  bonusHelpOnly:
    'Nur bestätigte Hilfe bei Meldungen, Übersetzungen, Fehlern oder Feedback zur Oberfläche kann Boni bringen.',
  bonusRuleConfirmedReports: 'Bestätigte nützliche Meldungen können Boni bringen.',
  bonusRuleTranslationIssues: 'Bestätigte Übersetzungs- oder Sprachprobleme können Boni bringen.',
  bonusRuleBugReports: 'Bestätigte technische Fehler können Boni bringen.',
  bonusRuleUiFeedback: 'Nützliches Feedback zur Oberfläche kann nach Prüfung Boni bringen.',
  bonusCannotWithdraw: 'Boni sind kein Geld und können nicht ausgezahlt werden.',
  bonusAccountOnly: 'Boni existieren nur in Ihrem privaten Konto.',
  bonusRedeemSecurityHold:
    'Das Verwenden von Boni ist nach einem neuen Gerät oder Netzwerk vorübergehend geschützt.',
  bonusSubscriptionExpires: 'Läuft ab',
  bonusCredits: 'Boni',
  bonusPlan7Days: '7 Tage',
  bonusPlan30Days: '30 Tage',
  bonusSpent: 'Ausgegeben',
  bonusEarned: 'Erhalten',
  bonusPendingReview: 'Wartet auf Prüfung',
  bonusRulesIntro:
    'Die Bonusregeln schützen Quaom davor, persönliche Texte in eine bezahlte Bühne zu verwandeln.',
  bonusActivate: 'Aktivieren',
  bonusNeedMore: 'Noch benötigt',
  bonusConfirmActivation: 'Aktivierung bestätigen',
  bonusWillSpend: 'Wird abgezogen',
  bonusRemaining: 'Verbleibend',
  bonusProgramsUnavailable: 'Bonusgutschriften sind vorübergehend nicht verfügbar.',
  bonusUpTo: 'Bis zu',
  bonusContactSupport: 'Support kontaktieren',
  bonusTerms: 'Bedingungen',
  bonusHistoryEmpty: 'Noch keine Bonusvorgänge.',
  bonusHistoryRejected: 'Abgelehnt',
  bonusHistoryReturned: 'Zurückgebucht',
  bonusHistoryExpired: 'Abgelaufen',
  bonusHistoryLocked: 'Vorübergehend gesperrt',
  bonusRewardConfirmedReport: 'Bestätigte hilfreiche Meldung',
  bonusRewardTranslationIssue: 'Bestätigtes Übersetzungsproblem',
  bonusRewardBugReport: 'Bestätigter technischer Fehler',
  bonusRewardUiFeedback: 'Bestätigtes Feedback zur Oberfläche',
  invalidPassword: 'Falsches Passwort.',
  passwordRules:
    'Verwenden Sie 10–32 Zeichen: nur lateinische Buchstaben und Zahlen, mit mindestens einem Kleinbuchstaben, einem Großbuchstaben und einer Zahl.',
  passwordRequired: 'Geben Sie ein Passwort ein.',
  passwordLength: 'Verwenden Sie 10–32 Zeichen für das Passwort.',
  passwordLatinOnly: 'Verwenden Sie im Passwort nur lateinische Buchstaben und Zahlen.',
  passwordLowercase: 'Fügen Sie mindestens einen lateinischen Kleinbuchstaben hinzu.',
  passwordUppercase: 'Fügen Sie mindestens einen lateinischen Großbuchstaben hinzu.',
  passwordDigit: 'Fügen Sie dem Passwort mindestens eine Zahl hinzu.',
  showPassword: 'Passwort anzeigen',
  hidePassword: 'Passwort ausblenden',
  showRecoveryKey: 'Wiederherstellungsschlüssel anzeigen',
  hideRecoveryKey: 'Wiederherstellungsschlüssel ausblenden',
  generatePassword: 'Passwort generieren',
  copied: 'Kopiert.',
  downloaded: 'Heruntergeladen.',
  recoveryFileWarning:
    'Bewahren Sie diese Datei an einem privaten Ort auf. Der Wiederherstellungsschlüssel kann helfen, den Zugriff auf das Konto wiederherzustellen.',
  accountNotFound: 'Konto nicht gefunden.',
  supportMessageTooManyRepeats: 'Die Nachricht enthält zu viele gleiche Zeichen hintereinander.',
  supportMessageWordTooLong: 'Ein Wort in der Nachricht ist zu lang.',
  supportMessageTooManyUrls: 'Die Nachricht enthält zu viele Links.',
  supportMessageTooShort: 'Die Nachricht ist zu kurz.',
  supportMessageTooLong: 'Die Nachricht ist zu lang.',
  tooManyAttempts: 'Zu viele Versuche. Bitte warten Sie kurz und versuchen Sie es erneut.',
  securityHoldShort: 'Vorübergehend eingeschränkt.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Ereignis',
  securityTime: 'Zeit',
  securitySeverityInfo: 'Information',
  securitySeverityImportant: 'Wichtig',
  securitySeverityWarning: 'Warnung',
  securityEventSensitiveActionAuthorized: 'Geschützte Aktion bestätigt',
  securityEventSensitiveActionPasswordFailed: 'Passwortbestätigung fehlgeschlagen',
  securityEventSensitiveActionBlockedHold: 'Aktion durch vorübergehenden Schutz blockiert',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Vorübergehend nicht verfügbar.',
  bonusPartialLoadError:
    'Einige Bonusdaten konnten nicht geladen werden. Verfügbare Bereiche bleiben nutzbar.',
  bonusRetry: 'Erneut versuchen',
  bonusBalanceUnavailable: 'Der Kontostand ist vorübergehend nicht verfügbar.',
  bonusRedeemOptionsUnavailable: 'Bonusoptionen sind vorübergehend nicht verfügbar.',
  bonusRulesUnavailable: 'Programme zum Erhalten von Boni sind vorübergehend nicht verfügbar.',
  bonusHistoryUnavailable: 'Der Bonusverlauf ist vorübergehend nicht verfügbar.',
  bonusSubscriptionUnavailable: 'Der Abonnementstatus ist vorübergehend nicht verfügbar.',
  bonusRedeemStateUnavailable:
    'Die Verwendung von Boni kann derzeit nicht geprüft werden. Bitte erneut versuchen.',
  bonusOptionUnavailable: 'Diese Option ist vorübergehend nicht verfügbar.',
  bonusRedeemInsufficient:
    'Nicht genügend verfügbare Boni. Der Kontostand könnte sich geändert haben.',
  bonusRedeemOptionUnavailable:
    'Diese Bonusoption ist nicht mehr verfügbar. Aktualisieren und erneut auswählen.',
  bonusRedeemUnknownOutcome:
    'Das Ergebnis konnte nicht bestätigt werden. Sicher erneut versuchen; dieselbe Anfrage wird nicht doppelt berechnet.',
  bonusRedeemFailed: 'Boni konnten nicht verwendet werden. Bitte erneut versuchen.',
  bonusShowMore: 'Mehr anzeigen',
  bonusHistoryLoadMoreError:
    'Weiterer Verlauf konnte nicht geladen werden. Bitte erneut versuchen.',
  bonusBenefitsTitle: 'Das Abonnement umfasst',
  bonusBenefitMorePrivateSaves: 'Mehr privat gespeicherte Texte',
  bonusBenefitLongerHistory: 'Längerer privater Leseverlauf',
  bonusBenefitAdvancedReading: 'Erweiterte Leseeinstellungen',
  bonusBenefitThemes: 'Zusätzliche Lesethemen',
  bonusBenefitExport: 'Export gespeicherter Texte',
  bonusBenefitEarlyAccess: 'Früher Zugriff auf Lesemodi',
  bonusBenefitPrioritySupport: 'Bevorzugter Support',
  bonusRewardSafetyReport: 'Bestätigter Sicherheitsbericht',
  bonusRuleSafetyReports: 'Ein bestätigter Sicherheitsbericht kann nach Prüfung Boni erhalten.',
  bonusRewardSupportFeedback: 'Bestätigtes Support-Feedback',
  bonusRuleSupportFeedback: 'Nützliches Feedback zum Support kann nach Prüfung Boni erhalten.',
};
const FR: AccountMessages = {
  title: 'Compte',
  eyebrow: 'Compte privé',
  headline: 'Compte',
  intro: 'Gérez votre compte.',
  home: 'Compte',
  login: 'Connexion',
  register: 'Créer un compte',
  recover: 'Récupérer le compte',
  texts: 'Mes textes',
  saved: 'Enregistrés',
  recent: 'Récemment lus',
  reading: 'Lecture',
  translations: 'Traductions',
  bonus: 'Bonus',
  support: 'Support',
  security: 'Sécurité',
  settings: 'Réglages',
  accountNotProfile:
    'Le compte sert au contrôle, pas à la publicité. Votre pseudonyme n’est pas affiché comme nom d’auteur.',
  loading: 'Chargement…',
  empty: 'Rien à afficher pour le moment.',
  error: 'Une erreur est survenue. Réessayez.',
  success: 'Enregistré.',
  submit: 'Envoyer',
  save: 'Enregistrer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  close: 'Fermer',
  refresh: 'Actualiser',
  password: 'Mot de passe',
  currentPassword: 'Mot de passe actuel',
  newPassword: 'Nouveau mot de passe',
  pseudonym: 'Pseudonyme',
  emailOptional: 'E-mail, facultatif',
  recoveryKey: 'Clé de récupération',
  copy: 'Copier',
  download: 'Télécharger',
  status: 'Statut',
  language: 'Langue',
  created: 'Créé',
  updated: 'Mis à jour',
  published: 'Publié',
  open: 'Ouvrir',
  manage: 'Gérer',
  remove: 'Retirer',
  clear: 'Effacer',
  enabled: 'Activé',
  disabled: 'Désactivé',
  interfaceLanguage: 'Langue de l’interface',
  theme: 'Thème',
  notifications: 'Notifications',
  privacy: 'Confidentialité',
  data: 'Données',
  savedTextsIntro:
    'Les textes enregistrés sont privés. Ce ne sont pas des likes publics et ils ne révèlent pas votre identité.',
  recentIntro: 'Les lectures récentes sont privées, effaçables et désactivables.',
  readingIntro:
    'Choisissez les langues de lecture et le mode doux. Ces réglages sont séparés de la langue de l’interface.',
  translationsIntro:
    'Contrôlez le consentement et le statut des traductions de vos textes. Les traductions ne sont pas créées immédiatement.',
  supportIntro: 'Créez et suivez des demandes de support privées.',
  securityIntro:
    'Gérez les sessions, la récupération, l’e-mail et les actions sensibles du compte.',
  settingsIntro:
    'Réglages généraux du compte : langue, thème, notifications, confidentialité et données.',
  loginIntro: 'Saisissez vos accès.',
  registerIntro: 'Choisissez vos accès.',
  recoverIntro: 'Restaurez l’accès.',
  textsIntro: 'Les textes liés à votre compte restent anonymes pour les lecteurs.',
  noPublicProfile: 'Pas de profil public, pas d’abonnés, pas d’avatar, pas de page auteur.',
  handleTaken: 'Ce pseudonyme est indisponible.',
  pseudonymSuggestions: 'Choisissez une option :',
  pseudonymRules: '6-20 caractères : lettres, chiffres, point, tiret ou tiret bas.',
  pseudonymLength: 'Utilisez 6-20 caractères.',
  pseudonymFormat: 'Utilisez lettres, chiffres, point, tiret ou tiret bas.',
  pseudonymReserved: 'Choisissez un autre pseudonyme.',
  pseudonymRequired: 'Saisissez un pseudonyme.',
  securityHold: 'Cette action est temporairement protégée après un nouvel appareil ou réseau.',
  logout: 'Déconnexion',
  logoutAll: 'Déconnecter partout',
  sessions: 'Sessions',
  devices: 'Appareils',
  createRecoveryKey: 'Créer une clé de récupération',
  recoveryKeyWarning:
    'Sans clé de récupération, vous ne pourrez pas récupérer ce compte si vous oubliez le mot de passe.',
  recoveryKeyRotatedAfterRecovery:
    'Après la récupération, une nouvelle clé de récupération sera fournie.',
  replaceRecoveryKey: 'Remplacer la clé de récupération',
  changeEmail: 'Changer l’e-mail',
  removeEmail: 'Supprimer l’e-mail',
  exportData: 'Demander l’export des données',
  deleteAccount: 'Demander la suppression du compte',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Ajouter un texte par lien',
  claimText: 'Enregistrer le texte dans le compte',
  timingTooFast: 'Patientez quelques secondes, puis réessayez.',
  managementLink: 'Lien de gestion',
  supportCategory: 'Catégorie',
  message: 'Message',
  ticket: 'Demande',
  newTicket: 'Nouvelle demande',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'La demande d’assistance a été fermée depuis le compte.',
  supportUnreadMessages: '{count} messages d’assistance non lus',
  supportLiveActive: 'Mises à jour en direct actives',
  supportLiveReconnecting: 'Reconnexion aux mises à jour en direct…',
  supportMessageClosedBySupport:
    'La demande d’assistance a été fermée par l’assistance. Motif : {reason}',
  supportMessageStatusChanged: 'Le statut de la demande d’assistance est passé à {status}.',
  supportCloseReasonClosedBySupport: 'fermée par l’assistance',
  supportCloseReasonClosedByAccount: 'fermée depuis le compte',
  supportActorYou: 'Vous',
  supportActorSupport: 'Assistance',
  supportActorSystem: 'Système',
  supportStatusNew: 'Nouvelle',
  supportStatusOpen: 'Ouverte',
  supportStatusWaitingSupport: 'En attente de l’assistance',
  supportStatusWaitingUser: 'En attente de votre réponse',
  supportStatusResolved: 'Résolue',
  supportStatusClosed: 'Fermée',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Démarrer la récupération',
  completeRecovery: 'Terminer la récupération',
  savedPrivate: 'Vous seul pouvez voir cette liste.',
  recentPrivate: 'L’historique de lecture n’est pas montré aux auteurs ni aux autres utilisateurs.',
  translationsPrivate: 'Les contrôles de traduction ne révèlent pas l’auteur.',
  settingsSaved: 'Réglages enregistrés.',
  bonusIntro:
    'Utilisez les bonus dans Quaom. Ils sont accordés uniquement pour une aide confirmée et ne peuvent pas être retirés.',
  bonusBalance: 'Solde',
  bonusAvailable: 'Disponible',
  bonusPending: 'En vérification',
  bonusLocked: 'Bloqué',
  bonusHistory: 'Historique',
  bonusRules: 'Règles',
  bonusHowToGet: 'Comment obtenir des bonus',
  bonusSpend: 'Dépenser les bonus',
  bonusSubscription: 'Abonnement',
  bonusSubscriptionActive: 'Abonnement actif',
  bonusSubscriptionInactive: 'Aucun abonnement actif',
  bonusRedeemOptions: 'Utiliser les bonus',
  bonusRedeem: 'Utiliser les bonus',
  bonusNoCashOut: 'Les bonus ne peuvent pas être retirés ni transférés.',
  bonusNoTextRewards: 'Les textes, vues, enregistrements et émotions ne donnent pas de bonus.',
  bonusHelpOnly:
    'Seule une aide confirmée concernant des signalements, traductions, bugs ou retours d’interface peut donner des bonus.',
  bonusRuleConfirmedReports: 'Les signalements utiles confirmés peuvent donner des bonus.',
  bonusRuleTranslationIssues:
    'Les problèmes de traduction ou de langue confirmés peuvent donner des bonus.',
  bonusRuleBugReports: 'Les bugs techniques confirmés peuvent donner des bonus.',
  bonusRuleUiFeedback: 'Un retour utile sur l’interface peut donner des bonus après vérification.',
  bonusCannotWithdraw: 'Les bonus ne sont pas de l’argent et ne peuvent pas être payés.',
  bonusAccountOnly: 'Les bonus existent uniquement dans votre compte privé.',
  bonusRedeemSecurityHold:
    'L’utilisation des bonus est temporairement protégée après un nouvel appareil ou réseau.',
  bonusSubscriptionExpires: 'Expire',
  bonusCredits: 'bonus',
  bonusPlan7Days: '7 jours',
  bonusPlan30Days: '30 jours',
  bonusSpent: 'Dépensé',
  bonusEarned: 'Obtenu',
  bonusPendingReview: 'En attente de vérification',
  bonusRulesIntro:
    'Les règles de bonus protègent Quaom contre la transformation des textes personnels en scène rémunérée.',
  bonusActivate: 'Activer',
  bonusNeedMore: 'Il manque',
  bonusConfirmActivation: 'Confirmer l’activation',
  bonusWillSpend: 'Sera débité',
  bonusRemaining: 'Restera',
  bonusProgramsUnavailable: 'L’attribution de bonus est temporairement indisponible.',
  bonusUpTo: 'Jusqu’à',
  bonusContactSupport: 'Contacter l’assistance',
  bonusTerms: 'Conditions',
  bonusHistoryEmpty: 'Aucune opération de bonus pour le moment.',
  bonusHistoryRejected: 'Refusé',
  bonusHistoryReturned: 'Restitué',
  bonusHistoryExpired: 'Expiré',
  bonusHistoryLocked: 'Temporairement bloqué',
  bonusRewardConfirmedReport: 'Signalement utile confirmé',
  bonusRewardTranslationIssue: 'Problème de traduction confirmé',
  bonusRewardBugReport: 'Bug technique confirmé',
  bonusRewardUiFeedback: 'Retour d’interface confirmé',
  invalidPassword: 'Mot de passe incorrect.',
  passwordRules:
    'Utilisez 10 à 32 caractères : lettres latines et chiffres uniquement, avec au moins une minuscule, une majuscule et un chiffre.',
  passwordRequired: 'Saisissez un mot de passe.',
  passwordLength: 'Utilisez 10 à 32 caractères pour le mot de passe.',
  passwordLatinOnly:
    'Utilisez uniquement des lettres latines et des chiffres dans le mot de passe.',
  passwordLowercase: 'Ajoutez au moins une lettre latine minuscule au mot de passe.',
  passwordUppercase: 'Ajoutez au moins une lettre latine majuscule au mot de passe.',
  passwordDigit: 'Ajoutez au moins un chiffre au mot de passe.',
  showPassword: 'Afficher le mot de passe',
  hidePassword: 'Masquer le mot de passe',
  showRecoveryKey: 'Afficher la clé de récupération',
  hideRecoveryKey: 'Masquer la clé de récupération',
  generatePassword: 'Générer un mot de passe',
  copied: 'Copié.',
  downloaded: 'Téléchargé.',
  recoveryFileWarning:
    'Conservez ce fichier dans un endroit privé. La clé de récupération peut aider à rétablir l’accès au compte.',
  accountNotFound: 'Compte introuvable.',
  supportMessageTooManyRepeats: 'Le message contient trop de caractères identiques à la suite.',
  supportMessageWordTooLong: 'Un mot du message est trop long.',
  supportMessageTooManyUrls: 'Le message contient trop de liens.',
  supportMessageTooShort: 'Le message est trop court.',
  supportMessageTooLong: 'Le message est trop long.',
  tooManyAttempts: 'Trop de tentatives. Patientez un peu puis réessayez.',
  securityHoldShort: 'Temporairement limité.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Événement',
  securityTime: 'Heure',
  securitySeverityInfo: 'Information',
  securitySeverityImportant: 'Important',
  securitySeverityWarning: 'Avertissement',
  securityEventSensitiveActionAuthorized: 'Action protégée confirmée',
  securityEventSensitiveActionPasswordFailed: 'Échec de la confirmation du mot de passe',
  securityEventSensitiveActionBlockedHold: 'Action bloquée par la protection temporaire',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Temporairement indisponible.',
  bonusPartialLoadError:
    'Certaines données de bonus n’ont pas pu être chargées. Les sections disponibles restent utilisables.',
  bonusRetry: 'Réessayer',
  bonusBalanceUnavailable: 'Le solde est temporairement indisponible.',
  bonusRedeemOptionsUnavailable: 'Les options de bonus sont temporairement indisponibles.',
  bonusRulesUnavailable:
    'Les programmes permettant d’obtenir des bonus sont temporairement indisponibles.',
  bonusHistoryUnavailable: 'L’historique des bonus est temporairement indisponible.',
  bonusSubscriptionUnavailable: 'Le statut de l’abonnement est temporairement indisponible.',
  bonusRedeemStateUnavailable:
    'L’utilisation des bonus ne peut pas être vérifiée pour le moment. Réessayez.',
  bonusOptionUnavailable: 'Cette option est temporairement indisponible.',
  bonusRedeemInsufficient: 'Pas assez de bonus disponibles. Votre solde a peut-être changé.',
  bonusRedeemOptionUnavailable:
    'Cette option de bonus n’est plus disponible. Actualisez et choisissez à nouveau.',
  bonusRedeemUnknownOutcome:
    'Le résultat n’a pas pu être confirmé. Réessayez sans risque : la même demande ne sera pas débitée deux fois.',
  bonusRedeemFailed: 'Impossible d’utiliser les bonus. Réessayez.',
  bonusShowMore: 'Afficher plus',
  bonusHistoryLoadMoreError: 'Impossible de charger plus d’historique. Réessayez.',
  bonusBenefitsTitle: 'L’abonnement comprend',
  bonusBenefitMorePrivateSaves: 'Plus de textes enregistrés en privé',
  bonusBenefitLongerHistory: 'Historique de lecture privé plus long',
  bonusBenefitAdvancedReading: 'Paramètres de lecture avancés',
  bonusBenefitThemes: 'Thèmes de lecture supplémentaires',
  bonusBenefitExport: 'Export des textes enregistrés',
  bonusBenefitEarlyAccess: 'Accès anticipé aux modes de lecture',
  bonusBenefitPrioritySupport: 'Assistance prioritaire',
  bonusRewardSafetyReport: 'Signalement de sécurité confirmé',
  bonusRuleSafetyReports:
    'Un signalement de sécurité confirmé peut donner des bonus après vérification.',
  bonusRewardSupportFeedback: 'Avis sur l’assistance confirmé',
  bonusRuleSupportFeedback:
    'Un avis utile sur l’assistance peut donner des bonus après vérification.',
};
const ES: AccountMessages = {
  title: 'Cuenta',
  eyebrow: 'Cuenta privada',
  headline: 'Cuenta',
  intro: 'Gestiona tu cuenta.',
  home: 'Cuenta',
  login: 'Iniciar sesión',
  register: 'Crear cuenta',
  recover: 'Recuperar cuenta',
  texts: 'Mis textos',
  saved: 'Guardados',
  recent: 'Leídos recientemente',
  reading: 'Lectura',
  translations: 'Traducciones',
  bonus: 'Bonos',
  support: 'Soporte',
  security: 'Seguridad',
  settings: 'Ajustes',
  accountNotProfile:
    'La cuenta es para control, no para publicidad. Tu seudónimo no se muestra como nombre de autor.',
  loading: 'Cargando…',
  empty: 'Aún no hay nada que mostrar.',
  error: 'Algo salió mal. Inténtalo de nuevo.',
  success: 'Guardado.',
  submit: 'Enviar',
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  close: 'Cerrar',
  refresh: 'Actualizar',
  password: 'Contraseña',
  currentPassword: 'Contraseña actual',
  newPassword: 'Nueva contraseña',
  pseudonym: 'Seudónimo',
  emailOptional: 'Email, opcional',
  recoveryKey: 'Clave de recuperación',
  copy: 'Copiar',
  download: 'Descargar',
  status: 'Estado',
  language: 'Idioma',
  created: 'Creado',
  updated: 'Actualizado',
  published: 'Publicado',
  open: 'Abrir',
  manage: 'Gestionar',
  remove: 'Quitar',
  clear: 'Borrar',
  enabled: 'Activado',
  disabled: 'Desactivado',
  interfaceLanguage: 'Idioma de la interfaz',
  theme: 'Tema',
  notifications: 'Notificaciones',
  privacy: 'Privacidad',
  data: 'Datos',
  savedTextsIntro:
    'Los textos guardados son privados. No son likes públicos y no exponen tu identidad.',
  recentIntro: 'Leídos recientemente es privado, se puede borrar y desactivar.',
  readingIntro:
    'Elige idiomas de lectura y modo suave. Estos ajustes están separados del idioma de la interfaz.',
  translationsIntro:
    'Controla el consentimiento y el estado de traducciones de tus textos. Las traducciones no se crean de inmediato.',
  supportIntro: 'Crea y sigue solicitudes privadas de soporte.',
  securityIntro: 'Gestiona sesiones, recuperación, email y acciones sensibles de la cuenta.',
  settingsIntro:
    'Ajustes generales de la cuenta: idioma, tema, notificaciones, privacidad y datos.',
  loginIntro: 'Introduce tus datos de acceso.',
  registerIntro: 'Elige tus datos de acceso.',
  recoverIntro: 'Recupera el acceso.',
  textsIntro: 'Los textos vinculados a tu cuenta siguen siendo anónimos para los lectores.',
  noPublicProfile: 'Sin perfil público, seguidores, avatar ni página de autor.',
  handleTaken: 'Este seudónimo no está disponible.',
  pseudonymSuggestions: 'Elige una de estas opciones:',
  pseudonymRules: '6-20 caracteres: letras, números, punto, guion o guion bajo.',
  pseudonymLength: 'Usa 6-20 caracteres.',
  pseudonymFormat: 'Usa letras, números, punto, guion o guion bajo.',
  pseudonymReserved: 'Elige otro seudónimo.',
  pseudonymRequired: 'Introduce un seudónimo.',
  securityHold: 'Esta acción está protegida temporalmente después de un nuevo dispositivo o red.',
  logout: 'Cerrar sesión',
  logoutAll: 'Cerrar sesión en todas partes',
  sessions: 'Sesiones',
  devices: 'Dispositivos',
  createRecoveryKey: 'Crear clave de recuperación',
  recoveryKeyWarning:
    'Sin una clave de recuperación, no podrás recuperar esta cuenta si olvidas la contraseña.',
  recoveryKeyRotatedAfterRecovery:
    'Después de recuperar el acceso, se emitirá una nueva clave de recuperación.',
  replaceRecoveryKey: 'Reemplazar clave de recuperación',
  changeEmail: 'Cambiar email',
  removeEmail: 'Eliminar email',
  exportData: 'Solicitar exportación de datos',
  deleteAccount: 'Solicitar eliminación de cuenta',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Añadir texto por enlace',
  claimText: 'Guardar texto en la cuenta',
  timingTooFast: 'Espera unos segundos e inténtalo de nuevo.',
  managementLink: 'Enlace de gestión',
  supportCategory: 'Categoría',
  message: 'Mensaje',
  ticket: 'Solicitud',
  newTicket: 'Nueva solicitud',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'La solicitud de soporte se cerró desde la cuenta.',
  supportUnreadMessages: '{count} mensajes de soporte sin leer',
  supportLiveActive: 'Actualizaciones en directo activas',
  supportLiveReconnecting: 'Reconectando las actualizaciones en directo…',
  supportMessageClosedBySupport:
    'La solicitud de soporte fue cerrada por soporte. Motivo: {reason}',
  supportMessageStatusChanged: 'El estado de la solicitud de soporte cambió a {status}.',
  supportCloseReasonClosedBySupport: 'cerrada por soporte',
  supportCloseReasonClosedByAccount: 'cerrada desde la cuenta',
  supportActorYou: 'Tú',
  supportActorSupport: 'Soporte',
  supportActorSystem: 'Sistema',
  supportStatusNew: 'Nueva',
  supportStatusOpen: 'Abierta',
  supportStatusWaitingSupport: 'En espera de soporte',
  supportStatusWaitingUser: 'En espera de tu respuesta',
  supportStatusResolved: 'Resuelta',
  supportStatusClosed: 'Cerrada',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Iniciar recuperación',
  completeRecovery: 'Completar recuperación',
  savedPrivate: 'Solo tú puedes ver esta lista.',
  recentPrivate: 'El historial de lectura no se muestra a autores ni a otros usuarios.',
  translationsPrivate: 'Los controles de traducción no revelan autoría.',
  settingsSaved: 'Ajustes guardados.',
  bonusIntro:
    'Usa bonos dentro de Quaom. Solo se obtienen por ayuda confirmada y no se pueden retirar.',
  bonusBalance: 'Saldo',
  bonusAvailable: 'Disponible',
  bonusPending: 'En revisión',
  bonusLocked: 'Bloqueado',
  bonusHistory: 'Historial',
  bonusRules: 'Reglas',
  bonusHowToGet: 'Cómo obtener bonos',
  bonusSpend: 'Gastar bonos',
  bonusSubscription: 'Suscripción',
  bonusSubscriptionActive: 'Suscripción activa',
  bonusSubscriptionInactive: 'Sin suscripción activa',
  bonusRedeemOptions: 'Usar bonos',
  bonusRedeem: 'Usar bonos',
  bonusNoCashOut: 'Los bonos no se pueden retirar ni transferir.',
  bonusNoTextRewards: 'Los textos, vistas, guardados y emociones no generan bonos.',
  bonusHelpOnly:
    'Solo la ayuda confirmada con reportes, traducciones, errores o comentarios de interfaz puede generar bonos.',
  bonusRuleConfirmedReports: 'Los reportes útiles confirmados pueden generar bonos.',
  bonusRuleTranslationIssues:
    'Los problemas confirmados de traducción o idioma pueden generar bonos.',
  bonusRuleBugReports: 'Los errores técnicos confirmados pueden generar bonos.',
  bonusRuleUiFeedback:
    'Los comentarios útiles sobre la interfaz pueden generar bonos tras revisión.',
  bonusCannotWithdraw: 'Los bonos no son dinero y no se pueden pagar.',
  bonusAccountOnly: 'Los bonos existen solo dentro de tu cuenta privada.',
  bonusRedeemSecurityHold:
    'El gasto de bonos está protegido temporalmente tras un nuevo dispositivo o red.',
  bonusSubscriptionExpires: 'Expira',
  bonusCredits: 'bonos',
  bonusPlan7Days: '7 días',
  bonusPlan30Days: '30 días',
  bonusSpent: 'Gastado',
  bonusEarned: 'Obtenido',
  bonusPendingReview: 'Pendiente de revisión',
  bonusRulesIntro:
    'Las reglas de bonos protegen a Quaom de convertir textos personales en un escenario pagado.',
  bonusActivate: 'Activar',
  bonusNeedMore: 'Faltan',
  bonusConfirmActivation: 'Confirmar activación',
  bonusWillSpend: 'Se descontarán',
  bonusRemaining: 'Quedarán',
  bonusProgramsUnavailable: 'La concesión de bonos no está disponible temporalmente.',
  bonusUpTo: 'Hasta',
  bonusContactSupport: 'Contactar con soporte',
  bonusTerms: 'Condiciones',
  bonusHistoryEmpty: 'Todavía no hay movimientos de bonos.',
  bonusHistoryRejected: 'Rechazado',
  bonusHistoryReturned: 'Devuelto',
  bonusHistoryExpired: 'Caducado',
  bonusHistoryLocked: 'Bloqueado temporalmente',
  bonusRewardConfirmedReport: 'Reporte útil confirmado',
  bonusRewardTranslationIssue: 'Problema de traducción confirmado',
  bonusRewardBugReport: 'Error técnico confirmado',
  bonusRewardUiFeedback: 'Comentario de interfaz confirmado',
  invalidPassword: 'Contraseña incorrecta.',
  passwordRules:
    'Usa 10-32 caracteres: solo letras latinas y números, con al menos una minúscula, una mayúscula y un número.',
  passwordRequired: 'Introduce una contraseña.',
  passwordLength: 'Usa 10-32 caracteres para la contraseña.',
  passwordLatinOnly: 'Usa solo letras latinas y números en la contraseña.',
  passwordLowercase: 'Añade al menos una letra latina minúscula a la contraseña.',
  passwordUppercase: 'Añade al menos una letra latina mayúscula a la contraseña.',
  passwordDigit: 'Añade al menos un número a la contraseña.',
  showPassword: 'Mostrar contraseña',
  hidePassword: 'Ocultar contraseña',
  showRecoveryKey: 'Mostrar clave de recuperación',
  hideRecoveryKey: 'Ocultar clave de recuperación',
  generatePassword: 'Generar contraseña',
  copied: 'Copiado.',
  downloaded: 'Descargado.',
  recoveryFileWarning:
    'Guarde este archivo en un lugar privado. La clave de recuperación puede ayudar a recuperar el acceso a la cuenta.',
  accountNotFound: 'Cuenta no encontrada.',
  supportMessageTooManyRepeats: 'El mensaje contiene demasiados caracteres idénticos seguidos.',
  supportMessageWordTooLong: 'Una palabra del mensaje es demasiado larga.',
  supportMessageTooManyUrls: 'El mensaje contiene demasiados enlaces.',
  supportMessageTooShort: 'El mensaje es demasiado corto.',
  supportMessageTooLong: 'El mensaje es demasiado largo.',
  tooManyAttempts: 'Demasiados intentos. Espera un poco e inténtalo de nuevo.',
  securityHoldShort: 'Limitado temporalmente.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Evento',
  securityTime: 'Hora',
  securitySeverityInfo: 'Información',
  securitySeverityImportant: 'Importante',
  securitySeverityWarning: 'Advertencia',
  securityEventSensitiveActionAuthorized: 'Acción protegida confirmada',
  securityEventSensitiveActionPasswordFailed: 'Falló la confirmación de la contraseña',
  securityEventSensitiveActionBlockedHold: 'Acción bloqueada por la protección temporal',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'No disponible temporalmente.',
  bonusPartialLoadError:
    'No se pudieron cargar algunos datos de bonos. Las secciones disponibles siguen funcionando.',
  bonusRetry: 'Intentar de nuevo',
  bonusBalanceUnavailable: 'El saldo no está disponible temporalmente.',
  bonusRedeemOptionsUnavailable: 'Las opciones de bonos no están disponibles temporalmente.',
  bonusRulesUnavailable: 'Los programas para obtener bonos no están disponibles temporalmente.',
  bonusHistoryUnavailable: 'El historial de bonos no está disponible temporalmente.',
  bonusSubscriptionUnavailable: 'El estado de la suscripción no está disponible temporalmente.',
  bonusRedeemStateUnavailable: 'No se puede verificar el uso de bonos ahora. Inténtalo de nuevo.',
  bonusOptionUnavailable: 'Esta opción no está disponible temporalmente.',
  bonusRedeemInsufficient:
    'No hay suficientes bonos disponibles. Es posible que el saldo haya cambiado.',
  bonusRedeemOptionUnavailable:
    'Esta opción de bonos ya no está disponible. Actualiza y vuelve a elegir.',
  bonusRedeemUnknownOutcome:
    'No pudimos confirmar el resultado. Reintenta con seguridad; la misma solicitud no se cobrará dos veces.',
  bonusRedeemFailed: 'No se pudieron usar los bonos. Inténtalo de nuevo.',
  bonusShowMore: 'Mostrar más',
  bonusHistoryLoadMoreError: 'No se pudo cargar más historial. Inténtalo de nuevo.',
  bonusBenefitsTitle: 'La suscripción incluye',
  bonusBenefitMorePrivateSaves: 'Más textos guardados de forma privada',
  bonusBenefitLongerHistory: 'Historial privado de lectura más largo',
  bonusBenefitAdvancedReading: 'Ajustes avanzados de lectura',
  bonusBenefitThemes: 'Temas de lectura adicionales',
  bonusBenefitExport: 'Exportación de textos guardados',
  bonusBenefitEarlyAccess: 'Acceso anticipado a modos de lectura',
  bonusBenefitPrioritySupport: 'Soporte prioritario',
  bonusRewardSafetyReport: 'Informe de seguridad confirmado',
  bonusRuleSafetyReports:
    'Un informe de seguridad confirmado puede otorgar bonos tras la revisión.',
  bonusRewardSupportFeedback: 'Comentario de soporte confirmado',
  bonusRuleSupportFeedback:
    'Un comentario útil sobre el soporte puede otorgar bonos tras la revisión.',
};
const IT: AccountMessages = {
  title: 'Account',
  eyebrow: 'Account privato',
  headline: 'Account',
  intro: 'Gestisci il tuo account.',
  home: 'Account',
  login: 'Accedi',
  register: 'Crea account',
  recover: 'Recupera account',
  texts: 'I miei testi',
  saved: 'Salvati',
  recent: 'Letti di recente',
  reading: 'Lettura',
  translations: 'Traduzioni',
  bonus: 'Bonus',
  support: 'Supporto',
  security: 'Sicurezza',
  settings: 'Impostazioni',
  accountNotProfile:
    'L’account serve al controllo, non alla visibilità pubblica. Il tuo pseudonimo non viene mostrato come nome autore.',
  loading: 'Caricamento…',
  empty: 'Ancora nulla da mostrare.',
  error: 'Qualcosa è andato storto. Riprova.',
  success: 'Salvato.',
  submit: 'Invia',
  save: 'Salva',
  cancel: 'Annulla',
  delete: 'Elimina',
  close: 'Chiudi',
  refresh: 'Aggiorna',
  password: 'Password',
  currentPassword: 'Password attuale',
  newPassword: 'Nuova password',
  pseudonym: 'Pseudonimo',
  emailOptional: 'Email, opzionale',
  recoveryKey: 'Chiave di recupero',
  copy: 'Copia',
  download: 'Scarica',
  status: 'Stato',
  language: 'Lingua',
  created: 'Creato',
  updated: 'Aggiornato',
  published: 'Pubblicato',
  open: 'Apri',
  manage: 'Gestisci',
  remove: 'Rimuovi',
  clear: 'Cancella',
  enabled: 'Attivo',
  disabled: 'Disattivo',
  interfaceLanguage: 'Lingua interfaccia',
  theme: 'Tema',
  notifications: 'Notifiche',
  privacy: 'Privacy',
  data: 'Dati',
  savedTextsIntro:
    'I testi salvati sono privati. Non sono like pubblici e non espongono la tua identità.',
  recentIntro: 'Letti di recente è privato, cancellabile e disattivabile.',
  readingIntro:
    'Scegli lingue di lettura e modalità morbida. Queste impostazioni sono separate dalla lingua dell’interfaccia.',
  translationsIntro:
    'Controlla consenso e stato delle traduzioni dei tuoi testi. Le traduzioni non vengono create subito.',
  supportIntro: 'Crea e segui richieste private di supporto.',
  securityIntro: 'Gestisci sessioni, recupero, email e azioni sensibili dell’account.',
  settingsIntro: 'Impostazioni generali: lingua, tema, notifiche, privacy e dati.',
  loginIntro: 'Inserisci i dati di accesso.',
  registerIntro: 'Scegli i dati di accesso.',
  recoverIntro: 'Ripristina l’accesso.',
  textsIntro: 'I testi collegati al tuo account restano anonimi per i lettori.',
  noPublicProfile: 'Nessun profilo pubblico, follower, avatar o pagina autore.',
  handleTaken: 'Questo pseudonimo non è disponibile.',
  pseudonymSuggestions: 'Scegli una di queste opzioni:',
  pseudonymRules: '6-20 caratteri: lettere, numeri, punto, trattino o underscore.',
  pseudonymLength: 'Usa 6-20 caratteri.',
  pseudonymFormat: 'Usa lettere, numeri, punto, trattino o underscore.',
  pseudonymReserved: 'Scegli un altro pseudonimo.',
  pseudonymRequired: 'Inserisci uno pseudonimo.',
  securityHold: 'Questa azione è temporaneamente protetta dopo un nuovo dispositivo o rete.',
  logout: 'Esci',
  logoutAll: 'Esci ovunque',
  sessions: 'Sessioni',
  devices: 'Dispositivi',
  createRecoveryKey: 'Crea chiave di recupero',
  recoveryKeyWarning:
    'Senza una chiave di recupero, non potrai recuperare questo account se dimentichi la password.',
  recoveryKeyRotatedAfterRecovery: 'Dopo il ripristino verrà emessa una nuova chiave di recupero.',
  replaceRecoveryKey: 'Sostituisci chiave di recupero',
  changeEmail: 'Cambia email',
  removeEmail: 'Rimuovi email',
  exportData: 'Richiedi esportazione dati',
  deleteAccount: 'Richiedi eliminazione account',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Aggiungi testo tramite link',
  claimText: 'Salva testo nell’account',
  timingTooFast: 'Attendi qualche secondo e riprova.',
  managementLink: 'Link di gestione',
  supportCategory: 'Categoria',
  message: 'Messaggio',
  ticket: 'Richiesta',
  newTicket: 'Nuova richiesta',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'La richiesta di assistenza è stata chiusa dall’account.',
  supportUnreadMessages: '{count} messaggi di assistenza non letti',
  supportLiveActive: 'Aggiornamenti in tempo reale attivi',
  supportLiveReconnecting: 'Riconnessione agli aggiornamenti in tempo reale…',
  supportMessageClosedBySupport:
    'La richiesta di assistenza è stata chiusa dal supporto. Motivo: {reason}',
  supportMessageStatusChanged:
    'Lo stato della richiesta di assistenza è stato impostato su {status}.',
  supportCloseReasonClosedBySupport: 'chiusa dal supporto',
  supportCloseReasonClosedByAccount: 'chiusa dall’account',
  supportActorYou: 'Tu',
  supportActorSupport: 'Supporto',
  supportActorSystem: 'Sistema',
  supportStatusNew: 'Nuova',
  supportStatusOpen: 'Aperta',
  supportStatusWaitingSupport: 'In attesa del supporto',
  supportStatusWaitingUser: 'In attesa della tua risposta',
  supportStatusResolved: 'Risolta',
  supportStatusClosed: 'Chiusa',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Avvia recupero',
  completeRecovery: 'Completa recupero',
  savedPrivate: 'Solo tu puoi vedere questa lista.',
  recentPrivate: 'La cronologia lettura non è mostrata ad autori o altri utenti.',
  translationsPrivate: 'I controlli traduzione non rivelano l’autore.',
  settingsSaved: 'Impostazioni salvate.',
  bonusIntro:
    'Usa i bonus dentro Quaom. Si ottengono solo per aiuto confermato e non possono essere prelevati.',
  bonusBalance: 'Saldo',
  bonusAvailable: 'Disponibili',
  bonusPending: 'In revisione',
  bonusLocked: 'Bloccati',
  bonusHistory: 'Cronologia',
  bonusRules: 'Regole',
  bonusHowToGet: 'Come ottenere bonus',
  bonusSpend: 'Spendere bonus',
  bonusSubscription: 'Abbonamento',
  bonusSubscriptionActive: 'Abbonamento attivo',
  bonusSubscriptionInactive: 'Nessun abbonamento attivo',
  bonusRedeemOptions: 'Usa bonus',
  bonusRedeem: 'Usa bonus',
  bonusNoCashOut: 'I bonus non possono essere prelevati o trasferiti.',
  bonusNoTextRewards: 'Testi, visualizzazioni, salvataggi ed emozioni non danno bonus.',
  bonusHelpOnly:
    'Solo l’aiuto confermato su segnalazioni, traduzioni, bug o feedback dell’interfaccia può dare bonus.',
  bonusRuleConfirmedReports: 'Le segnalazioni utili confermate possono dare bonus.',
  bonusRuleTranslationIssues: 'I problemi confermati di traduzione o lingua possono dare bonus.',
  bonusRuleBugReports: 'I bug tecnici confermati possono dare bonus.',
  bonusRuleUiFeedback: 'Un feedback utile sull’interfaccia può dare bonus dopo revisione.',
  bonusCannotWithdraw: 'I bonus non sono denaro e non possono essere pagati.',
  bonusAccountOnly: 'I bonus esistono solo nel tuo account privato.',
  bonusRedeemSecurityHold:
    'L’uso dei bonus è temporaneamente protetto dopo un nuovo dispositivo o rete.',
  bonusSubscriptionExpires: 'Scade',
  bonusCredits: 'bonus',
  bonusPlan7Days: '7 giorni',
  bonusPlan30Days: '30 giorni',
  bonusSpent: 'Spesi',
  bonusEarned: 'Ottenuti',
  bonusPendingReview: 'In attesa di revisione',
  bonusRulesIntro:
    'Le regole dei bonus impediscono a Quaom di trasformare i testi personali in un palco pagato.',
  bonusActivate: 'Attiva',
  bonusNeedMore: 'Mancano',
  bonusConfirmActivation: 'Conferma attivazione',
  bonusWillSpend: 'Verranno detratti',
  bonusRemaining: 'Rimarranno',
  bonusProgramsUnavailable: 'L’assegnazione dei bonus è temporaneamente non disponibile.',
  bonusUpTo: 'Fino a',
  bonusContactSupport: 'Contatta l’assistenza',
  bonusTerms: 'Condizioni',
  bonusHistoryEmpty: 'Non ci sono ancora movimenti di bonus.',
  bonusHistoryRejected: 'Rifiutato',
  bonusHistoryReturned: 'Restituito',
  bonusHistoryExpired: 'Scaduto',
  bonusHistoryLocked: 'Bloccato temporaneamente',
  bonusRewardConfirmedReport: 'Segnalazione utile confermata',
  bonusRewardTranslationIssue: 'Problema di traduzione confermato',
  bonusRewardBugReport: 'Errore tecnico confermato',
  bonusRewardUiFeedback: 'Feedback sull’interfaccia confermato',
  invalidPassword: 'Password errata.',
  passwordRules:
    'Usa 10-32 caratteri: solo lettere latine e numeri, con almeno una minuscola, una maiuscola e un numero.',
  passwordRequired: 'Inserisci una password.',
  passwordLength: 'Usa 10-32 caratteri per la password.',
  passwordLatinOnly: 'Usa solo lettere latine e numeri nella password.',
  passwordLowercase: 'Aggiungi almeno una lettera latina minuscola alla password.',
  passwordUppercase: 'Aggiungi almeno una lettera latina maiuscola alla password.',
  passwordDigit: 'Aggiungi almeno un numero alla password.',
  showPassword: 'Mostra password',
  hidePassword: 'Nascondi password',
  showRecoveryKey: 'Mostra chiave di recupero',
  hideRecoveryKey: 'Nascondi chiave di recupero',
  generatePassword: 'Genera password',
  copied: 'Copiato.',
  downloaded: 'Scaricato.',
  recoveryFileWarning:
    'Conserva questo file in un luogo privato. La chiave di recupero può aiutare a ripristinare l’accesso all’account.',
  accountNotFound: 'Account non trovato.',
  supportMessageTooManyRepeats: 'Il messaggio contiene troppi caratteri identici consecutivi.',
  supportMessageWordTooLong: 'Una parola nel messaggio è troppo lunga.',
  supportMessageTooManyUrls: 'Il messaggio contiene troppi link.',
  supportMessageTooShort: 'Il messaggio è troppo breve.',
  supportMessageTooLong: 'Il messaggio è troppo lungo.',
  tooManyAttempts: 'Troppi tentativi. Attendi un momento e riprova.',
  securityHoldShort: 'Temporaneamente limitato.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Evento',
  securityTime: 'Ora',
  securitySeverityInfo: 'Informazione',
  securitySeverityImportant: 'Importante',
  securitySeverityWarning: 'Avviso',
  securityEventSensitiveActionAuthorized: 'Azione protetta confermata',
  securityEventSensitiveActionPasswordFailed: 'Conferma della password non riuscita',
  securityEventSensitiveActionBlockedHold: 'Azione bloccata dalla protezione temporanea',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Temporaneamente non disponibile.',
  bonusPartialLoadError:
    'Non è stato possibile caricare alcuni dati dei bonus. Le sezioni disponibili restano utilizzabili.',
  bonusRetry: 'Riprova',
  bonusBalanceUnavailable: 'Il saldo è temporaneamente non disponibile.',
  bonusRedeemOptionsUnavailable: 'Le opzioni bonus sono temporaneamente non disponibili.',
  bonusRulesUnavailable: 'I programmi per ottenere bonus sono temporaneamente non disponibili.',
  bonusHistoryUnavailable: 'La cronologia dei bonus è temporaneamente non disponibile.',
  bonusSubscriptionUnavailable: 'Lo stato dell’abbonamento è temporaneamente non disponibile.',
  bonusRedeemStateUnavailable: 'Al momento non è possibile verificare l’uso dei bonus. Riprova.',
  bonusOptionUnavailable: 'Questa opzione è temporaneamente non disponibile.',
  bonusRedeemInsufficient: 'Bonus disponibili insufficienti. Il saldo potrebbe essere cambiato.',
  bonusRedeemOptionUnavailable:
    'Questa opzione bonus non è più disponibile. Aggiorna e scegli di nuovo.',
  bonusRedeemUnknownOutcome:
    'Non è stato possibile confermare il risultato. Riprova in sicurezza: la stessa richiesta non verrà addebitata due volte.',
  bonusRedeemFailed: 'Impossibile usare i bonus. Riprova.',
  bonusShowMore: 'Mostra altro',
  bonusHistoryLoadMoreError: 'Impossibile caricare altra cronologia. Riprova.',
  bonusBenefitsTitle: 'L’abbonamento include',
  bonusBenefitMorePrivateSaves: 'Più testi salvati privatamente',
  bonusBenefitLongerHistory: 'Cronologia privata di lettura più lunga',
  bonusBenefitAdvancedReading: 'Impostazioni di lettura avanzate',
  bonusBenefitThemes: 'Temi di lettura aggiuntivi',
  bonusBenefitExport: 'Esportazione dei testi salvati',
  bonusBenefitEarlyAccess: 'Accesso anticipato alle modalità di lettura',
  bonusBenefitPrioritySupport: 'Assistenza prioritaria',
  bonusRewardSafetyReport: 'Segnalazione di sicurezza confermata',
  bonusRuleSafetyReports:
    'Una segnalazione di sicurezza confermata può ottenere bonus dopo la verifica.',
  bonusRewardSupportFeedback: 'Feedback sull’assistenza confermato',
  bonusRuleSupportFeedback:
    'Un feedback utile sull’assistenza può ottenere bonus dopo la verifica.',
};
const PT: AccountMessages = {
  title: 'Conta',
  eyebrow: 'Conta privada',
  headline: 'Conta',
  intro: 'Gerencie sua conta.',
  home: 'Conta',
  login: 'Iniciar sessão',
  register: 'Criar conta',
  recover: 'Recuperar conta',
  texts: 'Os meus textos',
  saved: 'Guardados',
  recent: 'Lidos recentemente',
  reading: 'Leitura',
  translations: 'Traduções',
  bonus: 'Bónus',
  support: 'Apoio',
  security: 'Segurança',
  settings: 'Definições',
  accountNotProfile:
    'A conta é para controlo, não para publicidade. O pseudónimo não é mostrado como nome de autor.',
  loading: 'A carregar…',
  empty: 'Ainda não há nada para mostrar.',
  error: 'Algo correu mal. Tente novamente.',
  success: 'Guardado.',
  submit: 'Enviar',
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  close: 'Fechar',
  refresh: 'Atualizar',
  password: 'Palavra-passe',
  currentPassword: 'Palavra-passe atual',
  newPassword: 'Nova palavra-passe',
  pseudonym: 'Pseudónimo',
  emailOptional: 'Email, opcional',
  recoveryKey: 'Chave de recuperação',
  copy: 'Copiar',
  download: 'Transferir',
  status: 'Estado',
  language: 'Idioma',
  created: 'Criado',
  updated: 'Atualizado',
  published: 'Publicado',
  open: 'Abrir',
  manage: 'Gerir',
  remove: 'Remover',
  clear: 'Limpar',
  enabled: 'Ativado',
  disabled: 'Desativado',
  interfaceLanguage: 'Idioma da interface',
  theme: 'Tema',
  notifications: 'Notificações',
  privacy: 'Privacidade',
  data: 'Dados',
  savedTextsIntro:
    'Os textos guardados são privados. Não são gostos públicos e não expõem a sua identidade.',
  recentIntro: 'Lidos recentemente é privado, pode ser limpo e desativado.',
  readingIntro:
    'Escolha idiomas de leitura e modo suave. Estas definições são separadas do idioma da interface.',
  translationsIntro:
    'Controle o consentimento e o estado das traduções dos seus textos. As traduções não são criadas imediatamente.',
  supportIntro: 'Crie e acompanhe pedidos privados de apoio.',
  securityIntro: 'Gerir sessões, recuperação, email e ações sensíveis da conta.',
  settingsIntro: 'Definições gerais: idioma, tema, notificações, privacidade e dados.',
  loginIntro: 'Insira seus dados de acesso.',
  registerIntro: 'Escolha seus dados de acesso.',
  recoverIntro: 'Recupere o acesso.',
  textsIntro: 'Os textos ligados à sua conta continuam anónimos para leitores.',
  noPublicProfile: 'Sem perfil público, seguidores, avatar ou página de autor.',
  handleTaken: 'Este pseudónimo não está disponível.',
  pseudonymSuggestions: 'Escolha uma destas opções:',
  pseudonymRules: '6-20 caracteres: letras, números, ponto, hífen ou sublinhado.',
  pseudonymLength: 'Use 6-20 caracteres.',
  pseudonymFormat: 'Use letras, números, ponto, hífen ou sublinhado.',
  pseudonymReserved: 'Escolha outro pseudônimo.',
  pseudonymRequired: 'Insira um pseudônimo.',
  securityHold: 'Esta ação está temporariamente protegida após novo dispositivo ou rede.',
  logout: 'Terminar sessão',
  logoutAll: 'Terminar sessão em todo o lado',
  sessions: 'Sessões',
  devices: 'Dispositivos',
  createRecoveryKey: 'Criar chave de recuperação',
  recoveryKeyWarning:
    'Sem uma chave de recuperação, não será possível recuperar esta conta se você esquecer a senha.',
  recoveryKeyRotatedAfterRecovery:
    'Após a recuperação, uma nova chave de recuperação será emitida.',
  replaceRecoveryKey: 'Substituir chave de recuperação',
  changeEmail: 'Alterar email',
  removeEmail: 'Remover email',
  exportData: 'Pedir exportação de dados',
  deleteAccount: 'Pedir eliminação da conta',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Adicionar texto por ligação',
  claimText: 'Guardar texto na conta',
  timingTooFast: 'Aguarde alguns segundos e tente novamente.',
  managementLink: 'Ligação de gestão',
  supportCategory: 'Categoria',
  message: 'Mensagem',
  ticket: 'Pedido',
  newTicket: 'Novo pedido',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'O pedido de suporte foi encerrado a partir da conta.',
  supportUnreadMessages: '{count} mensagens de suporte não lidas',
  supportLiveActive: 'Atualizações em tempo real ativas',
  supportLiveReconnecting: 'A restabelecer as atualizações em tempo real…',
  supportMessageClosedBySupport: 'O pedido de suporte foi encerrado pelo suporte. Motivo: {reason}',
  supportMessageStatusChanged: 'O estado do pedido de suporte foi alterado para {status}.',
  supportCloseReasonClosedBySupport: 'encerrado pelo suporte',
  supportCloseReasonClosedByAccount: 'encerrado a partir da conta',
  supportActorYou: 'Você',
  supportActorSupport: 'Suporte',
  supportActorSystem: 'Sistema',
  supportStatusNew: 'Novo',
  supportStatusOpen: 'Aberto',
  supportStatusWaitingSupport: 'A aguardar suporte',
  supportStatusWaitingUser: 'A aguardar a sua resposta',
  supportStatusResolved: 'Resolvido',
  supportStatusClosed: 'Fechado',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Iniciar recuperação',
  completeRecovery: 'Concluir recuperação',
  savedPrivate: 'Só você pode ver esta lista.',
  recentPrivate: 'O histórico de leitura não é mostrado a autores nem a outros utilizadores.',
  translationsPrivate: 'Os controlos de tradução não revelam autoria.',
  settingsSaved: 'Definições guardadas.',
  bonusIntro:
    'Use bónus dentro do Quaom. Eles são ganhos apenas por ajuda confirmada e não podem ser levantados.',
  bonusBalance: 'Saldo',
  bonusAvailable: 'Disponível',
  bonusPending: 'Em revisão',
  bonusLocked: 'Bloqueado',
  bonusHistory: 'Histórico',
  bonusRules: 'Regras',
  bonusHowToGet: 'Como obter bónus',
  bonusSpend: 'Gastar bónus',
  bonusSubscription: 'Subscrição',
  bonusSubscriptionActive: 'Subscrição ativa',
  bonusSubscriptionInactive: 'Sem subscrição ativa',
  bonusRedeemOptions: 'Usar bónus',
  bonusRedeem: 'Usar bónus',
  bonusNoCashOut: 'Os bónus não podem ser levantados nem transferidos.',
  bonusNoTextRewards: 'Textos, visualizações, guardados e emoções não geram bónus.',
  bonusHelpOnly:
    'Só a ajuda confirmada em denúncias, traduções, erros ou feedback da interface pode gerar bónus.',
  bonusRuleConfirmedReports: 'Denúncias úteis confirmadas podem gerar bónus.',
  bonusRuleTranslationIssues: 'Problemas confirmados de tradução ou idioma podem gerar bónus.',
  bonusRuleBugReports: 'Erros técnicos confirmados podem gerar bónus.',
  bonusRuleUiFeedback: 'Feedback útil da interface pode gerar bónus após revisão.',
  bonusCannotWithdraw: 'Os bónus não são dinheiro e não podem ser pagos.',
  bonusAccountOnly: 'Os bónus existem apenas na sua conta privada.',
  bonusRedeemSecurityHold:
    'O uso de bónus fica temporariamente protegido após um novo dispositivo ou rede.',
  bonusSubscriptionExpires: 'Expira',
  bonusCredits: 'bónus',
  bonusPlan7Days: '7 dias',
  bonusPlan30Days: '30 dias',
  bonusSpent: 'Gasto',
  bonusEarned: 'Obtido',
  bonusPendingReview: 'Pendente de revisão',
  bonusRulesIntro:
    'As regras de bónus protegem o Quaom de transformar textos pessoais num palco pago.',
  bonusActivate: 'Ativar',
  bonusNeedMore: 'Faltam',
  bonusConfirmActivation: 'Confirmar ativação',
  bonusWillSpend: 'Serão descontados',
  bonusRemaining: 'Restarão',
  bonusProgramsUnavailable: 'A atribuição de bónus está temporariamente indisponível.',
  bonusUpTo: 'Até',
  bonusContactSupport: 'Contactar o suporte',
  bonusTerms: 'Condições',
  bonusHistoryEmpty: 'Ainda não existem movimentos de bónus.',
  bonusHistoryRejected: 'Rejeitado',
  bonusHistoryReturned: 'Devolvido',
  bonusHistoryExpired: 'Expirado',
  bonusHistoryLocked: 'Bloqueado temporariamente',
  bonusRewardConfirmedReport: 'Denúncia útil confirmada',
  bonusRewardTranslationIssue: 'Problema de tradução confirmado',
  bonusRewardBugReport: 'Erro técnico confirmado',
  bonusRewardUiFeedback: 'Feedback da interface confirmado',
  invalidPassword: 'Senha incorreta.',
  passwordRules:
    'Use 10-32 caracteres: apenas letras latinas e números, com pelo menos uma minúscula, uma maiúscula e um número.',
  passwordRequired: 'Introduza uma palavra-passe.',
  passwordLength: 'Use 10-32 caracteres para a palavra-passe.',
  passwordLatinOnly: 'Use apenas letras latinas e números na palavra-passe.',
  passwordLowercase: 'Adicione pelo menos uma letra latina minúscula à palavra-passe.',
  passwordUppercase: 'Adicione pelo menos uma letra latina maiúscula à palavra-passe.',
  passwordDigit: 'Adicione pelo menos um número à palavra-passe.',
  showPassword: 'Mostrar palavra-passe',
  hidePassword: 'Ocultar palavra-passe',
  showRecoveryKey: 'Mostrar chave de recuperação',
  hideRecoveryKey: 'Ocultar chave de recuperação',
  generatePassword: 'Gerar palavra-passe',
  copied: 'Copiado.',
  downloaded: 'Transferido.',
  recoveryFileWarning:
    'Guarde este ficheiro num local privado. A chave de recuperação pode ajudar a recuperar o acesso à conta.',
  accountNotFound: 'Conta não encontrada.',
  supportMessageTooManyRepeats: 'A mensagem contém caracteres idênticos demais em sequência.',
  supportMessageWordTooLong: 'Uma palavra da mensagem é longa demais.',
  supportMessageTooManyUrls: 'A mensagem contém links demais.',
  supportMessageTooShort: 'A mensagem é curta demais.',
  supportMessageTooLong: 'A mensagem é longa demais.',
  tooManyAttempts: 'Muitas tentativas. Aguarde um pouco e tente novamente.',
  securityHoldShort: 'Temporariamente limitado.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Evento',
  securityTime: 'Hora',
  securitySeverityInfo: 'Informação',
  securitySeverityImportant: 'Importante',
  securitySeverityWarning: 'Aviso',
  securityEventSensitiveActionAuthorized: 'Ação protegida confirmada',
  securityEventSensitiveActionPasswordFailed: 'Falha na confirmação da palavra-passe',
  securityEventSensitiveActionBlockedHold: 'Ação bloqueada pela proteção temporária',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Temporariamente indisponível.',
  bonusPartialLoadError:
    'Alguns dados de bónus não puderam ser carregados. As secções disponíveis continuam utilizáveis.',
  bonusRetry: 'Tentar novamente',
  bonusBalanceUnavailable: 'O saldo está temporariamente indisponível.',
  bonusRedeemOptionsUnavailable: 'As opções de bónus estão temporariamente indisponíveis.',
  bonusRulesUnavailable: 'Os programas para obter bónus estão temporariamente indisponíveis.',
  bonusHistoryUnavailable: 'O histórico de bónus está temporariamente indisponível.',
  bonusSubscriptionUnavailable: 'O estado da subscrição está temporariamente indisponível.',
  bonusRedeemStateUnavailable:
    'Não é possível verificar a utilização de bónus agora. Tente novamente.',
  bonusOptionUnavailable: 'Esta opção está temporariamente indisponível.',
  bonusRedeemInsufficient: 'Não há bónus disponíveis suficientes. O saldo pode ter mudado.',
  bonusRedeemOptionUnavailable:
    'Esta opção de bónus já não está disponível. Atualize e escolha novamente.',
  bonusRedeemUnknownOutcome:
    'Não foi possível confirmar o resultado. Tente novamente em segurança; o mesmo pedido não será cobrado duas vezes.',
  bonusRedeemFailed: 'Não foi possível usar os bónus. Tente novamente.',
  bonusShowMore: 'Mostrar mais',
  bonusHistoryLoadMoreError: 'Não foi possível carregar mais histórico. Tente novamente.',
  bonusBenefitsTitle: 'A subscrição inclui',
  bonusBenefitMorePrivateSaves: 'Mais textos guardados em privado',
  bonusBenefitLongerHistory: 'Histórico privado de leitura mais longo',
  bonusBenefitAdvancedReading: 'Definições avançadas de leitura',
  bonusBenefitThemes: 'Temas de leitura adicionais',
  bonusBenefitExport: 'Exportação de textos guardados',
  bonusBenefitEarlyAccess: 'Acesso antecipado a modos de leitura',
  bonusBenefitPrioritySupport: 'Suporte prioritário',
  bonusRewardSafetyReport: 'Relatório de segurança confirmado',
  bonusRuleSafetyReports: 'Um relatório de segurança confirmado pode dar bónus após verificação.',
  bonusRewardSupportFeedback: 'Feedback de suporte confirmado',
  bonusRuleSupportFeedback: 'Feedback útil sobre o suporte pode dar bónus após verificação.',
};
const PL: AccountMessages = {
  title: 'Konto',
  eyebrow: 'Prywatne konto',
  headline: 'Konto',
  intro: 'Zarządzaj kontem.',
  home: 'Konto',
  login: 'Zaloguj się',
  register: 'Utwórz konto',
  recover: 'Odzyskaj konto',
  texts: 'Moje teksty',
  saved: 'Zapisane',
  recent: 'Ostatnio czytane',
  reading: 'Czytanie',
  translations: 'Tłumaczenia',
  bonus: 'Bonusy',
  support: 'Wsparcie',
  security: 'Bezpieczeństwo',
  settings: 'Ustawienia',
  accountNotProfile:
    'Konto służy do kontroli, nie do publiczności. Pseudonim nie jest pokazywany jako imię autora.',
  loading: 'Ładowanie…',
  empty: 'Nie ma jeszcze nic do pokazania.',
  error: 'Coś poszło nie tak. Spróbuj ponownie.',
  success: 'Zapisano.',
  submit: 'Wyślij',
  save: 'Zapisz',
  cancel: 'Anuluj',
  delete: 'Usuń',
  close: 'Zamknij',
  refresh: 'Odśwież',
  password: 'Hasło',
  currentPassword: 'Aktualne hasło',
  newPassword: 'Nowe hasło',
  pseudonym: 'Pseudonim',
  emailOptional: 'Email, opcjonalnie',
  recoveryKey: 'Klucz odzyskiwania',
  copy: 'Kopiuj',
  download: 'Pobierz',
  status: 'Status',
  language: 'Język',
  created: 'Utworzono',
  updated: 'Zaktualizowano',
  published: 'Opublikowano',
  open: 'Otwórz',
  manage: 'Zarządzaj',
  remove: 'Usuń z listy',
  clear: 'Wyczyść',
  enabled: 'Włączone',
  disabled: 'Wyłączone',
  interfaceLanguage: 'Język interfejsu',
  theme: 'Motyw',
  notifications: 'Powiadomienia',
  privacy: 'Prywatność',
  data: 'Dane',
  savedTextsIntro:
    'Zapisane teksty są prywatne. Nie są publicznymi polubieniami i nie ujawniają tożsamości.',
  recentIntro: 'Ostatnio czytane jest prywatne, można je wyczyścić i wyłączyć.',
  readingIntro:
    'Wybierz języki czytania i tryb łagodny. To ustawienia oddzielne od języka interfejsu.',
  translationsIntro:
    'Kontroluj zgodę i status tłumaczeń swoich tekstów. Tłumaczenia nie powstają od razu.',
  supportIntro: 'Twórz i śledź prywatne zgłoszenia wsparcia.',
  securityIntro: 'Zarządzaj sesjami, odzyskiwaniem, emailem i wrażliwymi działaniami konta.',
  settingsIntro: 'Ogólne ustawienia: język, motyw, powiadomienia, prywatność i dane.',
  loginIntro: 'Podaj dane dostępu.',
  registerIntro: 'Wybierz dane dostępu.',
  recoverIntro: 'Odzyskaj dostęp.',
  textsIntro: 'Teksty powiązane z kontem pozostają anonimowe dla czytelników.',
  noPublicProfile: 'Brak profilu publicznego, obserwujących, awatara i strony autora.',
  handleTaken: 'Ten pseudonim jest niedostępny.',
  pseudonymSuggestions: 'Wybierz jedną z opcji:',
  pseudonymRules: '6-20 znaków: litery, cyfry, kropka, myślnik lub podkreślenie.',
  pseudonymLength: 'Użyj 6-20 znaków.',
  pseudonymFormat: 'Użyj liter, cyfr, kropki, myślnika lub podkreślenia.',
  pseudonymReserved: 'Wybierz inny pseudonim.',
  pseudonymRequired: 'Wpisz pseudonim.',
  securityHold: 'Ta akcja jest tymczasowo chroniona po nowym urządzeniu lub sieci.',
  logout: 'Wyloguj',
  logoutAll: 'Wyloguj wszędzie',
  sessions: 'Sesje',
  devices: 'Urządzenia',
  createRecoveryKey: 'Utwórz klucz odzyskiwania',
  recoveryKeyWarning: 'Bez klucza odzyskiwania nie odzyskasz tego konta, jeśli zapomnisz hasła.',
  recoveryKeyRotatedAfterRecovery: 'Po odzyskaniu dostępu zostanie wydany nowy klucz odzyskiwania.',
  replaceRecoveryKey: 'Zastąp klucz odzyskiwania',
  changeEmail: 'Zmień email',
  removeEmail: 'Usuń email',
  exportData: 'Poproś o eksport danych',
  deleteAccount: 'Poproś o usunięcie konta',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Dodaj tekst linkiem',
  claimText: 'Zapisz tekst na koncie',
  timingTooFast: 'Poczekaj kilka sekund i spróbuj ponownie.',
  managementLink: 'Link zarządzania',
  supportCategory: 'Kategoria',
  message: 'Wiadomość',
  ticket: 'Zgłoszenie',
  newTicket: 'Nowe zgłoszenie',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'Zgłoszenie do pomocy zostało zamknięte z poziomu konta.',
  supportUnreadMessages: '{count} nieprzeczytanych wiadomości pomocy',
  supportLiveActive: 'Aktualizacje na żywo są aktywne',
  supportLiveReconnecting: 'Ponowne łączenie z aktualizacjami na żywo…',
  supportMessageClosedBySupport: 'Zgłoszenie zostało zamknięte przez pomoc. Powód: {reason}',
  supportMessageStatusChanged: 'Status zgłoszenia zmieniono na {status}.',
  supportCloseReasonClosedBySupport: 'zamknięte przez pomoc',
  supportCloseReasonClosedByAccount: 'zamknięte z poziomu konta',
  supportActorYou: 'Ty',
  supportActorSupport: 'Pomoc',
  supportActorSystem: 'System',
  supportStatusNew: 'Nowe',
  supportStatusOpen: 'Otwarte',
  supportStatusWaitingSupport: 'Oczekuje na pomoc',
  supportStatusWaitingUser: 'Oczekuje na Twoją odpowiedź',
  supportStatusResolved: 'Rozwiązane',
  supportStatusClosed: 'Zamknięte',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Rozpocznij odzyskiwanie',
  completeRecovery: 'Zakończ odzyskiwanie',
  savedPrivate: 'Tylko Ty widzisz tę listę.',
  recentPrivate: 'Historia czytania nie jest pokazywana autorom ani innym użytkownikom.',
  translationsPrivate: 'Kontrola tłumaczeń nie ujawnia autorstwa.',
  settingsSaved: 'Ustawienia zapisane.',
  bonusIntro:
    'Używaj bonusów wewnątrz Quaom. Są przyznawane tylko za potwierdzoną pomoc i nie można ich wypłacić.',
  bonusBalance: 'Saldo',
  bonusAvailable: 'Dostępne',
  bonusPending: 'W trakcie weryfikacji',
  bonusLocked: 'Zablokowane',
  bonusHistory: 'Historia',
  bonusRules: 'Zasady',
  bonusHowToGet: 'Jak zdobyć bonusy',
  bonusSpend: 'Wydaj bonusy',
  bonusSubscription: 'Subskrypcja',
  bonusSubscriptionActive: 'Subskrypcja aktywna',
  bonusSubscriptionInactive: 'Brak aktywnej subskrypcji',
  bonusRedeemOptions: 'Wykorzystaj bonusy',
  bonusRedeem: 'Użyj bonusów',
  bonusNoCashOut: 'Bonusów nie można wypłacić ani przekazać.',
  bonusNoTextRewards: 'Teksty, wyświetlenia, zapisania i emocje nie dają bonusów.',
  bonusHelpOnly:
    'Bonusy może dawać tylko potwierdzona pomoc przy zgłoszeniach, tłumaczeniach, błędach lub opinii o interfejsie.',
  bonusRuleConfirmedReports: 'Potwierdzone przydatne zgłoszenia mogą dawać bonusy.',
  bonusRuleTranslationIssues:
    'Potwierdzone problemy z tłumaczeniem lub językiem mogą dawać bonusy.',
  bonusRuleBugReports: 'Potwierdzone błędy techniczne mogą dawać bonusy.',
  bonusRuleUiFeedback: 'Przydatna opinia o interfejsie może dawać bonusy po sprawdzeniu.',
  bonusCannotWithdraw: 'Bonusy nie są pieniędzmi i nie mogą być wypłacone.',
  bonusAccountOnly: 'Bonusy istnieją tylko w prywatnym koncie.',
  bonusRedeemSecurityHold:
    'Wydawanie bonusów jest czasowo chronione po nowym urządzeniu lub sieci.',
  bonusSubscriptionExpires: 'Wygasa',
  bonusCredits: 'bonusów',
  bonusPlan7Days: '7 dni',
  bonusPlan30Days: '30 dni',
  bonusSpent: 'Wydano',
  bonusEarned: 'Zdobyto',
  bonusPendingReview: 'Oczekuje na sprawdzenie',
  bonusRulesIntro: 'Zasady bonusów chronią Quaom przed zmianą osobistych tekstów w płatną scenę.',
  bonusActivate: 'Aktywuj',
  bonusNeedMore: 'Brakuje',
  bonusConfirmActivation: 'Potwierdź aktywację',
  bonusWillSpend: 'Zostanie odjęte',
  bonusRemaining: 'Pozostanie',
  bonusProgramsUnavailable: 'Przyznawanie bonusów jest tymczasowo niedostępne.',
  bonusUpTo: 'Do',
  bonusContactSupport: 'Skontaktuj się z pomocą',
  bonusTerms: 'Warunki',
  bonusHistoryEmpty: 'Brak historii bonusów.',
  bonusHistoryRejected: 'Odrzucono',
  bonusHistoryReturned: 'Zwrócono',
  bonusHistoryExpired: 'Wygasło',
  bonusHistoryLocked: 'Tymczasowo zablokowano',
  bonusRewardConfirmedReport: 'Potwierdzone przydatne zgłoszenie',
  bonusRewardTranslationIssue: 'Potwierdzony problem z tłumaczeniem',
  bonusRewardBugReport: 'Potwierdzony błąd techniczny',
  bonusRewardUiFeedback: 'Potwierdzona opinia o interfejsie',
  invalidPassword: 'Nieprawidłowe hasło.',
  passwordRules:
    'Użyj 10–32 znaków: tylko litery łacińskie i cyfry, co najmniej jedna mała litera, jedna wielka litera i jedna cyfra.',
  passwordRequired: 'Wpisz hasło.',
  passwordLength: 'Hasło musi mieć 10–32 znaki.',
  passwordLatinOnly: 'W haśle używaj tylko liter łacińskich i cyfr.',
  passwordLowercase: 'Dodaj do hasła co najmniej jedną małą literę łacińską.',
  passwordUppercase: 'Dodaj do hasła co najmniej jedną wielką literę łacińską.',
  passwordDigit: 'Dodaj do hasła co najmniej jedną cyfrę.',
  showPassword: 'Pokaż hasło',
  hidePassword: 'Ukryj hasło',
  showRecoveryKey: 'Pokaż klucz odzyskiwania',
  hideRecoveryKey: 'Ukryj klucz odzyskiwania',
  generatePassword: 'Wygeneruj hasło',
  copied: 'Skopiowano.',
  downloaded: 'Pobrano.',
  recoveryFileWarning:
    'Przechowuj ten plik w prywatnym miejscu. Klucz odzyskiwania może pomóc odzyskać dostęp do konta.',
  accountNotFound: 'Nie znaleziono konta.',
  supportMessageTooManyRepeats: 'Wiadomość zawiera zbyt wiele takich samych znaków z rzędu.',
  supportMessageWordTooLong: 'Jedno słowo w wiadomości jest zbyt długie.',
  supportMessageTooManyUrls: 'Wiadomość zawiera zbyt wiele linków.',
  supportMessageTooShort: 'Wiadomość jest zbyt krótka.',
  supportMessageTooLong: 'Wiadomość jest zbyt długa.',
  tooManyAttempts: 'Za dużo prób. Poczekaj chwilę i spróbuj ponownie.',
  securityHoldShort: 'Tymczasowo ograniczone.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Zdarzenie',
  securityTime: 'Czas',
  securitySeverityInfo: 'Informacja',
  securitySeverityImportant: 'Ważne',
  securitySeverityWarning: 'Ostrzeżenie',
  securityEventSensitiveActionAuthorized: 'Potwierdzono chronioną operację',
  securityEventSensitiveActionPasswordFailed: 'Potwierdzenie hasła nie powiodło się',
  securityEventSensitiveActionBlockedHold: 'Operacja zablokowana przez tymczasową ochronę',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Tymczasowo niedostępne.',
  bonusPartialLoadError:
    'Nie udało się wczytać części danych bonusowych. Dostępne sekcje nadal działają.',
  bonusRetry: 'Spróbuj ponownie',
  bonusBalanceUnavailable: 'Saldo jest tymczasowo niedostępne.',
  bonusRedeemOptionsUnavailable: 'Opcje bonusowe są tymczasowo niedostępne.',
  bonusRulesUnavailable: 'Programy zdobywania bonusów są tymczasowo niedostępne.',
  bonusHistoryUnavailable: 'Historia bonusów jest tymczasowo niedostępna.',
  bonusSubscriptionUnavailable: 'Stan subskrypcji jest tymczasowo niedostępny.',
  bonusRedeemStateUnavailable:
    'Nie można teraz zweryfikować wykorzystania bonusów. Spróbuj ponownie.',
  bonusOptionUnavailable: 'Ta opcja jest tymczasowo niedostępna.',
  bonusRedeemInsufficient: 'Za mało dostępnych bonusów. Saldo mogło się zmienić.',
  bonusRedeemOptionUnavailable:
    'Ta opcja bonusowa nie jest już dostępna. Odśwież i wybierz ponownie.',
  bonusRedeemUnknownOutcome:
    'Nie udało się potwierdzić wyniku. Spróbuj ponownie bezpiecznie; to samo żądanie nie zostanie naliczone dwa razy.',
  bonusRedeemFailed: 'Nie udało się wykorzystać bonusów. Spróbuj ponownie.',
  bonusShowMore: 'Pokaż więcej',
  bonusHistoryLoadMoreError: 'Nie udało się wczytać dalszej historii. Spróbuj ponownie.',
  bonusBenefitsTitle: 'Subskrypcja obejmuje',
  bonusBenefitMorePrivateSaves: 'Więcej prywatnie zapisanych tekstów',
  bonusBenefitLongerHistory: 'Dłuższa prywatna historia czytania',
  bonusBenefitAdvancedReading: 'Zaawansowane ustawienia czytania',
  bonusBenefitThemes: 'Dodatkowe motywy czytania',
  bonusBenefitExport: 'Eksport zapisanych tekstów',
  bonusBenefitEarlyAccess: 'Wczesny dostęp do trybów czytania',
  bonusBenefitPrioritySupport: 'Priorytetowe wsparcie',
  bonusRewardSafetyReport: 'Potwierdzone zgłoszenie bezpieczeństwa',
  bonusRuleSafetyReports:
    'Potwierdzone zgłoszenie bezpieczeństwa może otrzymać bonusy po weryfikacji.',
  bonusRewardSupportFeedback: 'Potwierdzona opinia o wsparciu',
  bonusRuleSupportFeedback: 'Przydatna opinia o wsparciu może otrzymać bonusy po weryfikacji.',
};
const CS: AccountMessages = {
  title: 'Účet',
  eyebrow: 'Soukromý účet',
  headline: 'Účet',
  intro: 'Spravujte svůj účet.',
  home: 'Účet',
  login: 'Přihlásit se',
  register: 'Vytvořit účet',
  recover: 'Obnovit účet',
  texts: 'Moje texty',
  saved: 'Uložené',
  recent: 'Nedávno čtené',
  reading: 'Čtení',
  translations: 'Překlady',
  bonus: 'Bonusy',
  support: 'Podpora',
  security: 'Zabezpečení',
  settings: 'Nastavení',
  accountNotProfile:
    'Účet slouží ke kontrole, ne k publicitě. Pseudonym se nezobrazuje jako jméno autora.',
  loading: 'Načítání…',
  empty: 'Zatím není co zobrazit.',
  error: 'Něco se pokazilo. Zkuste to znovu.',
  success: 'Uloženo.',
  submit: 'Odeslat',
  save: 'Uložit',
  cancel: 'Zrušit',
  delete: 'Smazat',
  close: 'Zavřít',
  refresh: 'Obnovit',
  password: 'Heslo',
  currentPassword: 'Aktuální heslo',
  newPassword: 'Nové heslo',
  pseudonym: 'Pseudonym',
  emailOptional: 'E-mail, volitelně',
  recoveryKey: 'Klíč pro obnovení',
  copy: 'Kopírovat',
  download: 'Stáhnout',
  status: 'Stav',
  language: 'Jazyk',
  created: 'Vytvořeno',
  updated: 'Aktualizováno',
  published: 'Publikováno',
  open: 'Otevřít',
  manage: 'Spravovat',
  remove: 'Odebrat',
  clear: 'Vymazat',
  enabled: 'Zapnuto',
  disabled: 'Vypnuto',
  interfaceLanguage: 'Jazyk rozhraní',
  theme: 'Motiv',
  notifications: 'Oznámení',
  privacy: 'Soukromí',
  data: 'Data',
  savedTextsIntro:
    'Uložené texty jsou soukromé. Nejsou veřejná označení líbí se a neodhalují identitu.',
  recentIntro: 'Nedávno čtené je soukromé, lze vymazat a vypnout.',
  readingIntro:
    'Vyberte jazyky čtení a jemný režim. Tato nastavení jsou oddělena od jazyka rozhraní.',
  translationsIntro: 'Spravujte souhlas a stav překladů svých textů. Překlady nevznikají okamžitě.',
  supportIntro: 'Vytvářejte a sledujte soukromé žádosti podpory.',
  securityIntro: 'Spravujte relace, obnovení, e-mail a citlivé akce účtu.',
  settingsIntro: 'Obecná nastavení: jazyk, motiv, oznámení, soukromí a data.',
  loginIntro: 'Zadejte přístupové údaje.',
  registerIntro: 'Zvolte přístupové údaje.',
  recoverIntro: 'Obnovit přístup.',
  textsIntro: 'Texty propojené s účtem zůstávají pro čtenáře anonymní.',
  noPublicProfile: 'Žádný veřejný profil, sledující, avatar ani stránka autora.',
  handleTaken: 'Tento pseudonym není dostupný.',
  pseudonymSuggestions: 'Vyberte jednu z možností:',
  pseudonymRules: '6-20 znaků: písmena, čísla, tečka, pomlčka nebo podtržítko.',
  pseudonymLength: 'Použijte 6-20 znaků.',
  pseudonymFormat: 'Použijte písmena, čísla, tečku, pomlčku nebo podtržítko.',
  pseudonymReserved: 'Zvolte jiný pseudonym.',
  pseudonymRequired: 'Zadejte pseudonym.',
  securityHold: 'Tato akce je dočasně chráněna po novém zařízení nebo síti.',
  logout: 'Odhlásit se',
  logoutAll: 'Odhlásit všude',
  sessions: 'Relace',
  devices: 'Zařízení',
  createRecoveryKey: 'Vytvořit klíč pro obnovení',
  recoveryKeyWarning:
    'Bez klíče pro obnovení nebude možné tento účet obnovit, pokud zapomenete heslo.',
  recoveryKeyRotatedAfterRecovery: 'Po obnovení bude vydán nový obnovovací klíč.',
  replaceRecoveryKey: 'Nahradit klíč pro obnovení',
  changeEmail: 'Změnit e-mail',
  removeEmail: 'Odebrat e-mail',
  exportData: 'Požádat o export dat',
  deleteAccount: 'Požádat o smazání účtu',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Přidat text odkazem',
  claimText: 'Uložit text do účtu',
  timingTooFast: 'Počkejte několik sekund a zkuste to znovu.',
  managementLink: 'Odkaz pro správu',
  supportCategory: 'Kategorie',
  message: 'Zpráva',
  ticket: 'Žádost',
  newTicket: 'Nová žádost',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'Požadavek na podporu byl uzavřen z účtu.',
  supportUnreadMessages: '{count} nepřečtených zpráv podpory',
  supportLiveActive: 'Živé aktualizace jsou aktivní',
  supportLiveReconnecting: 'Obnovování živých aktualizací…',
  supportMessageClosedBySupport: 'Požadavek na podporu uzavřela podpora. Důvod: {reason}',
  supportMessageStatusChanged: 'Stav požadavku na podporu byl změněn na {status}.',
  supportCloseReasonClosedBySupport: 'uzavřeno podporou',
  supportCloseReasonClosedByAccount: 'uzavřeno z účtu',
  supportActorYou: 'Vy',
  supportActorSupport: 'Podpora',
  supportActorSystem: 'Systém',
  supportStatusNew: 'Nový',
  supportStatusOpen: 'Otevřený',
  supportStatusWaitingSupport: 'Čeká na podporu',
  supportStatusWaitingUser: 'Čeká na vaši odpověď',
  supportStatusResolved: 'Vyřešený',
  supportStatusClosed: 'Uzavřený',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Zahájit obnovení',
  completeRecovery: 'Dokončit obnovení',
  savedPrivate: 'Tento seznam vidíte jen vy.',
  recentPrivate: 'Historie čtení se nezobrazuje autorům ani jiným uživatelům.',
  translationsPrivate: 'Ovládání překladů neodhaluje autorství.',
  settingsSaved: 'Nastavení uloženo.',
  bonusIntro:
    'Používejte bonusy uvnitř Quaom. Získávají se jen za potvrzenou pomoc a nelze je vybrat.',
  bonusBalance: 'Zůstatek',
  bonusAvailable: 'Dostupné',
  bonusPending: 'V kontrole',
  bonusLocked: 'Uzamčené',
  bonusHistory: 'Historie',
  bonusRules: 'Pravidla',
  bonusHowToGet: 'Jak získat bonusy',
  bonusSpend: 'Utratit bonusy',
  bonusSubscription: 'Předplatné',
  bonusSubscriptionActive: 'Předplatné je aktivní',
  bonusSubscriptionInactive: 'Žádné aktivní předplatné',
  bonusRedeemOptions: 'Použít bonusy',
  bonusRedeem: 'Použít bonusy',
  bonusNoCashOut: 'Bonusy nelze vybrat ani převést.',
  bonusNoTextRewards: 'Texty, zobrazení, uložení a emoce bonusy nepřinášejí.',
  bonusHelpOnly:
    'Bonusy může přinést jen potvrzená pomoc s hlášeními, překlady, chybami nebo zpětnou vazbou k rozhraní.',
  bonusRuleConfirmedReports: 'Potvrzená užitečná hlášení mohou přinést bonusy.',
  bonusRuleTranslationIssues: 'Potvrzené problémy s překladem nebo jazykem mohou přinést bonusy.',
  bonusRuleBugReports: 'Potvrzené technické chyby mohou přinést bonusy.',
  bonusRuleUiFeedback: 'Užitečná zpětná vazba k rozhraní může po kontrole přinést bonusy.',
  bonusCannotWithdraw: 'Bonusy nejsou peníze a nelze je vyplatit.',
  bonusAccountOnly: 'Bonusy existují pouze ve vašem soukromém účtu.',
  bonusRedeemSecurityHold: 'Utrácení bonusů je po novém zařízení nebo síti dočasně chráněno.',
  bonusSubscriptionExpires: 'Vyprší',
  bonusCredits: 'bonusů',
  bonusPlan7Days: '7 dní',
  bonusPlan30Days: '30 dní',
  bonusSpent: 'Utraceno',
  bonusEarned: 'Získáno',
  bonusPendingReview: 'Čeká na kontrolu',
  bonusRulesIntro: 'Pravidla bonusů chrání Quaom před proměnou osobních textů v placené jeviště.',
  bonusActivate: 'Aktivovat',
  bonusNeedMore: 'Chybí',
  bonusConfirmActivation: 'Potvrdit aktivaci',
  bonusWillSpend: 'Bude odečteno',
  bonusRemaining: 'Zůstane',
  bonusProgramsUnavailable: 'Přidělování bonusů je dočasně nedostupné.',
  bonusUpTo: 'Až',
  bonusContactSupport: 'Kontaktovat podporu',
  bonusTerms: 'Podmínky',
  bonusHistoryEmpty: 'Zatím žádná historie bonusů.',
  bonusHistoryRejected: 'Zamítnuto',
  bonusHistoryReturned: 'Vráceno',
  bonusHistoryExpired: 'Vypršelo',
  bonusHistoryLocked: 'Dočasně uzamčeno',
  bonusRewardConfirmedReport: 'Potvrzené užitečné hlášení',
  bonusRewardTranslationIssue: 'Potvrzený problém s překladem',
  bonusRewardBugReport: 'Potvrzená technická chyba',
  bonusRewardUiFeedback: 'Potvrzená zpětná vazba k rozhraní',
  invalidPassword: 'Nesprávné heslo.',
  passwordRules:
    'Použijte 10–32 znaků: pouze latinská písmena a číslice, alespoň jedno malé písmeno, jedno velké písmeno a jednu číslici.',
  passwordRequired: 'Zadejte heslo.',
  passwordLength: 'Heslo musí mít 10–32 znaků.',
  passwordLatinOnly: 'V hesle používejte pouze latinská písmena a číslice.',
  passwordLowercase: 'Přidejte do hesla alespoň jedno malé latinské písmeno.',
  passwordUppercase: 'Přidejte do hesla alespoň jedno velké latinské písmeno.',
  passwordDigit: 'Přidejte do hesla alespoň jednu číslici.',
  showPassword: 'Zobrazit heslo',
  hidePassword: 'Skrýt heslo',
  showRecoveryKey: 'Zobrazit obnovovací klíč',
  hideRecoveryKey: 'Skrýt obnovovací klíč',
  generatePassword: 'Vygenerovat heslo',
  copied: 'Zkopírováno.',
  downloaded: 'Staženo.',
  recoveryFileWarning:
    'Uložte tento soubor na soukromé místo. Obnovovací klíč může pomoci obnovit přístup k účtu.',
  accountNotFound: 'Účet nebyl nalezen.',
  supportMessageTooManyRepeats: 'Zpráva obsahuje příliš mnoho stejných znaků za sebou.',
  supportMessageWordTooLong: 'Jedno slovo ve zprávě je příliš dlouhé.',
  supportMessageTooManyUrls: 'Zpráva obsahuje příliš mnoho odkazů.',
  supportMessageTooShort: 'Zpráva je příliš krátká.',
  supportMessageTooLong: 'Zpráva je příliš dlouhá.',
  tooManyAttempts: 'Příliš mnoho pokusů. Chvíli počkejte a zkuste to znovu.',
  securityHoldShort: 'Dočasně omezeno.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Událost',
  securityTime: 'Čas',
  securitySeverityInfo: 'Informace',
  securitySeverityImportant: 'Důležité',
  securitySeverityWarning: 'Upozornění',
  securityEventSensitiveActionAuthorized: 'Chráněná akce potvrzena',
  securityEventSensitiveActionPasswordFailed: 'Potvrzení hesla se nezdařilo',
  securityEventSensitiveActionBlockedHold: 'Akce zablokována dočasnou ochranou',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Dočasně nedostupné.',
  bonusPartialLoadError:
    'Některá bonusová data se nepodařilo načíst. Dostupné části zůstávají použitelné.',
  bonusRetry: 'Zkusit znovu',
  bonusBalanceUnavailable: 'Zůstatek je dočasně nedostupný.',
  bonusRedeemOptionsUnavailable: 'Možnosti bonusů jsou dočasně nedostupné.',
  bonusRulesUnavailable: 'Programy pro získání bonusů jsou dočasně nedostupné.',
  bonusHistoryUnavailable: 'Historie bonusů je dočasně nedostupná.',
  bonusSubscriptionUnavailable: 'Stav předplatného je dočasně nedostupný.',
  bonusRedeemStateUnavailable: 'Použití bonusů nyní nelze ověřit. Zkuste to znovu.',
  bonusOptionUnavailable: 'Tato možnost je dočasně nedostupná.',
  bonusRedeemInsufficient: 'Není dostatek dostupných bonusů. Zůstatek se mohl změnit.',
  bonusRedeemOptionUnavailable:
    'Tato bonusová možnost již není dostupná. Obnovte stránku a vyberte znovu.',
  bonusRedeemUnknownOutcome:
    'Výsledek se nepodařilo potvrdit. Opakujte bezpečně; stejný požadavek nebude účtován dvakrát.',
  bonusRedeemFailed: 'Bonusy se nepodařilo použít. Zkuste to znovu.',
  bonusShowMore: 'Zobrazit více',
  bonusHistoryLoadMoreError: 'Další historii se nepodařilo načíst. Zkuste to znovu.',
  bonusBenefitsTitle: 'Předplatné zahrnuje',
  bonusBenefitMorePrivateSaves: 'Více soukromě uložených textů',
  bonusBenefitLongerHistory: 'Delší soukromá historie čtení',
  bonusBenefitAdvancedReading: 'Pokročilá nastavení čtení',
  bonusBenefitThemes: 'Další motivy čtení',
  bonusBenefitExport: 'Export uložených textů',
  bonusBenefitEarlyAccess: 'Přednostní přístup k režimům čtení',
  bonusBenefitPrioritySupport: 'Prioritní podpora',
  bonusRewardSafetyReport: 'Potvrzené bezpečnostní hlášení',
  bonusRuleSafetyReports: 'Potvrzené bezpečnostní hlášení může po kontrole získat bonusy.',
  bonusRewardSupportFeedback: 'Potvrzená zpětná vazba na podporu',
  bonusRuleSupportFeedback: 'Užitečná zpětná vazba na podporu může po kontrole získat bonusy.',
};
const HU: AccountMessages = {
  title: 'Fiók',
  eyebrow: 'Privát fiók',
  headline: 'Fiók',
  intro: 'Kezelje a fiókját.',
  home: 'Fiók',
  login: 'Bejelentkezés',
  register: 'Fiók létrehozása',
  recover: 'Fiók helyreállítása',
  texts: 'Saját szövegek',
  saved: 'Mentettek',
  recent: 'Nemrég olvasott',
  reading: 'Olvasás',
  translations: 'Fordítások',
  bonus: 'Bónuszok',
  support: 'Támogatás',
  security: 'Biztonság',
  settings: 'Beállítások',
  accountNotProfile:
    'A fiók irányításra szolgál, nem nyilvánosságra. A pseudonym nem szerzőnévként jelenik meg.',
  loading: 'Betöltés…',
  empty: 'Még nincs mit megjeleníteni.',
  error: 'Valami nem sikerült. Próbáld újra.',
  success: 'Mentve.',
  submit: 'Küldés',
  save: 'Mentés',
  cancel: 'Mégse',
  delete: 'Törlés',
  close: 'Bezárás',
  refresh: 'Frissítés',
  password: 'Jelszó',
  currentPassword: 'Jelenlegi jelszó',
  newPassword: 'Új jelszó',
  pseudonym: 'Pseudonym',
  emailOptional: 'Email, opcionális',
  recoveryKey: 'Helyreállítási kulcs',
  copy: 'Másolás',
  download: 'Letöltés',
  status: 'Állapot',
  language: 'Nyelv',
  created: 'Létrehozva',
  updated: 'Frissítve',
  published: 'Közzétéve',
  open: 'Megnyitás',
  manage: 'Kezelés',
  remove: 'Eltávolítás',
  clear: 'Törlés',
  enabled: 'Engedélyezve',
  disabled: 'Letiltva',
  interfaceLanguage: 'Felület nyelve',
  theme: 'Téma',
  notifications: 'Értesítések',
  privacy: 'Adatvédelem',
  data: 'Adatok',
  savedTextsIntro:
    'A mentett szövegek privátak. Nem nyilvános kedvelések, és nem fedik fel az identitásodat.',
  recentIntro: 'A nemrég olvasott lista privát, törölhető és kikapcsolható.',
  readingIntro: 'Válassz olvasási nyelveket és lágy módot. Ezek külön vannak a felület nyelvétől.',
  translationsIntro:
    'Kezeld a szövegeid fordítási hozzájárulását és állapotát. A fordítások nem készülnek el azonnal.',
  supportIntro: 'Hozz létre és kövess privát támogatási kéréseket.',
  securityIntro: 'Kezeld a munkameneteket, helyreállítást, emailt és érzékeny fiókműveleteket.',
  settingsIntro: 'Általános beállítások: nyelv, téma, értesítések, adatvédelem és adatok.',
  loginIntro: 'Adja meg a hozzáférési adatokat.',
  registerIntro: 'Válassza ki a hozzáférési adatokat.',
  recoverIntro: 'Hozzáférés helyreállítása.',
  textsIntro: 'A fiókhoz kapcsolt szövegek anonimak maradnak az olvasók számára.',
  noPublicProfile: 'Nincs nyilvános profil, követők, avatar vagy szerzői oldal.',
  handleTaken: 'Ez a pseudonym nem elérhető.',
  pseudonymSuggestions: 'Válassz egyet ezek közül:',
  pseudonymRules: '6-20 karakter: betűk, számok, pont, kötőjel vagy aláhúzás.',
  pseudonymLength: 'Használj 6-20 karaktert.',
  pseudonymFormat: 'Használj betűket, számokat, pontot, kötőjelet vagy aláhúzást.',
  pseudonymReserved: 'Válassz másik álnevet.',
  pseudonymRequired: 'Adj meg álnevet.',
  securityHold: 'Ez a művelet új eszköz vagy hálózat után ideiglenesen védett.',
  logout: 'Kijelentkezés',
  logoutAll: 'Kijelentkezés mindenhol',
  sessions: 'Munkamenetek',
  devices: 'Eszközök',
  createRecoveryKey: 'Helyreállítási kulcs létrehozása',
  recoveryKeyWarning:
    'Helyreállítási kulcs nélkül nem tudod visszaállítani ezt a fiókot, ha elfelejted a jelszót.',
  recoveryKeyRotatedAfterRecovery: 'A helyreállítás után új helyreállítási kulcs lesz kiadva.',
  replaceRecoveryKey: 'Helyreállítási kulcs cseréje',
  changeEmail: 'Email módosítása',
  removeEmail: 'Email eltávolítása',
  exportData: 'Adatexport kérése',
  deleteAccount: 'Fióktörlés kérése',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Szöveg hozzáadása linkkel',
  claimText: 'Szöveg mentése fiókba',
  timingTooFast: 'Várjon néhány másodpercet, majd próbálja újra.',
  managementLink: 'Kezelő link',
  supportCategory: 'Kategória',
  message: 'Üzenet',
  ticket: 'Kérés',
  newTicket: 'Új kérés',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'A támogatási kérelmet a fiókból zárták le.',
  supportUnreadMessages: '{count} olvasatlan támogatási üzenet',
  supportLiveActive: 'Az élő frissítés aktív',
  supportLiveReconnecting: 'Az élő frissítés újracsatlakozik…',
  supportMessageClosedBySupport: 'A támogatási kérelmet az ügyfélszolgálat lezárta. Ok: {reason}',
  supportMessageStatusChanged: 'A támogatási kérelem állapota erre változott: {status}.',
  supportCloseReasonClosedBySupport: 'az ügyfélszolgálat zárta le',
  supportCloseReasonClosedByAccount: 'a fiókból zárták le',
  supportActorYou: 'Ön',
  supportActorSupport: 'Ügyfélszolgálat',
  supportActorSystem: 'Rendszer',
  supportStatusNew: 'Új',
  supportStatusOpen: 'Nyitott',
  supportStatusWaitingSupport: 'Ügyfélszolgálatra vár',
  supportStatusWaitingUser: 'Az Ön válaszára vár',
  supportStatusResolved: 'Megoldva',
  supportStatusClosed: 'Lezárva',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Helyreállítás indítása',
  completeRecovery: 'Helyreállítás befejezése',
  savedPrivate: 'Ezt a listát csak te látod.',
  recentPrivate: 'Az olvasási előzmények nem láthatók szerzőknek vagy más felhasználóknak.',
  translationsPrivate: 'A fordítási vezérlés nem fedi fel a szerzőséget.',
  settingsSaved: 'Beállítások mentve.',
  bonusIntro:
    'A bónuszokat a Qeweón belül használhatod. Csak megerősített segítségért járnak, és nem vehetők ki.',
  bonusBalance: 'Egyenleg',
  bonusAvailable: 'Elérhető',
  bonusPending: 'Ellenőrzés alatt',
  bonusLocked: 'Zárolt',
  bonusHistory: 'Előzmények',
  bonusRules: 'Szabályok',
  bonusHowToGet: 'Hogyan szerezhetsz bónuszt',
  bonusSpend: 'Bónuszok felhasználása',
  bonusSubscription: 'Előfizetés',
  bonusSubscriptionActive: 'Aktív előfizetés',
  bonusSubscriptionInactive: 'Nincs aktív előfizetés',
  bonusRedeemOptions: 'Bónuszok felhasználása',
  bonusRedeem: 'Bónuszok használata',
  bonusNoCashOut: 'A bónuszok nem vehetők ki és nem ruházhatók át.',
  bonusNoTextRewards: 'A szövegek, megtekintések, mentések és érzelmek nem adnak bónuszt.',
  bonusHelpOnly:
    'Csak a jelentésekkel, fordításokkal, hibákkal vagy felület-visszajelzéssel kapcsolatos megerősített segítség adhat bónuszt.',
  bonusRuleConfirmedReports: 'A megerősített hasznos jelentések bónuszt adhatnak.',
  bonusRuleTranslationIssues: 'A megerősített fordítási vagy nyelvi problémák bónuszt adhatnak.',
  bonusRuleBugReports: 'A megerősített technikai hibák bónuszt adhatnak.',
  bonusRuleUiFeedback: 'A hasznos felület-visszajelzés ellenőrzés után bónuszt adhat.',
  bonusCannotWithdraw: 'A bónusz nem pénz, és nem fizethető ki.',
  bonusAccountOnly: 'A bónuszok csak a privát fiókodban léteznek.',
  bonusRedeemSecurityHold:
    'Új eszköz vagy hálózat után a bónuszok felhasználása ideiglenesen védett.',
  bonusSubscriptionExpires: 'Lejár',
  bonusCredits: 'bónusz',
  bonusPlan7Days: '7 nap',
  bonusPlan30Days: '30 nap',
  bonusSpent: 'Elköltve',
  bonusEarned: 'Megszerzett',
  bonusPendingReview: 'Ellenőrzés alatt',
  bonusRulesIntro:
    'A bónuszszabályok megvédik a Qeweót attól, hogy a személyes szövegek fizetett színpaddá váljanak.',
  bonusActivate: 'Aktiválás',
  bonusNeedMore: 'Még szükséges',
  bonusConfirmActivation: 'Aktiválás megerősítése',
  bonusWillSpend: 'Levonásra kerül',
  bonusRemaining: 'Megmarad',
  bonusProgramsUnavailable: 'A bónuszjóváírás átmenetileg nem érhető el.',
  bonusUpTo: 'Legfeljebb',
  bonusContactSupport: 'Kapcsolatfelvétel az ügyfélszolgálattal',
  bonusTerms: 'Feltételek',
  bonusHistoryEmpty: 'Még nincs bónuszelőzmény.',
  bonusHistoryRejected: 'Elutasítva',
  bonusHistoryReturned: 'Visszatérítve',
  bonusHistoryExpired: 'Lejárt',
  bonusHistoryLocked: 'Ideiglenesen zárolva',
  bonusRewardConfirmedReport: 'Megerősített hasznos bejelentés',
  bonusRewardTranslationIssue: 'Megerősített fordítási probléma',
  bonusRewardBugReport: 'Megerősített technikai hiba',
  bonusRewardUiFeedback: 'Megerősített felületi visszajelzés',
  invalidPassword: 'Hibás jelszó.',
  passwordRules:
    'Használjon 10–32 karaktert: csak latin betűket és számokat, legalább egy kisbetűvel, egy nagybetűvel és egy számmal.',
  passwordRequired: 'Adjon meg jelszót.',
  passwordLength: 'A jelszó legyen 10–32 karakter hosszú.',
  passwordLatinOnly: 'A jelszóban csak latin betűket és számokat használjon.',
  passwordLowercase: 'Adjon a jelszóhoz legalább egy latin kisbetűt.',
  passwordUppercase: 'Adjon a jelszóhoz legalább egy latin nagybetűt.',
  passwordDigit: 'Adjon a jelszóhoz legalább egy számot.',
  showPassword: 'Jelszó megjelenítése',
  hidePassword: 'Jelszó elrejtése',
  showRecoveryKey: 'Helyreállítási kulcs megjelenítése',
  hideRecoveryKey: 'Helyreállítási kulcs elrejtése',
  generatePassword: 'Jelszó generálása',
  copied: 'Másolva.',
  downloaded: 'Letöltve.',
  recoveryFileWarning:
    'Tartsa ezt a fájlt privát helyen. A helyreállítási kulcs segíthet visszaállítani a hozzáférést a fiókhoz.',
  accountNotFound: 'A fiók nem található.',
  supportMessageTooManyRepeats: 'Az üzenet túl sok azonos karaktert tartalmaz egymás után.',
  supportMessageWordTooLong: 'Az üzenet egyik szava túl hosszú.',
  supportMessageTooManyUrls: 'Az üzenet túl sok hivatkozást tartalmaz.',
  supportMessageTooShort: 'Az üzenet túl rövid.',
  supportMessageTooLong: 'Az üzenet túl hosszú.',
  tooManyAttempts: 'Túl sok próbálkozás. Várj egy kicsit, majd próbáld újra.',
  securityHoldShort: 'Ideiglenesen korlátozva.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Esemény',
  securityTime: 'Idő',
  securitySeverityInfo: 'Információ',
  securitySeverityImportant: 'Fontos',
  securitySeverityWarning: 'Figyelmeztetés',
  securityEventSensitiveActionAuthorized: 'Védett művelet megerősítve',
  securityEventSensitiveActionPasswordFailed: 'A jelszó megerősítése sikertelen',
  securityEventSensitiveActionBlockedHold: 'A műveletet az ideiglenes védelem blokkolta',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Átmenetileg nem elérhető.',
  bonusPartialLoadError:
    'Néhány bónuszadat nem tölthető be. Az elérhető részek továbbra is használhatók.',
  bonusRetry: 'Próbálja újra',
  bonusBalanceUnavailable: 'Az egyenleg átmenetileg nem érhető el.',
  bonusRedeemOptionsUnavailable: 'A bónuszlehetőségek átmenetileg nem érhetők el.',
  bonusRulesUnavailable: 'A bónuszszerzési programok átmenetileg nem érhetők el.',
  bonusHistoryUnavailable: 'A bónuszelőzmények átmenetileg nem érhetők el.',
  bonusSubscriptionUnavailable: 'Az előfizetés állapota átmenetileg nem érhető el.',
  bonusRedeemStateUnavailable: 'A bónuszok felhasználása most nem ellenőrizhető. Próbálja újra.',
  bonusOptionUnavailable: 'Ez a lehetőség átmenetileg nem érhető el.',
  bonusRedeemInsufficient: 'Nincs elég elérhető bónusz. Az egyenleg megváltozhatott.',
  bonusRedeemOptionUnavailable:
    'Ez a bónuszlehetőség már nem érhető el. Frissítsen és válasszon újra.',
  bonusRedeemUnknownOutcome:
    'Az eredmény nem erősíthető meg. Biztonságosan próbálja újra; ugyanaz a kérés nem kerül kétszer levonásra.',
  bonusRedeemFailed: 'A bónuszok nem használhatók fel. Próbálja újra.',
  bonusShowMore: 'Továbbiak',
  bonusHistoryLoadMoreError: 'Nem sikerült további előzményeket betölteni. Próbálja újra.',
  bonusBenefitsTitle: 'Az előfizetés tartalma',
  bonusBenefitMorePrivateSaves: 'Több privát mentett szöveg',
  bonusBenefitLongerHistory: 'Hosszabb privát olvasási előzmény',
  bonusBenefitAdvancedReading: 'Speciális olvasási beállítások',
  bonusBenefitThemes: 'További olvasási témák',
  bonusBenefitExport: 'Mentett szövegek exportálása',
  bonusBenefitEarlyAccess: 'Korai hozzáférés az olvasási módokhoz',
  bonusBenefitPrioritySupport: 'Elsőbbségi támogatás',
  bonusRewardSafetyReport: 'Megerősített biztonsági jelentés',
  bonusRuleSafetyReports: 'A megerősített biztonsági jelentés ellenőrzés után bónuszt érhet.',
  bonusRewardSupportFeedback: 'Megerősített támogatási visszajelzés',
  bonusRuleSupportFeedback: 'A hasznos támogatási visszajelzés ellenőrzés után bónuszt érhet.',
};
const RO: AccountMessages = {
  title: 'Cont',
  eyebrow: 'Cont privat',
  headline: 'Cont',
  intro: 'Gestionează contul.',
  home: 'Cont',
  login: 'Autentificare',
  register: 'Creați cont',
  recover: 'Recuperați contul',
  texts: 'Textele mele',
  saved: 'Salvate',
  recent: 'Citite recent',
  reading: 'Citire',
  translations: 'Traduceri',
  bonus: 'Bonusuri',
  support: 'Suport',
  security: 'Securitate',
  settings: 'Setări',
  accountNotProfile:
    'Contul este pentru control, nu pentru publicitate. Pseudonimul nu este afișat ca nume de autor.',
  loading: 'Se încarcă…',
  empty: 'Nu este nimic de afișat încă.',
  error: 'Ceva nu a mers bine. Încercați din nou.',
  success: 'Salvat.',
  submit: 'Trimiteți',
  save: 'Salvați',
  cancel: 'Anulați',
  delete: 'Ștergeți',
  close: 'Închideți',
  refresh: 'Reîmprospătați',
  password: 'Parolă',
  currentPassword: 'Parola curentă',
  newPassword: 'Parolă nouă',
  pseudonym: 'Pseudonim',
  emailOptional: 'Email, opțional',
  recoveryKey: 'Cheie de recuperare',
  copy: 'Copiați',
  download: 'Descărcați',
  status: 'Stare',
  language: 'Limbă',
  created: 'Creat',
  updated: 'Actualizat',
  published: 'Publicat',
  open: 'Deschideți',
  manage: 'Gestionați',
  remove: 'Eliminați',
  clear: 'Ștergeți',
  enabled: 'Activat',
  disabled: 'Dezactivat',
  interfaceLanguage: 'Limba interfeței',
  theme: 'Temă',
  notifications: 'Notificări',
  privacy: 'Confidențialitate',
  data: 'Date',
  savedTextsIntro:
    'Textele salvate sunt private. Nu sunt aprecieri publice și nu expun identitatea.',
  recentIntro: 'Citite recent este privat, poate fi șters și dezactivat.',
  readingIntro:
    'Alegeți limbile de citire și modul blând. Aceste setări sunt separate de limba interfeței.',
  translationsIntro:
    'Controlați consimțământul și starea traducerilor textelor dvs. Traducerile nu sunt create imediat.',
  supportIntro: 'Creați și urmăriți cereri private de suport.',
  securityIntro: 'Gestionați sesiunile, recuperarea, emailul și acțiunile sensibile ale contului.',
  settingsIntro: 'Setări generale: limbă, temă, notificări, confidențialitate și date.',
  loginIntro: 'Introdu datele de acces.',
  registerIntro: 'Alege datele de acces.',
  recoverIntro: 'Recuperează accesul.',
  textsIntro: 'Textele legate de cont rămân anonime pentru cititori.',
  noPublicProfile: 'Fără profil public, urmăritori, avatar sau pagină de autor.',
  handleTaken: 'Acest pseudonim nu este disponibil.',
  pseudonymSuggestions: 'Alege una dintre aceste opțiuni:',
  pseudonymRules: '6-20 caractere: litere, cifre, punct, cratimă sau underscore.',
  pseudonymLength: 'Folosește 6-20 caractere.',
  pseudonymFormat: 'Folosește litere, cifre, punct, cratimă sau underscore.',
  pseudonymReserved: 'Alege alt pseudonim.',
  pseudonymRequired: 'Introdu un pseudonim.',
  securityHold: 'Această acțiune este protejată temporar după un dispozitiv sau o rețea nouă.',
  logout: 'Deconectare',
  logoutAll: 'Deconectare peste tot',
  sessions: 'Sesiuni',
  devices: 'Dispozitive',
  createRecoveryKey: 'Creați cheie de recuperare',
  recoveryKeyWarning:
    'Fără o cheie de recuperare, nu vei putea recupera acest cont dacă uiți parola.',
  recoveryKeyRotatedAfterRecovery: 'După recuperare, va fi emisă o nouă cheie de recuperare.',
  replaceRecoveryKey: 'Înlocuiți cheia de recuperare',
  changeEmail: 'Schimbați emailul',
  removeEmail: 'Eliminați emailul',
  exportData: 'Solicitați exportul datelor',
  deleteAccount: 'Solicitați ștergerea contului',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Adăugați text prin link',
  claimText: 'Salvați textul în cont',
  timingTooFast: 'Așteptați câteva secunde și încercați din nou.',
  managementLink: 'Link de gestionare',
  supportCategory: 'Categorie',
  message: 'Mesaj',
  ticket: 'Cerere',
  newTicket: 'Cerere nouă',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'Solicitarea de asistență a fost închisă din cont.',
  supportUnreadMessages: '{count} mesaje de asistență necitite',
  supportLiveActive: 'Actualizările în timp real sunt active',
  supportLiveReconnecting: 'Se reconectează actualizările în timp real…',
  supportMessageClosedBySupport:
    'Solicitarea de asistență a fost închisă de echipa de asistență. Motiv: {reason}',
  supportMessageStatusChanged: 'Starea solicitării de asistență a fost schimbată în {status}.',
  supportCloseReasonClosedBySupport: 'închisă de echipa de asistență',
  supportCloseReasonClosedByAccount: 'închisă din cont',
  supportActorYou: 'Tu',
  supportActorSupport: 'Asistență',
  supportActorSystem: 'Sistem',
  supportStatusNew: 'Nouă',
  supportStatusOpen: 'Deschisă',
  supportStatusWaitingSupport: 'Așteaptă asistența',
  supportStatusWaitingUser: 'Așteaptă răspunsul tău',
  supportStatusResolved: 'Rezolvată',
  supportStatusClosed: 'Închisă',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Începeți recuperarea',
  completeRecovery: 'Finalizați recuperarea',
  savedPrivate: 'Doar dvs. puteți vedea această listă.',
  recentPrivate: 'Istoricul de citire nu este afișat autorilor sau altor utilizatori.',
  translationsPrivate: 'Controalele de traducere nu dezvăluie autorul.',
  settingsSaved: 'Setări salvate.',
  bonusIntro:
    'Folosește bonusurile în Quaom. Se obțin doar pentru ajutor confirmat și nu pot fi retrase.',
  bonusBalance: 'Sold',
  bonusAvailable: 'Disponibil',
  bonusPending: 'În verificare',
  bonusLocked: 'Blocat',
  bonusHistory: 'Istoric',
  bonusRules: 'Reguli',
  bonusHowToGet: 'Cum obții bonusuri',
  bonusSpend: 'Cheltuie bonusuri',
  bonusSubscription: 'Abonament',
  bonusSubscriptionActive: 'Abonament activ',
  bonusSubscriptionInactive: 'Niciun abonament activ',
  bonusRedeemOptions: 'Folosește bonusurile',
  bonusRedeem: 'Folosește bonusuri',
  bonusNoCashOut: 'Bonusurile nu pot fi retrase sau transferate.',
  bonusNoTextRewards: 'Textele, vizualizările, salvările și emoțiile nu oferă bonusuri.',
  bonusHelpOnly:
    'Doar ajutorul confirmat cu raportări, traduceri, erori sau feedback de interfață poate oferi bonusuri.',
  bonusRuleConfirmedReports: 'Raportările utile confirmate pot oferi bonusuri.',
  bonusRuleTranslationIssues: 'Problemele confirmate de traducere sau limbă pot oferi bonusuri.',
  bonusRuleBugReports: 'Erorile tehnice confirmate pot oferi bonusuri.',
  bonusRuleUiFeedback: 'Feedbackul util despre interfață poate oferi bonusuri după verificare.',
  bonusCannotWithdraw: 'Bonusurile nu sunt bani și nu pot fi plătite.',
  bonusAccountOnly: 'Bonusurile există doar în contul tău privat.',
  bonusRedeemSecurityHold:
    'Folosirea bonusurilor este protejată temporar după un dispozitiv sau o rețea nouă.',
  bonusSubscriptionExpires: 'Expiră',
  bonusCredits: 'bonusuri',
  bonusPlan7Days: '7 zile',
  bonusPlan30Days: '30 de zile',
  bonusSpent: 'Cheltuit',
  bonusEarned: 'Obținut',
  bonusPendingReview: 'În verificare',
  bonusRulesIntro:
    'Regulile bonusurilor protejează Quaom de transformarea textelor personale într-o scenă plătită.',
  bonusActivate: 'Activează',
  bonusNeedMore: 'Mai sunt necesare',
  bonusConfirmActivation: 'Confirmă activarea',
  bonusWillSpend: 'Se vor scădea',
  bonusRemaining: 'Vor rămâne',
  bonusProgramsUnavailable: 'Acordarea bonusurilor este temporar indisponibilă.',
  bonusUpTo: 'Până la',
  bonusContactSupport: 'Contactează asistența',
  bonusTerms: 'Condiții',
  bonusHistoryEmpty: 'Nu există încă operațiuni cu bonusuri.',
  bonusHistoryRejected: 'Respins',
  bonusHistoryReturned: 'Returnat',
  bonusHistoryExpired: 'Expirat',
  bonusHistoryLocked: 'Blocat temporar',
  bonusRewardConfirmedReport: 'Sesizare utilă confirmată',
  bonusRewardTranslationIssue: 'Problemă de traducere confirmată',
  bonusRewardBugReport: 'Eroare tehnică confirmată',
  bonusRewardUiFeedback: 'Feedback de interfață confirmat',
  invalidPassword: 'Parolă greșită.',
  passwordRules:
    'Folosiți 10-32 de caractere: doar litere latine și cifre, cu cel puțin o literă mică, o literă mare și o cifră.',
  passwordRequired: 'Introduceți o parolă.',
  passwordLength: 'Folosiți 10-32 de caractere pentru parolă.',
  passwordLatinOnly: 'Folosiți doar litere latine și cifre în parolă.',
  passwordLowercase: 'Adăugați cel puțin o literă latină mică în parolă.',
  passwordUppercase: 'Adăugați cel puțin o literă latină mare în parolă.',
  passwordDigit: 'Adăugați cel puțin o cifră în parolă.',
  showPassword: 'Afișați parola',
  hidePassword: 'Ascundeți parola',
  showRecoveryKey: 'Afișați cheia de recuperare',
  hideRecoveryKey: 'Ascundeți cheia de recuperare',
  generatePassword: 'Generați parolă',
  copied: 'Copiat.',
  downloaded: 'Descărcat.',
  recoveryFileWarning:
    'Păstrați acest fișier într-un loc privat. Cheia de recuperare poate ajuta la restabilirea accesului la cont.',
  accountNotFound: 'Contul nu a fost găsit.',
  supportMessageTooManyRepeats: 'Mesajul conține prea multe caractere identice consecutive.',
  supportMessageWordTooLong: 'Un cuvânt din mesaj este prea lung.',
  supportMessageTooManyUrls: 'Mesajul conține prea multe linkuri.',
  supportMessageTooShort: 'Mesajul este prea scurt.',
  supportMessageTooLong: 'Mesajul este prea lung.',
  tooManyAttempts: 'Prea multe încercări. Așteptați puțin și încercați din nou.',
  securityHoldShort: 'Limitat temporar.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Eveniment',
  securityTime: 'Ora',
  securitySeverityInfo: 'Informație',
  securitySeverityImportant: 'Important',
  securitySeverityWarning: 'Avertisment',
  securityEventSensitiveActionAuthorized: 'Acțiune protejată confirmată',
  securityEventSensitiveActionPasswordFailed: 'Confirmarea parolei a eșuat',
  securityEventSensitiveActionBlockedHold: 'Acțiune blocată de protecția temporară',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Temporar indisponibil.',
  bonusPartialLoadError:
    'Unele date despre bonusuri nu au putut fi încărcate. Secțiunile disponibile rămân utilizabile.',
  bonusRetry: 'Încearcă din nou',
  bonusBalanceUnavailable: 'Soldul este temporar indisponibil.',
  bonusRedeemOptionsUnavailable: 'Opțiunile de bonus sunt temporar indisponibile.',
  bonusRulesUnavailable: 'Programele pentru obținerea bonusurilor sunt temporar indisponibile.',
  bonusHistoryUnavailable: 'Istoricul bonusurilor este temporar indisponibil.',
  bonusSubscriptionUnavailable: 'Starea abonamentului este temporar indisponibilă.',
  bonusRedeemStateUnavailable:
    'Utilizarea bonusurilor nu poate fi verificată acum. Încearcă din nou.',
  bonusOptionUnavailable: 'Această opțiune este temporar indisponibilă.',
  bonusRedeemInsufficient:
    'Nu sunt suficiente bonusuri disponibile. Soldul s-ar putea să se fi schimbat.',
  bonusRedeemOptionUnavailable:
    'Această opțiune de bonus nu mai este disponibilă. Reîmprospătează și alege din nou.',
  bonusRedeemUnknownOutcome:
    'Rezultatul nu a putut fi confirmat. Reîncearcă în siguranță; aceeași cerere nu va fi taxată de două ori.',
  bonusRedeemFailed: 'Bonusurile nu au putut fi utilizate. Încearcă din nou.',
  bonusShowMore: 'Arată mai mult',
  bonusHistoryLoadMoreError: 'Nu s-a putut încărca mai mult istoric. Încearcă din nou.',
  bonusBenefitsTitle: 'Abonamentul include',
  bonusBenefitMorePrivateSaves: 'Mai multe texte salvate privat',
  bonusBenefitLongerHistory: 'Istoric privat de lectură mai lung',
  bonusBenefitAdvancedReading: 'Setări avansate de lectură',
  bonusBenefitThemes: 'Teme de lectură suplimentare',
  bonusBenefitExport: 'Exportul textelor salvate',
  bonusBenefitEarlyAccess: 'Acces timpuriu la modurile de lectură',
  bonusBenefitPrioritySupport: 'Asistență prioritară',
  bonusRewardSafetyReport: 'Raport de siguranță confirmat',
  bonusRuleSafetyReports: 'Un raport de siguranță confirmat poate primi bonusuri după verificare.',
  bonusRewardSupportFeedback: 'Feedback confirmat despre asistență',
  bonusRuleSupportFeedback:
    'Feedbackul util despre asistență poate primi bonusuri după verificare.',
};
const RU: AccountMessages = {
  title: 'Аккаунт',
  eyebrow: 'Внутренний аккаунт',
  headline: 'Аккаунт',
  intro: 'Управляйте аккаунтом.',
  home: 'Аккаунт',
  login: 'Войти',
  register: 'Создать аккаунт',
  recover: 'Восстановить аккаунт',
  texts: 'Мои тексты',
  saved: 'Сохранённые',
  recent: 'Недавно прочитанные',
  reading: 'Чтение',
  translations: 'Переводы',
  bonus: 'Бонусы',
  support: 'Поддержка',
  security: 'Безопасность',
  settings: 'Настройки',
  accountNotProfile:
    'Аккаунт нужен для контроля, а не для публичности. Псевдоним не показывается как имя автора.',
  loading: 'Загрузка…',
  empty: 'Пока нечего показать.',
  error: 'Что-то пошло не так. Попробуйте ещё раз.',
  success: 'Сохранено.',
  submit: 'Отправить',
  save: 'Сохранить',
  cancel: 'Отмена',
  delete: 'Удалить',
  close: 'Закрыть',
  refresh: 'Обновить',
  password: 'Пароль',
  currentPassword: 'Текущий пароль',
  newPassword: 'Новый пароль',
  pseudonym: 'Псевдоним',
  emailOptional: 'Email, необязательно',
  recoveryKey: 'Ключ восстановления',
  copy: 'Скопировать',
  download: 'Скачать',
  status: 'Статус',
  language: 'Язык',
  created: 'Создано',
  updated: 'Обновлено',
  published: 'Опубликовано',
  open: 'Открыть',
  manage: 'Управлять',
  remove: 'Убрать',
  clear: 'Очистить',
  enabled: 'Включено',
  disabled: 'Выключено',
  interfaceLanguage: 'Язык интерфейса',
  theme: 'Тема',
  notifications: 'Уведомления',
  privacy: 'Приватность',
  data: 'Данные',
  savedTextsIntro:
    'Сохранённые тексты приватны. Это не публичные лайки и они не раскрывают вашу личность.',
  recentIntro: 'Недавно прочитанные приватны, их можно очистить или отключить.',
  readingIntro: 'Выберите языки чтения и мягкий режим. Это отдельно от языка интерфейса.',
  translationsIntro:
    'Управляйте согласием и статусами переводов ваших текстов. Переводы не создаются сразу.',
  supportIntro: 'Создавайте и отслеживайте приватные обращения в поддержку.',
  securityIntro: 'Управляйте сессиями, восстановлением, email и важными действиями аккаунта.',
  settingsIntro: 'Общие настройки аккаунта: язык, тема, уведомления, приватность и данные.',
  loginIntro: 'Введите данные для входа.',
  registerIntro: 'Выберите данные доступа.',
  recoverIntro: 'Восстановите доступ.',
  textsIntro: 'Тексты, привязанные к аккаунту, остаются анонимными для читателей.',
  noPublicProfile: 'Нет публичного профиля, подписчиков, аватара или страницы автора.',
  handleTaken: 'Этот псевдоним недоступен.',
  pseudonymSuggestions: 'Выберите один из вариантов:',
  pseudonymRules: '6-20 символов: буквы, цифры, точка, дефис или подчёркивание.',
  pseudonymLength: 'Используйте 6-20 символов.',
  pseudonymFormat: 'Используйте буквы, цифры, точку, дефис или подчёркивание.',
  pseudonymReserved: 'Выберите другой псевдоним.',
  pseudonymRequired: 'Введите псевдоним.',
  securityHold: 'Это действие временно защищено после нового устройства или сети.',
  logout: 'Выйти',
  logoutAll: 'Выйти везде',
  sessions: 'Сессии',
  devices: 'Устройства',
  createRecoveryKey: 'Создать ключ восстановления',
  recoveryKeyWarning:
    'Без ключа восстановления вы не сможете восстановить этот аккаунт, если забудете пароль.',
  recoveryKeyRotatedAfterRecovery: 'После восстановления будет выдан новый ключ восстановления.',
  replaceRecoveryKey: 'Заменить ключ восстановления',
  changeEmail: 'Изменить email',
  removeEmail: 'Удалить email',
  exportData: 'Запросить экспорт данных',
  deleteAccount: 'Запросить удаление аккаунта',
  settingsTabLanguage: 'Язык интерфейса',
  settingsTabTheme: 'Тема',
  settingsTabDeletion: 'Удаление аккаунта',
  autoDeleteAccount:
    'Удалить аккаунт через 30 дней, если в течение этого времени вы не входите в аккаунт.',
  autoDeleteCheckboxRequired: 'Поставьте галочку, чтобы включить удаление через 30 дней.',
  saveAutoDelete: 'Сохранить настройку удаления',
  confirmChange: 'Подтвердить изменение',
  deleteNow: 'Удалить сейчас',
  deleteNowIntro: 'Это сразу удалит внутренний аккаунт. Действие нельзя отменить.',
  confirmDeleteAccount: 'Подтвердить удаление аккаунта',
  pseudonymConfirmation: 'Введите свой псевдоним',
  deletionSettingsSaved: 'Настройка удаления сохранена.',
  accountDeleted: 'Аккаунт удалён.',
  accountDeleteConfirmationMismatch: 'Подтверждение псевдонима не совпадает.',
  addByLink: 'Добавить текст по ссылке',
  claimText: 'Сохранить текст в аккаунте',
  timingTooFast: 'Подождите несколько секунд и повторите попытку.',
  managementLink: 'Ссылка управления',
  supportCategory: 'Категория',
  message: 'Сообщение',
  ticket: 'Обращение',
  newTicket: 'Новое обращение',
  supportTabNew: 'Новое обращение',
  supportTabTickets: 'Мои обращения',
  supportSubject: 'Тема',
  sendSupportRequest: 'Отправить обращение',
  supportAccountReplyHint: 'Ответ появится в вашем аккаунте. Email не нужен.',
  supportReply: 'Ответ',
  sendSupportReply: 'Отправить ответ',
  closeTicket: 'Закрыть обращение',
  supportTicketClosed: 'Это обращение закрыто.',
  supportMessageClosedFromAccount: 'Обращение в поддержку было закрыто из аккаунта.',
  supportUnreadMessages: '{count} непрочитанных сообщений поддержки',
  supportLiveActive: 'Обновление в реальном времени включено',
  supportLiveReconnecting: 'Восстанавливаем обновление в реальном времени…',
  supportMessageClosedBySupport: 'Обращение закрыто поддержкой. Причина: {reason}',
  supportMessageStatusChanged: 'Статус обращения изменён на «{status}».',
  supportCloseReasonClosedBySupport: 'закрыто поддержкой',
  supportCloseReasonClosedByAccount: 'закрыто из аккаунта',
  supportActorYou: 'Вы',
  supportActorSupport: 'Поддержка',
  supportActorSystem: 'Система',
  supportStatusNew: 'Новое',
  supportStatusOpen: 'Открыто',
  supportStatusWaitingSupport: 'Ожидает поддержки',
  supportStatusWaitingUser: 'Ожидает вашего ответа',
  supportStatusResolved: 'Решено',
  supportStatusClosed: 'Закрыто',
  supportCategoryAccount: 'Проблема с аккаунтом',
  supportCategoryText: 'Проблема с текстом',
  supportCategoryTranslation: 'Перевод',
  supportCategoryAccess: 'Доступ или ключ восстановления',
  supportCategorySecurity: 'Безопасность',
  supportCategoryBug: 'Ошибка',
  supportCategoryInterface: 'Отзыв об интерфейсе',
  supportCategoryData: 'Персональные данные',
  supportCategoryOther: 'Другое',
  startRecovery: 'Начать восстановление',
  completeRecovery: 'Завершить восстановление',
  savedPrivate: 'Только вы видите этот список.',
  recentPrivate: 'История чтения не показывается авторам или другим пользователям.',
  translationsPrivate: 'Управление переводами не раскрывает авторство.',
  settingsSaved: 'Настройки сохранены.',
  bonusIntro:
    'Используйте бонусы внутри Quaom. Они начисляются только за подтверждённую помощь и не выводятся.',
  bonusBalance: 'Баланс',
  bonusAvailable: 'Доступно',
  bonusPending: 'На проверке',
  bonusLocked: 'Заблокировано',
  bonusHistory: 'История',
  bonusRules: 'Правила',
  bonusHowToGet: 'Как получить бонусы',
  bonusSpend: 'Потратить бонусы',
  bonusSubscription: 'Подписка',
  bonusSubscriptionActive: 'Подписка активна',
  bonusSubscriptionInactive: 'Активной подписки нет',
  bonusRedeemOptions: 'Использовать бонусы',
  bonusRedeem: 'Использовать бонусы',
  bonusNoCashOut: 'Бонусы нельзя вывести или передать.',
  bonusNoTextRewards: 'Тексты, просмотры, сохранения и эмоции не дают бонусы.',
  bonusHelpOnly:
    'Бонусы возможны только за подтверждённую помощь: жалобы, переводы, ошибки или отзыв по интерфейсу.',
  bonusRuleConfirmedReports: 'Подтверждённые полезные жалобы могут дать бонусы.',
  bonusRuleTranslationIssues: 'Подтверждённые проблемы перевода или языка могут дать бонусы.',
  bonusRuleBugReports: 'Подтверждённые технические ошибки могут дать бонусы.',
  bonusRuleUiFeedback: 'Полезный отзыв по интерфейсу может дать бонусы после проверки.',
  bonusCannotWithdraw: 'Бонусы не являются деньгами и не выплачиваются.',
  bonusAccountOnly: 'Бонусы существуют только внутри приватного аккаунта.',
  bonusRedeemSecurityHold: 'Трата бонусов временно защищена после нового устройства или сети.',
  bonusSubscriptionExpires: 'Истекает',
  bonusCredits: 'бонусов',
  bonusPlan7Days: '7 дней',
  bonusPlan30Days: '30 дней',
  bonusSpent: 'Потрачено',
  bonusEarned: 'Получено',
  bonusPendingReview: 'Ожидает проверки',
  bonusRulesIntro:
    'Правила бонусов защищают Quaom от превращения личных текстов в оплачиваемую сцену.',
  bonusActivate: 'Активировать',
  bonusNeedMore: 'Нужно ещё',
  bonusConfirmActivation: 'Подтвердить активацию',
  bonusWillSpend: 'Будет списано',
  bonusRemaining: 'Останется',
  bonusProgramsUnavailable: 'Начисление бонусов временно недоступно.',
  bonusUpTo: 'До',
  bonusContactSupport: 'Обратиться в поддержку',
  bonusTerms: 'Условия',
  bonusHistoryEmpty: 'Операций с бонусами пока нет.',
  bonusHistoryRejected: 'Отклонено',
  bonusHistoryReturned: 'Возвращено',
  bonusHistoryExpired: 'Истекло',
  bonusHistoryLocked: 'Временно заблокировано',
  bonusRewardConfirmedReport: 'Подтверждённая полезная жалоба',
  bonusRewardTranslationIssue: 'Подтверждённая проблема перевода',
  bonusRewardBugReport: 'Подтверждённая техническая ошибка',
  bonusRewardUiFeedback: 'Подтверждённый отзыв об интерфейсе',
  invalidPassword: 'Неверный пароль.',
  passwordRules:
    'Используйте 10–32 символа: только латинские буквы и цифры, минимум одна строчная буква, одна заглавная буква и одна цифра.',
  passwordRequired: 'Введите пароль.',
  passwordLength: 'Пароль должен быть от 10 до 32 символов.',
  passwordLatinOnly: 'В пароле можно использовать только латинские буквы и цифры.',
  passwordLowercase: 'Добавьте в пароль минимум одну строчную латинскую букву.',
  passwordUppercase: 'Добавьте в пароль минимум одну заглавную латинскую букву.',
  passwordDigit: 'Добавьте в пароль минимум одну цифру.',
  showPassword: 'Показать пароль',
  hidePassword: 'Скрыть пароль',
  showRecoveryKey: 'Показать ключ восстановления',
  hideRecoveryKey: 'Скрыть ключ восстановления',
  generatePassword: 'Сгенерировать пароль',
  copied: 'Скопировано.',
  downloaded: 'Скачано.',
  recoveryFileWarning:
    'Храните этот файл в приватном месте. Ключ восстановления может помочь вернуть доступ к аккаунту.',
  accountNotFound: 'Аккаунт не найден.',
  supportMessageTooManyRepeats: 'Сообщение содержит слишком много одинаковых символов подряд.',
  supportMessageWordTooLong: 'Одно из слов в сообщении слишком длинное.',
  supportMessageTooManyUrls: 'Сообщение содержит слишком много ссылок.',
  supportMessageTooShort: 'Сообщение слишком короткое.',
  supportMessageTooLong: 'Сообщение слишком длинное.',
  tooManyAttempts: 'Слишком много попыток. Подождите немного и повторите.',
  securityHoldShort: 'Временно ограничено.',
  securityTabAuthentication: 'Аутентификация',
  securityTabSessions: 'Сессии',
  securityTabActivity: 'Активность',
  authentication: 'Аутентификация',
  changePassword: 'Изменить пароль',
  changePasswordIntro: 'Обновите пароль для входа во внутренний аккаунт.',
  savePassword: 'Сохранить пароль',
  passwordChanged: 'Пароль сохранён.',
  recoveryKeyCreateIntro: 'Создайте ключ восстановления, если не сохранили его при регистрации.',
  recoveryKeyReplaceIntro:
    'Активный ключ восстановления уже существует. Он не показывается повторно; его можно заменить новым.',
  recoveryKeyAlreadyCreated: 'Активный ключ восстановления уже существует.',
  showRecoveryKeyForm: 'Продолжить',
  sessionCurrent: 'Текущая сессия',
  sessionOther: 'Сессия',
  sessionExpiresAt: 'Истекает',
  revokeSession: 'Завершить сессию',
  sessionRevoked: 'Сессия завершена.',
  activity: 'Активность',
  securityActivityIntro: 'Недавние действия безопасности для этого внутреннего аккаунта.',
  securityEvent: 'Событие',
  securityTime: 'Время',
  securitySeverityInfo: 'Информация',
  securitySeverityImportant: 'Важное',
  securitySeverityWarning: 'Предупреждение',
  securityEventSensitiveActionAuthorized: 'Защищённое действие подтверждено',
  securityEventSensitiveActionPasswordFailed: 'Не удалось подтвердить пароль',
  securityEventSensitiveActionBlockedHold: 'Действие заблокировано временной защитой',
  noActivity: 'Действий безопасности пока нет.',
  securityEventAccountLoginSucceeded: 'Вход в аккаунт',
  securityEventAccountLoginFailed: 'Неудачная попытка входа',
  securityEventAccountLogout: 'Выход из аккаунта',
  securityEventAccountLogoutAll: 'Завершены все сессии',
  securityEventAccountSessionRevoked: 'Сессия завершена',
  securityEventAccountPasswordChanged: 'Пароль изменён',
  securityEventRecoveryKeyCreated: 'Ключ восстановления создан',
  securityEventRecoveryKeyReplaced: 'Ключ восстановления заменён',
  securityEventRecoveredByKey: 'Аккаунт восстановлен по ключу',
  securityEventAutoDeleteUpdated: 'Настройка автоудаления обновлена',
  securityEventAccountDeleted: 'Аккаунт удалён',
  securityEventGeneric: 'Действие безопасности',
  featureDisabled: 'Временно недоступно.',
  bonusPartialLoadError:
    'Не удалось загрузить часть данных о бонусах. Доступные разделы продолжают работать.',
  bonusRetry: 'Попробовать снова',
  bonusBalanceUnavailable: 'Баланс временно недоступен.',
  bonusRedeemOptionsUnavailable: 'Варианты использования бонусов временно недоступны.',
  bonusRulesUnavailable: 'Программы получения бонусов временно недоступны.',
  bonusHistoryUnavailable: 'История бонусов временно недоступна.',
  bonusSubscriptionUnavailable: 'Статус подписки временно недоступен.',
  bonusRedeemStateUnavailable:
    'Сейчас нельзя проверить возможность списания бонусов. Попробуйте снова.',
  bonusOptionUnavailable: 'Этот вариант временно недоступен.',
  bonusRedeemInsufficient: 'Недостаточно доступных бонусов. Баланс мог измениться.',
  bonusRedeemOptionUnavailable:
    'Этот вариант использования бонусов больше недоступен. Обновите страницу и выберите снова.',
  bonusRedeemUnknownOutcome:
    'Не удалось подтвердить результат. Повторите безопасно: один и тот же запрос не будет списан дважды.',
  bonusRedeemFailed: 'Не удалось использовать бонусы. Попробуйте снова.',
  bonusShowMore: 'Показать ещё',
  bonusHistoryLoadMoreError: 'Не удалось загрузить продолжение истории. Попробуйте снова.',
  bonusBenefitsTitle: 'В подписку входит',
  bonusBenefitMorePrivateSaves: 'Больше приватно сохранённых текстов',
  bonusBenefitLongerHistory: 'Более длинная приватная история чтения',
  bonusBenefitAdvancedReading: 'Расширенные настройки чтения',
  bonusBenefitThemes: 'Дополнительные темы чтения',
  bonusBenefitExport: 'Экспорт сохранённых текстов',
  bonusBenefitEarlyAccess: 'Ранний доступ к режимам чтения',
  bonusBenefitPrioritySupport: 'Приоритетная поддержка',
  bonusRewardSafetyReport: 'Подтверждённое сообщение о безопасности',
  bonusRuleSafetyReports:
    'Подтверждённое сообщение о безопасности может принести бонусы после проверки.',
  bonusRewardSupportFeedback: 'Подтверждённый отзыв о поддержке',
  bonusRuleSupportFeedback: 'Полезный отзыв о поддержке может принести бонусы после проверки.',
};
const UK: AccountMessages = {
  title: 'Акаунт',
  eyebrow: 'Внутрішній акаунт',
  headline: 'Акаунт',
  intro: 'Керуйте акаунтом.',
  home: 'Акаунт',
  login: 'Увійти',
  register: 'Створити акаунт',
  recover: 'Відновити акаунт',
  texts: 'Мої тексти',
  saved: 'Збережені',
  recent: 'Нещодавно прочитані',
  reading: 'Читання',
  translations: 'Переклади',
  bonus: 'Бонуси',
  support: 'Підтримка',
  security: 'Безпека',
  settings: 'Налаштування',
  accountNotProfile:
    'Акаунт потрібен для контролю, не для публічності. Псевдонім не показується як ім’я автора.',
  loading: 'Завантаження…',
  empty: 'Поки нічого показати.',
  error: 'Щось пішло не так. Спробуйте ще раз.',
  success: 'Збережено.',
  submit: 'Надіслати',
  save: 'Зберегти',
  cancel: 'Скасувати',
  delete: 'Видалити',
  close: 'Закрити',
  refresh: 'Оновити',
  password: 'Пароль',
  currentPassword: 'Поточний пароль',
  newPassword: 'Новий пароль',
  pseudonym: 'Псевдонім',
  emailOptional: 'Email, необов’язково',
  recoveryKey: 'Ключ відновлення',
  copy: 'Скопіювати',
  download: 'Завантажити',
  status: 'Статус',
  language: 'Мова',
  created: 'Створено',
  updated: 'Оновлено',
  published: 'Опубліковано',
  open: 'Відкрити',
  manage: 'Керувати',
  remove: 'Прибрати',
  clear: 'Очистити',
  enabled: 'Увімкнено',
  disabled: 'Вимкнено',
  interfaceLanguage: 'Мова інтерфейсу',
  theme: 'Тема',
  notifications: 'Сповіщення',
  privacy: 'Приватність',
  data: 'Дані',
  savedTextsIntro:
    'Збережені тексти приватні. Це не публічні лайки і вони не розкривають вашу особу.',
  recentIntro: 'Нещодавно прочитані приватні, їх можна очистити або вимкнути.',
  readingIntro: 'Оберіть мови читання та м’який режим. Це окремо від мови інтерфейсу.',
  translationsIntro:
    'Керуйте згодою та статусами перекладів ваших текстів. Переклади не створюються одразу.',
  supportIntro: 'Створюйте й відстежуйте приватні звернення в підтримку.',
  securityIntro: 'Керуйте сесіями, відновленням, email і важливими діями акаунта.',
  settingsIntro: 'Загальні налаштування: мова, тема, сповіщення, приватність і дані.',
  loginIntro: 'Введіть дані доступу.',
  registerIntro: 'Оберіть дані доступу.',
  recoverIntro: 'Відновіть доступ.',
  textsIntro: 'Тексти, прив’язані до акаунта, залишаються анонімними для читачів.',
  noPublicProfile: 'Немає публічного профілю, підписників, аватара чи сторінки автора.',
  handleTaken: 'Цей псевдонім недоступний.',
  pseudonymSuggestions: 'Виберіть один із варіантів:',
  pseudonymRules: '6-20 символів: літери, цифри, крапка, дефіс або підкреслення.',
  pseudonymLength: 'Використайте 6-20 символів.',
  pseudonymFormat: 'Використайте літери, цифри, крапку, дефіс або підкреслення.',
  pseudonymReserved: 'Виберіть інший псевдонім.',
  pseudonymRequired: 'Введіть псевдонім.',
  securityHold: 'Ця дія тимчасово захищена після нового пристрою або мережі.',
  logout: 'Вийти',
  logoutAll: 'Вийти всюди',
  sessions: 'Сесії',
  devices: 'Пристрої',
  createRecoveryKey: 'Створити ключ відновлення',
  recoveryKeyWarning:
    'Без ключа відновлення ви не зможете відновити цей акаунт, якщо забудете пароль.',
  recoveryKeyRotatedAfterRecovery: 'Після відновлення буде видано новий ключ відновлення.',
  replaceRecoveryKey: 'Замінити ключ відновлення',
  changeEmail: 'Змінити email',
  removeEmail: 'Видалити email',
  exportData: 'Запросити експорт даних',
  deleteAccount: 'Запросити видалення акаунта',
  settingsTabLanguage: 'Мова інтерфейсу',
  settingsTabTheme: 'Тема',
  settingsTabDeletion: 'Видалення акаунта',
  autoDeleteAccount:
    'Видалити акаунт через 30 днів, якщо протягом цього часу ви не входитимете в акаунт.',
  autoDeleteCheckboxRequired: 'Поставте галочку, щоб увімкнути видалення через 30 днів.',
  saveAutoDelete: 'Зберегти налаштування видалення',
  confirmChange: 'Підтвердити зміну',
  deleteNow: 'Видалити зараз',
  deleteNowIntro: 'Це негайно видалить внутрішній акаунт. Дію не можна скасувати.',
  confirmDeleteAccount: 'Підтвердити видалення акаунта',
  pseudonymConfirmation: 'Введіть свій псевдонім',
  deletionSettingsSaved: 'Налаштування видалення збережено.',
  accountDeleted: 'Акаунт видалено.',
  accountDeleteConfirmationMismatch: 'Підтвердження псевдоніма не збігається.',
  addByLink: 'Додати текст за посиланням',
  claimText: 'Зберегти текст в акаунті',
  timingTooFast: 'Зачекайте кілька секунд і повторіть.',
  managementLink: 'Посилання керування',
  supportCategory: 'Категорія',
  message: 'Повідомлення',
  ticket: 'Звернення',
  newTicket: 'Нове звернення',
  supportTabNew: 'Нове звернення',
  supportTabTickets: 'Мої звернення',
  supportSubject: 'Тема',
  sendSupportRequest: 'Надіслати звернення',
  supportAccountReplyHint: 'Відповідь з’явиться у вашому акаунті. Email не потрібен.',
  supportReply: 'Відповідь',
  sendSupportReply: 'Надіслати відповідь',
  closeTicket: 'Закрити звернення',
  supportTicketClosed: 'Це звернення закрито.',
  supportMessageClosedFromAccount: 'Звернення до підтримки було закрито з акаунта.',
  supportUnreadMessages: '{count} непрочитаних повідомлень підтримки',
  supportLiveActive: 'Оновлення в реальному часі ввімкнено',
  supportLiveReconnecting: 'Відновлюємо оновлення в реальному часі…',
  supportMessageClosedBySupport: 'Звернення закрито підтримкою. Причина: {reason}',
  supportMessageStatusChanged: 'Статус звернення змінено на «{status}».',
  supportCloseReasonClosedBySupport: 'закрито підтримкою',
  supportCloseReasonClosedByAccount: 'закрито з акаунта',
  supportActorYou: 'Ви',
  supportActorSupport: 'Підтримка',
  supportActorSystem: 'Система',
  supportStatusNew: 'Нове',
  supportStatusOpen: 'Відкрите',
  supportStatusWaitingSupport: 'Очікує підтримки',
  supportStatusWaitingUser: 'Очікує вашої відповіді',
  supportStatusResolved: 'Вирішено',
  supportStatusClosed: 'Закрито',
  supportCategoryAccount: 'Проблема з акаунтом',
  supportCategoryText: 'Проблема з текстом',
  supportCategoryTranslation: 'Переклад',
  supportCategoryAccess: 'Доступ або ключ відновлення',
  supportCategorySecurity: 'Безпека',
  supportCategoryBug: 'Помилка',
  supportCategoryInterface: 'Відгук про інтерфейс',
  supportCategoryData: 'Персональні дані',
  supportCategoryOther: 'Інше',
  startRecovery: 'Почати відновлення',
  completeRecovery: 'Завершити відновлення',
  savedPrivate: 'Тільки ви бачите цей список.',
  recentPrivate: 'Історія читання не показується авторам або іншим користувачам.',
  translationsPrivate: 'Керування перекладами не розкриває авторство.',
  settingsSaved: 'Налаштування збережено.',
  bonusIntro:
    'Використовуйте бонуси всередині Quaom. Вони нараховуються лише за підтверджену допомогу і не виводяться.',
  bonusBalance: 'Баланс',
  bonusAvailable: 'Доступно',
  bonusPending: 'На перевірці',
  bonusLocked: 'Заблоковано',
  bonusHistory: 'Історія',
  bonusRules: 'Правила',
  bonusHowToGet: 'Як отримати бонуси',
  bonusSpend: 'Витратити бонуси',
  bonusSubscription: 'Підписка',
  bonusSubscriptionActive: 'Підписка активна',
  bonusSubscriptionInactive: 'Немає активної підписки',
  bonusRedeemOptions: 'Використати бонуси',
  bonusRedeem: 'Використати бонуси',
  bonusNoCashOut: 'Бонуси не можна вивести або передати.',
  bonusNoTextRewards: 'Тексти, перегляди, збереження й емоції не дають бонусів.',
  bonusHelpOnly:
    'Бонуси можливі лише за підтверджену допомогу: скарги, переклади, помилки або відгук про інтерфейс.',
  bonusRuleConfirmedReports: 'Підтверджені корисні скарги можуть давати бонуси.',
  bonusRuleTranslationIssues: 'Підтверджені проблеми перекладу або мови можуть давати бонуси.',
  bonusRuleBugReports: 'Підтверджені технічні помилки можуть давати бонуси.',
  bonusRuleUiFeedback: 'Корисний відгук про інтерфейс може давати бонуси після перевірки.',
  bonusCannotWithdraw: 'Бонуси не є грошима і не виплачуються.',
  bonusAccountOnly: 'Бонуси існують лише всередині приватного акаунта.',
  bonusRedeemSecurityHold:
    'Витрачання бонусів тимчасово захищене після нового пристрою або мережі.',
  bonusSubscriptionExpires: 'Закінчується',
  bonusCredits: 'бонусів',
  bonusPlan7Days: '7 днів',
  bonusPlan30Days: '30 днів',
  bonusSpent: 'Витрачено',
  bonusEarned: 'Отримано',
  bonusPendingReview: 'Очікує перевірки',
  bonusRulesIntro:
    'Правила бонусів захищають Quaom від перетворення особистих текстів на оплачувану сцену.',
  bonusActivate: 'Активувати',
  bonusNeedMore: 'Потрібно ще',
  bonusConfirmActivation: 'Підтвердити активацію',
  bonusWillSpend: 'Буде списано',
  bonusRemaining: 'Залишиться',
  bonusProgramsUnavailable: 'Нарахування бонусів тимчасово недоступне.',
  bonusUpTo: 'До',
  bonusContactSupport: 'Звернутися до підтримки',
  bonusTerms: 'Умови',
  bonusHistoryEmpty: 'Операцій з бонусами поки немає.',
  bonusHistoryRejected: 'Відхилено',
  bonusHistoryReturned: 'Повернено',
  bonusHistoryExpired: 'Термін минув',
  bonusHistoryLocked: 'Тимчасово заблоковано',
  bonusRewardConfirmedReport: 'Підтверджена корисна скарга',
  bonusRewardTranslationIssue: 'Підтверджена проблема перекладу',
  bonusRewardBugReport: 'Підтверджена технічна помилка',
  bonusRewardUiFeedback: 'Підтверджений відгук про інтерфейс',
  invalidPassword: 'Неправильний пароль.',
  passwordRules:
    'Використовуйте 10–32 символи: лише латинські літери й цифри, мінімум одна мала літера, одна велика літера й одна цифра.',
  passwordRequired: 'Введіть пароль.',
  passwordLength: 'Пароль має містити 10–32 символи.',
  passwordLatinOnly: 'У паролі можна використовувати лише латинські літери й цифри.',
  passwordLowercase: 'Додайте до пароля мінімум одну малу латинську літеру.',
  passwordUppercase: 'Додайте до пароля мінімум одну велику латинську літеру.',
  passwordDigit: 'Додайте до пароля мінімум одну цифру.',
  showPassword: 'Показати пароль',
  hidePassword: 'Сховати пароль',
  showRecoveryKey: 'Показати ключ відновлення',
  hideRecoveryKey: 'Сховати ключ відновлення',
  generatePassword: 'Згенерувати пароль',
  copied: 'Скопійовано.',
  downloaded: 'Завантажено.',
  recoveryFileWarning:
    'Зберігайте цей файл у приватному місці. Ключ відновлення може допомогти повернути доступ до акаунта.',
  accountNotFound: 'Акаунт не знайдено.',
  supportMessageTooManyRepeats: 'Повідомлення містить забагато однакових символів поспіль.',
  supportMessageWordTooLong: 'Одне зі слів у повідомленні занадто довге.',
  supportMessageTooManyUrls: 'Повідомлення містить забагато посилань.',
  supportMessageTooShort: 'Повідомлення занадто коротке.',
  supportMessageTooLong: 'Повідомлення занадто довге.',
  tooManyAttempts: 'Забагато спроб. Зачекайте трохи й повторіть.',
  securityHoldShort: 'Тимчасово обмежено.',
  securityTabAuthentication: 'Автентифікація',
  securityTabSessions: 'Сесії',
  securityTabActivity: 'Активність',
  authentication: 'Автентифікація',
  changePassword: 'Змінити пароль',
  changePasswordIntro: 'Оновіть пароль для входу у внутрішній акаунт.',
  savePassword: 'Зберегти пароль',
  passwordChanged: 'Пароль збережено.',
  recoveryKeyCreateIntro: 'Створіть ключ відновлення, якщо не зберегли його під час реєстрації.',
  recoveryKeyReplaceIntro:
    'Активний ключ відновлення вже існує. Він не показується повторно; його можна замінити новим.',
  recoveryKeyAlreadyCreated: 'Активний ключ відновлення вже існує.',
  showRecoveryKeyForm: 'Продовжити',
  sessionCurrent: 'Поточна сесія',
  sessionOther: 'Сесія',
  sessionExpiresAt: 'Діє до',
  revokeSession: 'Завершити сесію',
  sessionRevoked: 'Сесію завершено.',
  activity: 'Активність',
  securityActivityIntro: 'Останні дії безпеки для цього внутрішнього акаунта.',
  securityEvent: 'Подія',
  securityTime: 'Час',
  securitySeverityInfo: 'Інформація',
  securitySeverityImportant: 'Важлива дія',
  securitySeverityWarning: 'Увага',
  securityEventSensitiveActionAuthorized: 'Захищену дію підтверджено',
  securityEventSensitiveActionPasswordFailed: 'Не вдалося підтвердити пароль',
  securityEventSensitiveActionBlockedHold: 'Дію заблоковано тимчасовим захистом',
  noActivity: 'Дій безпеки ще немає.',
  securityEventAccountLoginSucceeded: 'Вхід в акаунт',
  securityEventAccountLoginFailed: 'Невдала спроба входу',
  securityEventAccountLogout: 'Вихід з акаунта',
  securityEventAccountLogoutAll: 'Завершено всі сесії',
  securityEventAccountSessionRevoked: 'Сесію завершено',
  securityEventAccountPasswordChanged: 'Пароль змінено',
  securityEventRecoveryKeyCreated: 'Ключ відновлення створено',
  securityEventRecoveryKeyReplaced: 'Ключ відновлення замінено',
  securityEventRecoveredByKey: 'Акаунт відновлено за ключем',
  securityEventAutoDeleteUpdated: 'Налаштування автовидалення оновлено',
  securityEventAccountDeleted: 'Акаунт видалено',
  securityEventGeneric: 'Дія безпеки',
  featureDisabled: 'Тимчасово недоступно.',
  bonusPartialLoadError:
    'Не вдалося завантажити частину даних про бонуси. Доступні розділи продовжують працювати.',
  bonusRetry: 'Спробувати ще раз',
  bonusBalanceUnavailable: 'Баланс тимчасово недоступний.',
  bonusRedeemOptionsUnavailable: 'Варіанти використання бонусів тимчасово недоступні.',
  bonusRulesUnavailable: 'Програми отримання бонусів тимчасово недоступні.',
  bonusHistoryUnavailable: 'Історія бонусів тимчасово недоступна.',
  bonusSubscriptionUnavailable: 'Статус підписки тимчасово недоступний.',
  bonusRedeemStateUnavailable:
    'Зараз неможливо перевірити можливість списання бонусів. Спробуйте ще раз.',
  bonusOptionUnavailable: 'Цей варіант тимчасово недоступний.',
  bonusRedeemInsufficient: 'Недостатньо доступних бонусів. Баланс міг змінитися.',
  bonusRedeemOptionUnavailable:
    'Цей варіант використання бонусів більше недоступний. Оновіть сторінку та виберіть знову.',
  bonusRedeemUnknownOutcome:
    'Не вдалося підтвердити результат. Повторіть безпечно: той самий запит не спишеться двічі.',
  bonusRedeemFailed: 'Не вдалося використати бонуси. Спробуйте ще раз.',
  bonusShowMore: 'Показати ще',
  bonusHistoryLoadMoreError: 'Не вдалося завантажити продовження історії. Спробуйте ще раз.',
  bonusBenefitsTitle: 'До підписки входить',
  bonusBenefitMorePrivateSaves: 'Більше приватно збережених текстів',
  bonusBenefitLongerHistory: 'Довша приватна історія читання',
  bonusBenefitAdvancedReading: 'Розширені налаштування читання',
  bonusBenefitThemes: 'Додаткові теми читання',
  bonusBenefitExport: 'Експорт збережених текстів',
  bonusBenefitEarlyAccess: 'Ранній доступ до режимів читання',
  bonusBenefitPrioritySupport: 'Пріоритетна підтримка',
  bonusRewardSafetyReport: 'Підтверджене повідомлення про безпеку',
  bonusRuleSafetyReports:
    'Підтверджене повідомлення про безпеку може принести бонуси після перевірки.',
  bonusRewardSupportFeedback: 'Підтверджений відгук про підтримку',
  bonusRuleSupportFeedback: 'Корисний відгук про підтримку може принести бонуси після перевірки.',
};
const TR: AccountMessages = {
  title: 'Hesap',
  eyebrow: 'Özel hesap',
  headline: 'Hesap',
  intro: 'Hesabını yönet.',
  home: 'Hesap',
  login: 'Giriş yap',
  register: 'Hesap oluştur',
  recover: 'Hesabı kurtar',
  texts: 'Metinlerim',
  saved: 'Kaydedilenler',
  recent: 'Son okunanlar',
  reading: 'Okuma',
  translations: 'Çeviriler',
  bonus: 'Bonuslar',
  support: 'Destek',
  security: 'Güvenlik',
  settings: 'Ayarlar',
  accountNotProfile:
    'Hesap kontrol içindir, görünürlük için değil. Takma ad yazar adı olarak gösterilmez.',
  loading: 'Yükleniyor…',
  empty: 'Henüz gösterilecek bir şey yok.',
  error: 'Bir şey yanlış gitti. Tekrar deneyin.',
  success: 'Kaydedildi.',
  submit: 'Gönder',
  save: 'Kaydet',
  cancel: 'İptal',
  delete: 'Sil',
  close: 'Kapat',
  refresh: 'Yenile',
  password: 'Parola',
  currentPassword: 'Mevcut parola',
  newPassword: 'Yeni parola',
  pseudonym: 'Takma ad',
  emailOptional: 'Email, isteğe bağlı',
  recoveryKey: 'Kurtarma anahtarı',
  copy: 'Kopyala',
  download: 'İndir',
  status: 'Durum',
  language: 'Dil',
  created: 'Oluşturuldu',
  updated: 'Güncellendi',
  published: 'Yayınlandı',
  open: 'Aç',
  manage: 'Yönet',
  remove: 'Kaldır',
  clear: 'Temizle',
  enabled: 'Etkin',
  disabled: 'Devre dışı',
  interfaceLanguage: 'Arayüz dili',
  theme: 'Tema',
  notifications: 'Bildirimler',
  privacy: 'Gizlilik',
  data: 'Veriler',
  savedTextsIntro:
    'Kaydedilen metinler özeldir. Herkese açık beğeni değildir ve kimliğinizi göstermez.',
  recentIntro: 'Son okunanlar özeldir, temizlenebilir ve kapatılabilir.',
  readingIntro: 'Okuma dillerini ve yumuşak modu seçin. Bunlar arayüz dilinden ayrıdır.',
  translationsIntro:
    'Metinlerinizin çeviri onayını ve durumlarını yönetin. Çeviriler hemen oluşturulmaz.',
  supportIntro: 'Özel destek talepleri oluşturun ve takip edin.',
  securityIntro: 'Oturumları, kurtarmayı, emaili ve hassas hesap işlemlerini yönetin.',
  settingsIntro: 'Genel ayarlar: dil, tema, bildirimler, gizlilik ve veriler.',
  loginIntro: 'Erişim bilgilerini gir.',
  registerIntro: 'Erişim bilgilerini seç.',
  recoverIntro: 'Erişimi geri yükle.',
  textsIntro: 'Hesabınıza bağlı metinler okuyucular için anonim kalır.',
  noPublicProfile: 'Herkese açık profil, takipçi, avatar veya yazar sayfası yok.',
  handleTaken: 'Bu takma ad kullanılamıyor.',
  pseudonymSuggestions: 'Bu seçeneklerden birini seçin:',
  pseudonymRules: '6-20 karakter: harf, rakam, nokta, tire veya alt çizgi.',
  pseudonymLength: '6-20 karakter kullan.',
  pseudonymFormat: 'Harf, rakam, nokta, tire veya alt çizgi kullan.',
  pseudonymReserved: 'Başka bir takma ad seç.',
  pseudonymRequired: 'Bir takma ad gir.',
  securityHold: 'Bu işlem yeni cihaz veya ağdan sonra geçici olarak korunuyor.',
  logout: 'Çıkış yap',
  logoutAll: 'Her yerden çıkış yap',
  sessions: 'Oturumlar',
  devices: 'Cihazlar',
  createRecoveryKey: 'Kurtarma anahtarı oluştur',
  recoveryKeyWarning: 'Kurtarma anahtarı olmadan parolayı unutursanız bu hesabı kurtaramazsınız.',
  recoveryKeyRotatedAfterRecovery: 'Kurtarma sonrasında yeni bir kurtarma anahtarı verilecektir.',
  replaceRecoveryKey: 'Kurtarma anahtarını değiştir',
  changeEmail: 'Emaili değiştir',
  removeEmail: 'Emaili kaldır',
  exportData: 'Veri dışa aktarımı iste',
  deleteAccount: 'Hesap silme iste',
  settingsTabLanguage: 'Interface language',
  settingsTabTheme: 'Theme',
  settingsTabDeletion: 'Account deletion',
  autoDeleteAccount: 'Delete the account after 30 days if you do not sign in during that time.',
  autoDeleteCheckboxRequired: 'Check the box to enable deletion after 30 days.',
  saveAutoDelete: 'Save deletion setting',
  confirmChange: 'Confirm change',
  deleteNow: 'Delete now',
  deleteNowIntro: 'This deletes the internal account immediately. This action cannot be undone.',
  confirmDeleteAccount: 'Confirm account deletion',
  pseudonymConfirmation: 'Enter your pseudonym',
  deletionSettingsSaved: 'Deletion setting saved.',
  accountDeleted: 'Account deleted.',
  accountDeleteConfirmationMismatch: 'The pseudonym confirmation does not match.',
  addByLink: 'Bağlantıyla metin ekle',
  claimText: 'Metni hesaba kaydet',
  timingTooFast: 'Birkaç saniye bekleyin ve tekrar deneyin.',
  managementLink: 'Yönetim bağlantısı',
  supportCategory: 'Kategori',
  message: 'Mesaj',
  ticket: 'Talep',
  newTicket: 'Yeni talep',
  supportTabNew: 'New request',
  supportTabTickets: 'My requests',
  supportSubject: 'Subject',
  sendSupportRequest: 'Send request',
  supportAccountReplyHint: 'The answer will appear in your account. Email is not required.',
  supportReply: 'Reply',
  sendSupportReply: 'Send reply',
  closeTicket: 'Close request',
  supportTicketClosed: 'This request is closed.',
  supportMessageClosedFromAccount: 'Destek talebi hesaptan kapatıldı.',
  supportUnreadMessages: '{count} okunmamış destek mesajı',
  supportLiveActive: 'Canlı güncellemeler etkin',
  supportLiveReconnecting: 'Canlı güncellemelere yeniden bağlanılıyor…',
  supportMessageClosedBySupport: 'Destek talebi destek ekibi tarafından kapatıldı. Neden: {reason}',
  supportMessageStatusChanged: 'Destek talebinin durumu {status} olarak değiştirildi.',
  supportCloseReasonClosedBySupport: 'destek ekibi tarafından kapatıldı',
  supportCloseReasonClosedByAccount: 'hesaptan kapatıldı',
  supportActorYou: 'Siz',
  supportActorSupport: 'Destek',
  supportActorSystem: 'Sistem',
  supportStatusNew: 'Yeni',
  supportStatusOpen: 'Açık',
  supportStatusWaitingSupport: 'Destek bekleniyor',
  supportStatusWaitingUser: 'Yanıtınız bekleniyor',
  supportStatusResolved: 'Çözüldü',
  supportStatusClosed: 'Kapalı',
  supportCategoryAccount: 'Account problem',
  supportCategoryText: 'Text issue',
  supportCategoryTranslation: 'Translation',
  supportCategoryAccess: 'Access or recovery key',
  supportCategorySecurity: 'Security',
  supportCategoryBug: 'Bug',
  supportCategoryInterface: 'Interface feedback',
  supportCategoryData: 'Personal data',
  supportCategoryOther: 'Other',
  startRecovery: 'Kurtarmayı başlat',
  completeRecovery: 'Kurtarmayı tamamla',
  savedPrivate: 'Bu listeyi yalnızca siz görebilirsiniz.',
  recentPrivate: 'Okuma geçmişi yazarlara veya diğer kullanıcılara gösterilmez.',
  translationsPrivate: 'Çeviri kontrolleri yazarlığı açıklamaz.',
  settingsSaved: 'Ayarlar kaydedildi.',
  bonusIntro:
    'Bonusları Quaom içinde kullanın. Yalnızca onaylanmış yardım için kazanılır ve çekilemez.',
  bonusBalance: 'Bakiye',
  bonusAvailable: 'Kullanılabilir',
  bonusPending: 'İncelemede',
  bonusLocked: 'Kilitli',
  bonusHistory: 'Geçmiş',
  bonusRules: 'Kurallar',
  bonusHowToGet: 'Bonus nasıl kazanılır',
  bonusSpend: 'Bonus harca',
  bonusSubscription: 'Abonelik',
  bonusSubscriptionActive: 'Abonelik aktif',
  bonusSubscriptionInactive: 'Aktif abonelik yok',
  bonusRedeemOptions: 'Bonusları kullan',
  bonusRedeem: 'Bonusları kullan',
  bonusNoCashOut: 'Bonuslar çekilemez veya devredilemez.',
  bonusNoTextRewards: 'Metinler, görüntülenmeler, kaydetmeler ve duygular bonus kazandırmaz.',
  bonusHelpOnly:
    'Yalnızca raporlar, çeviriler, hatalar veya arayüz geri bildirimiyle ilgili onaylanmış yardım bonus kazandırabilir.',
  bonusRuleConfirmedReports: 'Onaylanmış yararlı raporlar bonus kazandırabilir.',
  bonusRuleTranslationIssues: 'Onaylanmış çeviri veya dil sorunları bonus kazandırabilir.',
  bonusRuleBugReports: 'Onaylanmış teknik hatalar bonus kazandırabilir.',
  bonusRuleUiFeedback: 'Yararlı arayüz geri bildirimi incelemeden sonra bonus kazandırabilir.',
  bonusCannotWithdraw: 'Bonuslar para değildir ve ödenemez.',
  bonusAccountOnly: 'Bonuslar yalnızca özel hesabınızda bulunur.',
  bonusRedeemSecurityHold: 'Yeni cihaz veya ağdan sonra bonus harcama geçici olarak korunur.',
  bonusSubscriptionExpires: 'Bitiş',
  bonusCredits: 'bonus',
  bonusPlan7Days: '7 gün',
  bonusPlan30Days: '30 gün',
  bonusSpent: 'Harcanan',
  bonusEarned: 'Kazanılan',
  bonusPendingReview: 'İnceleme bekliyor',
  bonusRulesIntro:
    'Bonus kuralları, Quaom’nun kişisel metinleri ücretli bir sahneye dönüştürmesini engeller.',
  bonusActivate: 'Etkinleştir',
  bonusNeedMore: 'Daha gerekli',
  bonusConfirmActivation: 'Etkinleştirmeyi onayla',
  bonusWillSpend: 'Harcanacak',
  bonusRemaining: 'Kalan',
  bonusProgramsUnavailable: 'Bonus verme işlemi geçici olarak kullanılamıyor.',
  bonusUpTo: 'En fazla',
  bonusContactSupport: 'Destekle iletişime geç',
  bonusTerms: 'Koşullar',
  bonusHistoryEmpty: 'Henüz bonus hareketi yok.',
  bonusHistoryRejected: 'Reddedildi',
  bonusHistoryReturned: 'İade edildi',
  bonusHistoryExpired: 'Süresi doldu',
  bonusHistoryLocked: 'Geçici olarak kilitlendi',
  bonusRewardConfirmedReport: 'Onaylanmış yararlı bildirim',
  bonusRewardTranslationIssue: 'Onaylanmış çeviri sorunu',
  bonusRewardBugReport: 'Onaylanmış teknik hata',
  bonusRewardUiFeedback: 'Onaylanmış arayüz geri bildirimi',
  invalidPassword: 'Yanlış parola.',
  passwordRules:
    '10-32 karakter kullanın: yalnızca Latin harfleri ve rakamlar; en az bir küçük harf, bir büyük harf ve bir rakam içermeli.',
  passwordRequired: 'Bir parola girin.',
  passwordLength: 'Parola 10-32 karakter olmalıdır.',
  passwordLatinOnly: 'Parolada yalnızca Latin harfleri ve rakamlar kullanın.',
  passwordLowercase: 'Parolaya en az bir küçük Latin harfi ekleyin.',
  passwordUppercase: 'Parolaya en az bir büyük Latin harfi ekleyin.',
  passwordDigit: 'Parolaya en az bir rakam ekleyin.',
  showPassword: 'Parolayı göster',
  hidePassword: 'Parolayı gizle',
  showRecoveryKey: 'Kurtarma anahtarını göster',
  hideRecoveryKey: 'Kurtarma anahtarını gizle',
  generatePassword: 'Parola oluştur',
  copied: 'Kopyalandı.',
  downloaded: 'İndirildi.',
  recoveryFileWarning:
    'Bu dosyayı özel bir yerde saklayın. Kurtarma anahtarı hesaba erişimi geri kazanmanıza yardımcı olabilir.',
  accountNotFound: 'Hesap bulunamadı.',
  supportMessageTooManyRepeats: 'Mesaj art arda çok fazla aynı karakter içeriyor.',
  supportMessageWordTooLong: 'Mesajdaki bir kelime çok uzun.',
  supportMessageTooManyUrls: 'Mesaj çok fazla bağlantı içeriyor.',
  supportMessageTooShort: 'Mesaj çok kısa.',
  supportMessageTooLong: 'Mesaj çok uzun.',
  tooManyAttempts: 'Çok fazla deneme. Biraz bekleyip tekrar deneyin.',
  securityHoldShort: 'Geçici olarak sınırlı.',
  securityTabAuthentication: 'Authentication',
  securityTabSessions: 'Sessions',
  securityTabActivity: 'Activity',
  authentication: 'Authentication',
  changePassword: 'Change password',
  changePasswordIntro: 'Update the password used to enter your private account.',
  savePassword: 'Save password',
  passwordChanged: 'Password saved.',
  recoveryKeyCreateIntro: 'Create a recovery key if you did not save one during registration.',
  recoveryKeyReplaceIntro:
    'An active recovery key already exists. It is not shown again; you can replace it with a new key.',
  recoveryKeyAlreadyCreated: 'Active recovery key already exists.',
  showRecoveryKeyForm: 'Continue',
  sessionCurrent: 'Current session',
  sessionOther: 'Session',
  sessionExpiresAt: 'Expires',
  revokeSession: 'End session',
  sessionRevoked: 'Session ended.',
  activity: 'Activity',
  securityActivityIntro: 'Recent security actions for this private account.',
  securityEvent: 'Olay',
  securityTime: 'Zaman',
  securitySeverityInfo: 'Bilgi',
  securitySeverityImportant: 'Önemli',
  securitySeverityWarning: 'Uyarı',
  securityEventSensitiveActionAuthorized: 'Korumalı işlem onaylandı',
  securityEventSensitiveActionPasswordFailed: 'Parola doğrulaması başarısız oldu',
  securityEventSensitiveActionBlockedHold: 'İşlem geçici koruma tarafından engellendi',
  noActivity: 'No security activity yet.',
  securityEventAccountLoginSucceeded: 'Account sign-in',
  securityEventAccountLoginFailed: 'Failed sign-in attempt',
  securityEventAccountLogout: 'Account sign-out',
  securityEventAccountLogoutAll: 'All sessions signed out',
  securityEventAccountSessionRevoked: 'Session ended',
  securityEventAccountPasswordChanged: 'Password changed',
  securityEventRecoveryKeyCreated: 'Recovery key created',
  securityEventRecoveryKeyReplaced: 'Recovery key replaced',
  securityEventRecoveredByKey: 'Account recovered by key',
  securityEventAutoDeleteUpdated: 'Auto-deletion setting updated',
  securityEventAccountDeleted: 'Account deleted',
  securityEventGeneric: 'Security action',
  featureDisabled: 'Geçici olarak kullanılamıyor.',
  bonusPartialLoadError:
    'Bazı bonus verileri yüklenemedi. Kullanılabilir bölümler çalışmaya devam ediyor.',
  bonusRetry: 'Tekrar dene',
  bonusBalanceUnavailable: 'Bakiye geçici olarak kullanılamıyor.',
  bonusRedeemOptionsUnavailable: 'Bonus seçenekleri geçici olarak kullanılamıyor.',
  bonusRulesUnavailable: 'Bonus kazanma programları geçici olarak kullanılamıyor.',
  bonusHistoryUnavailable: 'Bonus geçmişi geçici olarak kullanılamıyor.',
  bonusSubscriptionUnavailable: 'Abonelik durumu geçici olarak kullanılamıyor.',
  bonusRedeemStateUnavailable: 'Bonus kullanımı şu anda doğrulanamıyor. Tekrar deneyin.',
  bonusOptionUnavailable: 'Bu seçenek geçici olarak kullanılamıyor.',
  bonusRedeemInsufficient: 'Yeterli kullanılabilir bonus yok. Bakiye değişmiş olabilir.',
  bonusRedeemOptionUnavailable: 'Bu bonus seçeneği artık kullanılamıyor. Yenileyip tekrar seçin.',
  bonusRedeemUnknownOutcome:
    'Sonuç doğrulanamadı. Güvenle tekrar deneyin; aynı istek iki kez ücretlendirilmez.',
  bonusRedeemFailed: 'Bonuslar kullanılamadı. Tekrar deneyin.',
  bonusShowMore: 'Daha fazla göster',
  bonusHistoryLoadMoreError: 'Daha fazla geçmiş yüklenemedi. Tekrar deneyin.',
  bonusBenefitsTitle: 'Aboneliğe dahil',
  bonusBenefitMorePrivateSaves: 'Daha fazla özel kaydedilmiş metin',
  bonusBenefitLongerHistory: 'Daha uzun özel okuma geçmişi',
  bonusBenefitAdvancedReading: 'Gelişmiş okuma ayarları',
  bonusBenefitThemes: 'Ek okuma temaları',
  bonusBenefitExport: 'Kaydedilmiş metinleri dışa aktarma',
  bonusBenefitEarlyAccess: 'Okuma modlarına erken erişim',
  bonusBenefitPrioritySupport: 'Öncelikli destek',
  bonusRewardSafetyReport: 'Onaylanmış güvenlik bildirimi',
  bonusRuleSafetyReports:
    'Onaylanmış bir güvenlik bildirimi incelemeden sonra bonus kazandırabilir.',
  bonusRewardSupportFeedback: 'Onaylanmış destek geri bildirimi',
  bonusRuleSupportFeedback:
    'Destek hakkında yararlı geri bildirim incelemeden sonra bonus kazandırabilir.',
};

export const ACCOUNT_I18N_BUNDLE: PublicI18nBundle<AccountMessageKey> = {
  namespace: 'public.account.runtime',
  fallbackLanguage: QUAOM_DEFAULT_UI_LANGUAGE,
  requiredKeys: ACCOUNT_REQUIRED_I18N_KEYS,
  messages: {
    en: EN,
    de: DE,
    fr: FR,
    es: ES,
    it: IT,
    pt: PT,
    pl: PL,
    cs: CS,
    hu: HU,
    ro: RO,
    ru: RU,
    uk: UK,
    tr: TR,
  },
};
